import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Tooltip,
  Typography,
  Upload,
} from "antd";

import {
  CloseOutlined,
  DownOutlined,
  EyeOutlined,
  LoadingOutlined,
  PlusOutlined,
  ReloadOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import deleteImg from "../../../images/deletebutton.svg";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useClient } from "../../Context/ClientContext";
import {
  handleDecimalValues,
  handleInputFocus,
  updateListWithNewValue,
  Utils,
} from "../../../Utilities/Utils";
import { dayjs } from "../../../Utilities/dayjs";
import "../../Common/Acc_Common.css";
import "../../Common/AddPageCommon.css";
import noteContext from "../../Context/StyleContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import TextArea from "antd/es/input/TextArea";
import AddItems from "../Items/AddItems";
import PartyService from "../../Services/PartyService";
import { percentCal } from "../../Common/CAPComponents";
import { BodySkeleton } from "../../../Common/Skeleton";
import AddBankAccount from "../Banking/BankAccounts/AddBankAccountModel";
import LedgerService, {
  ILedgerAddResponse,
  ILedgerSearchByGroupNameResponse,
  LedgerStatus,
  SearchLedgerByGroupsTypes,
  TypeOfAddress,
} from "../../Services/LedgerService";
import Layout, { Content, Footer, Header } from "antd/es/layout/layout";
import VoucherServices, {
  AddressEnum,
  DiscountType,
  ITCEligibilityTypeOptions,
  ITCEligibility_Type,
  Party_Tax,
  ReconciledFilter,
  RefType,
  VoucherStatus_New,
  Voucher_Nature,
  Voucher_Type,
  addVoucherExpensesIncomeptions,
  convertToDays,
  expensesIncomeNatureOptions,
} from "../../Services/VoucherServices";
import { AddLedger } from "../Master/Ledger/AddLedger";
// import { CompanyGSTTypes } from "../../../Types";
import { CompanyGSTTypes } from "../../../Types/CommonConstants";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import {
  Discount_Policy,
  RoundOff_Type,
  SettingsSections,
  TimeUnits,
  vouchersSettings,
} from "../../Services/SettingService";
import DraftService from "../../Services/DraftService";
import DocumentPreview from "../../Common/DocumentPreview";
import { PanCardType } from "../../Services/PurchaseService";
import { useUser } from "../../../Context/UserContext";
import { getIndianStates } from "../../Services/ClientService";
import TdsTcsServices, {
  Transaction_Type,
} from "../../Services/TdsTcsServices";
import AddTcsTaxRate from "../TcsTds/Tcs/AddTcsTaxRate";
import AddTdsTaxRate from "../TcsTds/Tds/AddTdsTaxRate";
import { useTheme } from "../../Context/ThemeContext";
import { ExpenseIncomeDropdownItems } from "../SalesAndPurchase/InvoiceAndPurchaseBill/Add/SalesPurchaseAndExpensesDropdownList";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import AddSalesInvBillAndExpensesReferenceModel from "../SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvBillAndExpensesReferenceModel";
import { handleRoundoff } from "../../Common/Calculation/HandleRoundoff";
import { findVoucharCustomizationTemplete } from "../../Common/Vouchar/FindVoucharCustomizationTemplete";
import { useHotkey } from "../../Context/HotKeyContext";
import AddCostCentreModel from "./AddCostCentreModel";
import {
  ICostCentre,
  ICostCentresList,
} from "../../Services/CostCentersServices";

const AddExpensesIncome = () => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const themeData: any = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef: any = useRef(null);
  const { windowWidth } = useContext(noteContext);
  const { currentClient, companySettings } = useClient();
  const { getAllIndStates, clientSpecificRole } = useUser();
  const stateOptions: any = getAllIndStates();
  const [checkIsPartyApiCall, SetCheckIsPartyApiCall] =
    useState<boolean>(false);
  const [checkIsBankApiCall, SetCheckIsBankApiCall] = useState<boolean>(false);
  const { updateId, partyId, cloneId, draftId } = useParams();
  const { openNotification } = useContext(notificationContext);
  const [trigger, setTrigger] = useState(false);

  let splitPathInVchType: Voucher_Type;
  if (location.pathname.split("/")[4] === "expenses") {
    splitPathInVchType = Voucher_Type.Expenses;
  } else {
    splitPathInVchType = Voucher_Type.Income;
  }
  const [newLedgerAddedIndex, setNewLedgerAddedIndex] = useState<number>(0);
  const [dueOnSetting, setDueOnSetting] = useState<number>(
    convertToDays(currentClient?.duration!, TimeUnits.Day)
  );
  const [addLedgerResponse, setAddLedgerResponse] =
    useState<ILedgerAddResponse | null>(null);
  const [openCostCentreModel, setOpenCostCentreModel] = useState<{
    open: boolean;
    id: string;
  }>({
    open: false,
    id: "",
  });
  const [postCostCenterResponse, setPostCostCentreResponse] =
    useState<ICostCentresList>({
      costCentreName: "",
      expenseId: "",
      id: "",
    });
  const [costCentreAddedDetails, setCostCentreAddedDetails] = useState<{
    expenseId: string;
    expenseParentIndex: number;
    costCentreAddedIndex: number;
  }>({ expenseId: "", expenseParentIndex: 0, costCentreAddedIndex: 0 });
  const [dueOnParty, setDueOnParty] = useState<number>(0);
  const [dateFiled, setDateFiled] = useState<any>();
  const [editDate, setEditDate] = useState<any>();
  const [editDueDate, setEditDueDate] = useState<any>();
  const [balance, setBalance] = useState<number>(0);
  const [totalTcs, setTotalTcs] = useState<number>(0);
  const [totalTds, setTotalTds] = useState<number>(0);
  const [tdsOrTcs, setTdsOrTcs] = useState<number>(
    splitPathInVchType === Voucher_Type.Expenses ? 0 : 1
  );
  // const [totalgst, setTotalgst] = useState<number>(0);
  // const [totalQty, setTotalQty] = useState<number>(0);
  const [isOpenDueDate, setIsDueDate] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [itemLength, setItemLength] = useState<number>(0);
  // const [isInCash, setIsInCash] = useState<boolean>(false);
  const [itemsOption, setItemsOption] = useState<any[]>([]);
  const [deleteItemList, setDeleteItemList] = useState<any>();
  // const [invoiceTotal, setInvoiceTotal] = useState<number>(0.0);
  const [purchaseOrderRef, setPurchaseOrderRef] = useState<string | null>(null);
  const [salesInvoiceNo, setSalesInvoiceNo] = useState<string>("");
  const [editParty, setEditParty] = useState<{ id: string }>({ id: "" });
  const [selectedParty, setSelectedParty] = useState<string>("");
  const [ledgerconfirmation, setLedgerConfirmation] = useState<boolean>(false);

  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [onlyEditTimeCustomerOptions, setOnlyEditTimeCustomerOptions] =
    useState<boolean>(false);
  // const [addressList, setAddressList] = useState<any[]>([]);
  const [currentCustomerState, setCurrentCustomerState] = useState<number>(
    currentClient?.state!
  );
  const [purchasePartyState, setPurchasePartyState] = useState<number>(
    currentClient?.state!
  );

  const [updateAndNewButton, setUpdateAndNewButton] = useState<boolean>(false);
  const [saveNewLoading, setSaveNewLoading] = useState<boolean>(false);
  // const [openCustomerDrawer, setOpenCustomerDrawer] = useState<boolean>(false);
  const [deleteBankAccountRow, setDeleteBankAccountRow] = useState<any>();
  const [bankConfirmation, setBankConfirmation] = useState<boolean>(false);
  // const [countDraft, setCountDraft] = useState<boolean>(false);
  const [searchBankAccount, setSearchBankAccount] = useState<string>("");
  const [isSaveDraft, setIsSaveDraft] = useState<Boolean>(true);
  const [showPriceHistoryLoading, setShowPriceHistoryLoading] =
    useState<boolean>(false);
  const [showPriceHistory, setShowPriceHistory] = useState<boolean[]>([]);
  const [showPriceHistoryData, setShowPriceHistoryData] = useState<any>();

  const [bankAccountAmt, setBankAccountAmt] = useState<number>(0);
  const [termNCondData, setTermNCondData] = React.useState<any>();
  const [voucherNumberLoader, setVoucherNumberLoader] = React.useState(false);
  const [isStateSame, setIsStateSame] = useState<boolean>(
    splitPathInVchType === Voucher_Type.Expenses
      ? currentCustomerState === currentClient?.state!
      : (currentCustomerState ?? currentClient?.state!) === purchasePartyState
  );
  const [insufficientBalanceError, setInsufficientBalanceError] =
    React.useState<string>("");
  // const [addressEnum, setAddressEnum] = useState<number>(0);
  const [openModel, setOpenModel] = useState<{ type: string; param: any }>({
    type: "",
    param: {},
  });
  const [apiCallField, setApiCallField] = useState<string>("");
  const [newBankAccountAddedIndex, setNewBankAccountAddedIndex] =
    useState<number>();
  const [deletePaymentDetails, setDeletePaymentDetails] = React.useState<any[]>(
    []
  );
  const [saveInvoiceReferences, setSaveInvoiceReferences] =
    React.useState<any>();
  const [triggerDeletePaymentApi, setTriggerDeletePaymentApi] =
    React.useState<boolean>(false);
  const [isDeletePaymentApi, setIsDeletePaymentApi] =
    React.useState<boolean>(false);
  const [isSaveAndNew, setIsSaveAndNew] = React.useState<boolean>(false);
  // const [openGroupModel, setOpenGroupModel] = React.useState<{
  //   open: boolean;
  //   param: any;
  // }>({
  //   open: false,
  //   param: "",
  // });
  const [newItem, setNewItem] = useState<any>({
    data: {},
    isSaved: false,
  });

  const [presetsDueDate, setPresetsDueDate] = useState<any>({
    label: 0,
    value: "",
  });

  const [footerLedger, setFooterLedger] = useState<{
    ledgerAmount: number;
    ledgerGstAmount: number;
    ledgerTotalAmount: number;
  }>({
    ledgerAmount: 0,
    ledgerGstAmount: 0,
    ledgerTotalAmount: 0,
  });
  const [roundOffAmount, setRoundoffAmount] = useState<number>(0.0);
  const [cashDiscountRs, setCashDiscountRs] = useState<number>(0.0);
  const [itemId, setItemId] = React.useState<any>();
  const [loadItemAPI, setloadItemAPI] = React.useState<boolean>(false);
  const [bankAccountList, setBankAccountList] = useState<
    ILedgerSearchByGroupNameResponse[]
  >([]);

  // const [directExpenses, setDirectExpenses] = useState<boolean>(false);
  const [ledgerLength, setLedgerLength] = useState<number>(0);
  const [freightAndInsuranceOptions, setFreightAndInsuranceOptions] = useState<
    ILedgerSearchByGroupNameResponse[]
  >([]);
  const [deleteLedgerList, setDeleteLedgerList] = useState<number>(0);
  const [ledgerAmount, setLedgerAmount] = useState<any>();
  const [updateTimeShowFreightIns, setUpdateTimeShowFreightIns] =
    useState<boolean>(false);
  const [updateTimeData, setUpdateTimeData] = React.useState<{
    receipt: boolean;
    cashDiscount: boolean;
    isGSTVoucher: boolean;
    roundOff: boolean;
    showRCM: boolean;
  }>({
    receipt: false,
    cashDiscount: false,
    isGSTVoucher: false,
    roundOff: false,
    showRCM: false,
  });
  const [currentInvoiceDetails, setCurrentInvoiceDetails] = useState<any>();
  const [oldPartyRecepitDetails, setOldPartyRecepitDetails] = useState<any[]>(
    []
  );
  const [newPartyRecepitDetails, setNewPartyRecepitDetails] = useState<any[]>(
    []
  );
  const [customerAddress, setCustomerAddress] = useState<any>([]);
  const [dueDateTrigger, setDueDateTrigger] = useState<number>(0);

  const getVoucherTitle =
    splitPathInVchType === Voucher_Type.Expenses
      ? companySettings?.setting?.vouchersSettings.find(
          (x: vouchersSettings) => x?.settingType === SettingsSections.Expenses
        )
      : companySettings?.setting?.vouchersSettings.find(
          (x: vouchersSettings) => x?.settingType === SettingsSections.Income
        );

  const [settingControl, setSettingControl] = useState<{
    title?: string;
    titleToBePrint?: string;
    templateId: number;
    discountPolicy: Discount_Policy;
    showReceipt: boolean;
    manualNumbering: boolean;
    autoRoundOff: boolean;
    roundOffType: RoundOff_Type;
    showDispatchDetail: boolean;
    showFreightType: boolean;
    showRCM: boolean;
    showPriceHistory: boolean;
    showTcsTds: boolean;
  }>({
    title: getVoucherTitle?.title,
    titleToBePrint: getVoucherTitle?.settings?.expenseSettings?.titleToBePrint,
    templateId: getVoucherTitle?.id!,
    discountPolicy: getVoucherTitle?.settings?.expenseSettings?.discountPolicy!,
    showReceipt: getVoucherTitle?.settings?.expenseSettings?.showReceipt!,
    showPriceHistory:
      splitPathInVchType === Voucher_Type.Income
        ? false
        : getVoucherTitle?.settings?.expenseSettings?.showPriceHistory!,
    autoRoundOff: getVoucherTitle?.settings?.expenseSettings?.autoRoundOff!,
    roundOffType: getVoucherTitle?.settings?.expenseSettings?.roundOffType!,
    showDispatchDetail:
      getVoucherTitle?.settings?.expenseSettings?.showDispatchDetail!,
    showFreightType:
      getVoucherTitle?.settings?.expenseSettings?.showFreightType!,
    showRCM: getVoucherTitle?.settings?.expenseSettings?.showRCM!,
    manualNumbering:
      getVoucherTitle?.settings?.expenseSettings?.manualNumbering!,
    showTcsTds:
      splitPathInVchType === Voucher_Type.Income
        ? currentClient?.tcsApplicability!
        : currentClient?.tdsDeductible!,
  });
  const [voucherStatus, setVoucherStatus] = React.useState<VoucherStatus_New>(
    VoucherStatus_New.Active
  );

  const [selectCustomizationTemplete, setSelectCustomizationTemplete] =
    React.useState<{
      templateId: number;
      title: string;
    }>({
      templateId: getVoucherTitle?.id!,
      title: getVoucherTitle?.settings?.expenseSettings?.titleToBePrint,
    });
  const [isCashVoucher, setIsCashVoucher] = useState<boolean>(true);
  const [voucherNature, setVoucherNature] = React.useState<Voucher_Nature>(
    Voucher_Nature.Regular
  );

  useEffect(() => {
    setIsStateSame(purchasePartyState === currentCustomerState);
  }, [currentCustomerState, purchasePartyState]);

  React.useEffect(() => {
    const findVoucharType = companySettings?.setting?.vouchersSettings?.find(
      (x) => x?.id === selectCustomizationTemplete?.templateId
    );
    debugger;
    const voucherData = findVoucharType?.settings?.expenseSettings;

    setSettingControl({
      title: findVoucharType?.title,
      templateId: findVoucharType?.id!,
      titleToBePrint: voucherData?.titleToBePrint,
      discountPolicy: voucherData?.discountPolicy!,
      showReceipt: voucherData?.showReceipt!,
      showPriceHistory: voucherData?.showPriceHistory!,
      autoRoundOff: voucherData?.autoRoundOff!,
      roundOffType: voucherData?.roundOffType!,
      showDispatchDetail: voucherData?.showDispatchDetail!,
      showFreightType: voucherData?.showFreightType!,
      showRCM: voucherData?.showRCM!,
      manualNumbering: voucherData?.manualNumbering!,
      showTcsTds: settingControl?.showTcsTds,
    });
    // !updateId && setIsCustomNumber(voucherData?.manualNumbering);
    !updateId && setVoucherNature(voucherData?.defaultNature);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCustomizationTemplete]);

  const [transactionId, setTransactionId] = useState<{
    partyId: string;
  }>({ partyId: "" });
  const [updateInPartyId, setUpdateInPartyId] = useState<string>("");
  const [invoiceDespatchDetails, setInvoiceDespatchDetails] = useState<any>();
  const [refreshNumber, setRefreshNumber] = useState<boolean>(false);
  const [saveAndNew, setSaveAndNew] = useState<boolean>(false);
  const [updateAndNew, setUpdateAndNew] = useState<boolean>(false);

  const [selectedOtherExpenses, setSelectedOtherExpenses] = useState<any[]>([]);
  // const [selectedCostCentres, setSelectedCostCentres] = useState<any[]>([]);
  const [selectedCostCentres, setSelectedCostCentres] = React.useState<any[]>([
    [],
  ]);
  const [UnallottedAmounts, setUnallottedAmounts] = useState<any[]>([]);

  const [selectedBankLedger, setSelectedBankLedger] = useState<string[]>([]);
  const [selectedBankBalance, setSelectedBankBalance] = useState<number[]>([]);
  const [selectedBankPartyOrTax, setSelectedBankPartyOrTax] = useState<
    Party_Tax[]
  >([]);
  const [editInvBankDetails, setEditInvBankDetails] = useState<any[]>([]);
  const [isSameBillingAddress, setIsSameBillingAddress] =
    useState<boolean>(false);
  const [deleteUploadId, setDeleteUploadId] = React.useState<string[]>([]);
  const [previewImage, setPreviewImage] = React.useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });

  const [tdsList, setTdsList] = React.useState<any[]>([]);
  const [tcsList, setTcsList] = React.useState<any[]>([]);
  const [tdsListTrigger, setTdsListTrigger] = React.useState<boolean>(false);
  const [tcsListTrigger, setTcsListTrigger] = React.useState<boolean>(false);
  const [tdsPostDetail, setTdsPostDetail] = React.useState<{
    id: string;
    formNo: string;
    transactionType: Transaction_Type;
  }>({ formNo: "", transactionType: Transaction_Type.Domestic, id: "" });
  const [partyPanCard, setPartyPanCard] = React.useState<PanCardType>(
    PanCardType.notAvailable
  );
  const [tcsTdsPercentage, setTcsTdsPercentage] = React.useState<number>(0.0);
  const [isPartTDSOrTDS, setIsPartTDSOrTDS] = React.useState<{
    tds: Boolean;
    tcs: Boolean;
  }>({ tds: false, tcs: false });
  const [partyDropDownLoading, setPartyDropDownLoading] =
    React.useState<boolean>(false);

  const [bankAccountDropDownLoading, setbankAccountDropDownLoading] =
    React.useState<boolean>(false);
  const [otherExpensiveDropDownLoading, setOtherExpensiveDropDownLoading] =
    React.useState<boolean>(false);
  console.log("Checking TDS: ", tdsOrTcs, isPartTDSOrTDS, settingControl);

  const gstOption =
    // splitPathInVchType === Voucher_Type.Income
    //   ? companySettings?.setting?.gstDetails?.gst
    //   :
    companySettings?.gsts;

  // const purchaseGstOption = companySettings?.gsts;
  // let isStateSame =
  //   (currentCustomerState ?? currentClient?.state!) === purchasePartyState;

  // const [showKeys, setShowKeys] = useState(false);

  // //change
  // useHotkeys(
  //   "ctrl+shift",
  //   () => {
  //     setShowKeys((prev: any) => !prev);
  //   },
  //   {
  //     enabled: (event, hotkeysEvent) => {
  //       setTimeout(() => {
  //         setShowKeys(() => false);

  //         // alert("After 2 sec");
  //       }, 2000);

  //       return true;
  //     },
  //   }
  // );

  const handlePriceHistoryData = async (itemId: string) => {
    setShowPriceHistoryLoading(true);
    await VoucherServices.getPriceHistoryByItemId(
      currentClient?.id!,
      splitPathInVchType,
      itemId,
      false
    ).then((res: any) => {
      setShowPriceHistoryData(
        updateId
          ? res.result?.filter((res: any) => res.voucherId !== updateId)
          : res.result
      );
    });
    setShowPriceHistoryLoading(false);
  };

  const amountInNumber = (val: any, key: any) => {
    return Utils.getNumber(val?.amount?.[key]);
  };

  /* React.useEffect(() => {
    console.log("BankTransactionData", location?.state);
  }, []);*/

  const price = (curr: any) => amountInNumber(curr, "price");
  const qty = (curr: any) => amountInNumber(curr, "qty");
  const discount = (curr: any) => amountInNumber(curr, "discount");
  const taxRate = (curr: any) => Utils.getNumber(curr?.amount?.tax?.key);
  const netAmount = (curr: any) => price(curr) * qty(curr);

  const discountRupee = (curr: any, percentDiscountAll?: number) => {
    if (percentDiscountAll || percentDiscountAll === 0) {
      return percentCal(netAmount(curr), percentDiscountAll);
    } else return percentCal(netAmount(curr), discount(curr));
  };

  const amountWithoutTax = (curr: any, percentDiscountAll?: number) =>
    netAmount(curr) - discountRupee(curr, percentDiscountAll);

  const itemTaxAmt = (curr: any, percentDiscountAll?: number) => {
    // console.log("itemTaxAmt1`", curr);
    return amountWithoutTax(curr, percentDiscountAll) * (taxRate(curr) / 100);
  };

  const amountWithTax = (curr: any, percentDiscountAll?: number) =>
    amountWithoutTax(curr, percentDiscountAll) +
    itemTaxAmt(curr, percentDiscountAll);
  // const amountWithOutTax = (curr: any) => amountWithoutTax(curr);

  const amount = (curr: any) => amountInNumber(curr, "amount");
  const gstrate = (curr: any) => Utils.getNumber(curr?.gstRate?.title);
  const gstamount = (curr: any) =>
    percentCal(Utils.getNumber(curr?.amount), gstrate(curr));

  const ledgertotalamout = (curr: any) =>
    Utils.getNumber(curr?.amount) + gstamount(curr);

  // Save & New
  useEffect(() => {
    if (saveAndNew || updateAndNew) {
      form.resetFields();
      setFooterLedger({
        ledgerAmount: 0,
        ledgerGstAmount: 0,
        ledgerTotalAmount: 0,
      });
      setBankAccountAmt(0);
      // form.setFieldValue("dueDate", dayjs());

      form.setFieldValue("dueDate", dayjs(dateFiled).add(dueOnSetting, "d"));

      // splitPathInVchType === Voucher_Type.Expenses
      //   ? setDefaultEffectedAccount(Voucher_Type.Expenses)
      //   : setDefaultEffectedAccount(Voucher_Type.PurchaseVoucher);
      setRefreshNumber(!refreshNumber);
      // setInvoiceTotal(0.0);
      setItemLength(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveAndNew, updateAndNew]);

  //Add New Cost Centre
  useEffect(() => {
    if (postCostCenterResponse.id!.length > 0) {
      setFreightAndInsuranceOptions((pre: any[]) => {
        let newData = [...pre];
        newData[costCentreAddedDetails.expenseParentIndex] = {
          ...newData[costCentreAddedDetails.expenseParentIndex],
          costCentres: [
            ...newData[costCentreAddedDetails.expenseParentIndex].costCentres,
            postCostCenterResponse,
          ],
        };
        return newData;
      });
      const allPreviousData = [
        ...(form.getFieldValue([
          "freightInsLedgers",
          costCentreAddedDetails.expenseParentIndex,
          "costCentres",
        ]) || []),
      ];
      let newCostCentreData = {
        amount: 0,
        costCentreName: {
          key: postCostCenterResponse?.id,
          label: postCostCenterResponse?.costCentreName,
          value: postCostCenterResponse?.id,
          disabled: undefined,
          title: "",
        },
      };
      if (
        costCentreAddedDetails.costCentreAddedIndex ===
        allPreviousData.length - 1
      ) {
        allPreviousData.pop();
        allPreviousData.push(newCostCentreData);
        allPreviousData.push({ amount: 0 });
      } else {
        allPreviousData[costCentreAddedDetails.costCentreAddedIndex] =
          newCostCentreData;
      }
      form.setFieldValue(
        [
          "freightInsLedgers",
          costCentreAddedDetails.expenseParentIndex,
          "costCentres",
        ],
        allPreviousData
      );
      form.setFieldValue(
        [
          "freightInsLedgers",
          costCentreAddedDetails.expenseParentIndex,
          "costCentres",
          costCentreAddedDetails.costCentreAddedIndex,
          "costCentreName",
        ],
        postCostCenterResponse.costCentreName
      );
      setSelectedCostCentres((prevState: any[]) => {
        const updatedSelectedOptions: any[] = [...prevState];
        console.log("updatedSelectedOptions", updatedSelectedOptions);
        updatedSelectedOptions[costCentreAddedDetails.expenseParentIndex] = [
          ...(prevState[costCentreAddedDetails.expenseParentIndex] || []),
        ];
        updatedSelectedOptions[costCentreAddedDetails.expenseParentIndex][
          costCentreAddedDetails.costCentreAddedIndex
        ] = postCostCenterResponse.id;
        return updatedSelectedOptions;
      });
      handleCostCenterSelect(
        costCentreAddedDetails.expenseParentIndex,
        costCentreAddedDetails.costCentreAddedIndex
      );
    }
  }, [postCostCenterResponse]);
  console.log("termNCondData", termNCondData);

  // Date Api
  useEffect(() => {
    const getDate = async () => {
      if (currentClient?.id && !updateId && !location.state?.ledgerId) {
        await VoucherServices.getMaxVoucherDate(
          currentClient?.id!,
          splitPathInVchType
        ).then((res) => {
          const givenDate = new Date(res?.result);
          const currentTime = new Date();

          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
          form.setFieldValue("date", dayjs(givenDate));

          // console.log("givenDate", givenDate);

          form.setFieldValue(
            "dueDate",
            dayjs(givenDate).add(
              convertToDays(
                currentClient?.duration!,
                TimeUnits.Day
                // companySettings?.setting?.dueOn?.duration!,
                // companySettings?.setting?.dueOn?.durationUnit
              ),
              "d"
            )
          );
          setDateFiled(givenDate);
        });
      } else if (location.state?.ledgerId) {
        // console.log(
        //   "dataaaa..........",
        //   dayjs(location?.state?.BankTransactionData?.date, "DD/MM/YYYY")
        // );
        const givenDate = new Date(
          dayjs(
            location?.state?.BankTransactionData?.date,
            "DD/MM/YYYY"
          ).toISOString()
        );
        // dayjs(location?.state?.BankTransactionData?.date)
        const currentTime = new Date();

        // Set the time part of givenDate to match currentTime
        givenDate?.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds(),
          currentTime.getMilliseconds()
        );
        form.setFieldValue("date", dayjs(givenDate));

        form.setFieldValue(
          "dueDate",
          dayjs(givenDate).add(
            convertToDays(
              currentClient?.duration!,
              TimeUnits.Day
              // companySettings?.setting?.dueOn?.duration!,
              // companySettings?.setting?.dueOn?.durationUnit
            ),
            "d"
          )
        );

        form.setFieldValue(["bankDts", 0], {
          name: {
            value: location.state?.ledgerId,
          },
          amount:
            location?.state?.BankTransactionData?.moneyIn ||
            location?.state?.BankTransactionData?.moneyOut,
          date: givenDate,
        });

        setBankAccountAmt(
          location?.state?.BankTransactionData?.moneyIn ||
            location?.state?.BankTransactionData?.moneyOut
        );

        setDateFiled(givenDate);
      }
    };
    getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, splitPathInVchType]);

  React.useEffect(() => {
    setSelectCustomizationTemplete({
      templateId: getVoucherTitle?.id!,
      title: getVoucherTitle?.settings?.expenseSettings?.titleToBePrint,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPathInVchType]);

  useEffect(() => {
    const getInitialValue = async () => {
      if (
        (currentClient?.id && !updateId && !draftId && dateFiled) ||
        (updateAndNew && dateFiled)
      ) {
        if (!settingControl?.manualNumbering) {
          setVoucherNumberLoader(true);
          setLoading(true);
          await VoucherServices.getVoucherMaxNo(
            currentClient?.id!,
            splitPathInVchType,
            dayjs(dateFiled).endOf("day").toISOString(),
            selectCustomizationTemplete?.templateId
          )
            .then((res) => {
              // console.log("initial value", res.result);
              form.setFieldValue(
                "number",
                res?.result !== "0" ? res?.result : ""
              );

              // setSalesInvoiceNo(res?.result);
              setVoucherNumberLoader(false);
              setLoading(false);
              // setDefaultEffectedAccount(selectCustomizationTemplete);
            })
            .catch((err: any) => {
              openNotification("error", err.message);
              setVoucherNumberLoader(false);
              setLoading(false);
            });
        } else {
          form.setFieldValue("number", "");
        }
        // setVoucherNumberLoader(false);
      }
    };
    getInitialValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    refreshNumber,
    cloneId,
    dateFiled,
    settingControl,
    // splitPathInVchType,
    // selectCustomizationTemplete,
  ]);

  // -------- Edit Sales Invoice Get API ---------
  useEffect(() => {
    if (
      (updateId || cloneId || draftId) &&
      (settingControl?.showReceipt || editInvBankDetails?.length > 0
        ? checkIsBankApiCall
        : true) &&
      checkIsPartyApiCall
      // customerOptions?.length > 0
    ) {
      const editData = async (id: any) => {
        setLoading(true);
        try {
          const res = draftId
            ? await DraftService.getByDraftId(currentClient?.id!, draftId)
            : await VoucherServices.getVoucharById(
                currentClient?.id!,
                id,
                splitPathInVchType === Voucher_Type.Expenses
                  ? Voucher_Type.Expenses
                  : Voucher_Type.PurchaseVoucher
              );

          if (res?.result) {
            setVoucherNature(res.result?.nature);
            // setIsCustomNumber(res?.result?.isCustomNumber);
            setIsSameBillingAddress(res?.result?.isShippingAddressSame);
            setSelectCustomizationTemplete({
              templateId: res.result?.voucherTitle?.id,
              title: res.result?.voucherTitle.name,
            });
            // CustomerSelect(res.result?.partyLedger[0]?.id);
            setIsCashVoucher(res.result?.isCashVoucher);

            if (
              !res.result?.isCashVoucher ||
              res.result?.payRecVouchers !== null
            ) {
              setSelectedParty(res.result?.partyLedger[0]?.id);
              setUpdateInPartyId(res.result?.partyLedger[0]?.id);
              // Tcs & Tds Party condition show & hinde
              const partyDetail = customerOptions.find(
                (x) => x.id === res.result?.partyLedger[0]?.id
              );
              setIsPartTDSOrTDS({
                tds: partyDetail?.deductTDSinSameVoucher,
                tcs: partyDetail?.ledgerTCSApplicability,
              });

              setOldPartyRecepitDetails(
                res.result?.partyLedger[0]?.ref?.map(
                  (v: any, index: number) => {
                    return {
                      key: index,
                      // date: dayjs(v?.date),
                      value: v?.value,
                      // id: v?.id,
                      // refNo: v?.name,
                      refType: v?.refType,
                      id:
                        index === 0
                          ? {
                              value: v?.id,
                              label:
                                v?.refType === 0
                                  ? res?.result?.number
                                  : v?.name,
                              title: v?.parentRef,
                            }
                          : {
                              value: v?.id,
                              label: v?.name,
                              title: v?.parentRef,
                            },
                      dueAmount: v?.dueAmount,
                    };
                  }
                )
              );
            }
            // setEditParty({ id: res.result?.partyLedger[0]?.id });

            setFooterLedger({
              ledgerAmount: res.result?.amountSummary?.cifExpenses ?? 0,
              ledgerGstAmount: res.result?.amountSummary?.totalCIFGSTAmt ?? 0,
              ledgerTotalAmount:
                res.result?.amountSummary?.cifExpenses +
                res.result?.amountSummary?.totalCIFGSTAmt,
            });
            setBalance(res.result.amountSummary?.receivedAmount);
            setRoundoffAmount(
              res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0
            );
            setCashDiscountRs(
              res.result?.amountSummary?.cashDiscount?.discountAmount ?? 0
            );

            setTotalTds(res.result?.amountSummary?.tdsAmt);
            setTotalTcs(res.result?.amountSummary?.tcsAmt);
            setTdsOrTcs(res.result?.tcsApplicable ? 1 : 0);
            setTcsTdsPercentage(
              res.result?.tcsApplicable
                ? res.result?.tcsDetail?.rate
                : res.result?.tdsDetail?.rate
            );
            res.result?.tdsApplicable &&
              setTdsPostDetail({
                id: res.result?.tdsDetail?.id,
                formNo: res.result?.tdsDetail?.form,
                transactionType: res.result?.tdsDetail?.transactionType,
              });

            setItemLength(res.result?.items?.length);

            // if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
            setCurrentCustomerState(res.result?.billState);
            setPurchasePartyState(res.result?.supplyState);
            // }
            //  else {
            //   setCurrentCustomerState(res.result?.supplyState);
            // }
            // setGstEnabled(res?.result?.isGstEnabled);

            setTransactionId({
              partyId: res.result?.partyLedger[0]?.transactionId,
            });

            const filterFreightInsLedger =
              res.result?.freightInsLedgers?.filter(
                (x: any) => x?.partyOrTax !== 7 && x?.partyOrTax !== 6
              );

            setUpdateTimeShowFreightIns(filterFreightInsLedger?.length > 0);

            const freightInsLedgers: any[] = filterFreightInsLedger?.map(
              (exp: any, index: number) => {
                setSelectedOtherExpenses((select) => [...select, exp?.id]);
                setSelectedCostCentres((prev: any[]) => {
                  const updatedCostCenters: any[] = [...prev];
                  updatedCostCenters[index] = [...(prev[index] || [])];
                  updatedCostCenters[index] = exp?.costCentresDetail?.map(
                    (cc: any) => cc?.id
                  );

                  return updatedCostCenters;
                });
                return {
                  ...exp,
                  itcEligibilityType:
                    exp?.itcEligibilityType === 3
                      ? undefined
                      : exp?.itcEligibilityType,
                  id: {
                    value: exp?.id,
                    label: exp?.ledgerName,
                  },
                  amount: Math.abs(exp?.amount),
                  transactionId: exp?.transactionId,
                  gstRate: exp?.gstRate && {
                    value: exp?.gstRate?.id,
                    title: exp?.gstRate?.rate,
                    label: exp?.gstRate?.name,
                  },
                  costCentres:
                    exp?.costCentresDetail?.length > 0
                      ? [
                          ...exp?.costCentresDetail?.map((costCenters: any) => {
                            return {
                              costCentreName: {
                                label: costCenters?.name,
                                value: costCenters?.id,
                              },
                              amount: costCenters?.value,
                              qty: costCenters?.qty,
                            };
                          }),
                          {
                            costCentreName: null,
                            amount: 0,
                            qty: 1,
                          },
                        ]
                      : [],
                };
              }
            );
            setLedgerLength(freightInsLedgers?.length ?? 1);
            const bankDtsGet = draftId
              ? res.result?.instantPayLedgersDetails?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y?.id === x?.ledgerId
                  );
                  setSelectedBankBalance((y) => [
                    ...y,
                    bankAccount?.balance ?? 0,
                  ]);

                  return {
                    name: {
                      value: x?.ledgerId,
                      label: x?.ledgerName,
                      title: Party_Tax.BanknCash,
                    },
                    // name: x?.ledgerId,
                    payRecReference: x?.payRecReference,
                    amount: x?.amount,
                    isDeleted: false,
                  };
                })
              : res.result?.isCashVoucher && !res.result?.payRecVouchers
              ? res.result?.partyLedger?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y.id === x?.id
                  );

                  if (updateId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      splitPathInVchType === Voucher_Type.Income
                        ? bankAccount?.balance! - (x?.amount ?? 0)
                        : Math.abs(x?.amount) + (bankAccount?.balance ?? 0),
                    ]);
                  } else if (cloneId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      bankAccount?.balance ?? 0,
                    ]);
                  }

                  setSelectedBankLedger((select: any) => [...select, x?.id]);

                  setSelectedBankPartyOrTax((select: any) => [
                    ...select,
                    x?.partyOrTax,
                  ]);

                  return {
                    // editId: x?.id,
                    paymentNumber: x?.number,
                    payRecReference: x?.payRecReference,
                    date: x?.date,
                    // partyRefId: x?.partyLedger[0]?.ref[0]?.id,
                    name: {
                      value: x?.id,
                      label: x?.ledgerName,
                      title: x?.partyOrTax,
                    },
                    isDeleted: false,
                    amount: Math.abs(x?.amount),
                    isReconciled: x.isReconciled,
                    bankImportEntryRef: x.bankImportEntryRef,
                  };
                })
              : res.result?.payRecVouchers?.map((x: any) => {
                  let bankAccount = bankAccountList?.find(
                    (y: any) => y.id === x?.effectiveLedger[0]?.id
                  );

                  // console.log("x........", x.date);
                  if (updateId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      splitPathInVchType === Voucher_Type.Expenses
                        ? (bankAccount?.balance ?? 0) -
                          (x?.effectiveLedger[0]?.amount ?? 0)
                        : Math.abs(x?.effectiveLedger[0]?.amount ?? 0) +
                          (bankAccount?.balance ?? 0),
                    ]);
                  } else if (cloneId) {
                    setSelectedBankBalance((y) => [
                      ...y,
                      bankAccount?.balance ?? 0,
                    ]);
                  }

                  setSelectedBankLedger((select: any) => [
                    ...select,
                    x?.effectiveLedger[0]?.id,
                  ]);

                  setSelectedBankPartyOrTax((select: any) => [
                    ...select,
                    x?.effectiveLedger[0]?.partyOrTax,
                  ]);

                  return {
                    editId: x?.id,
                    paymentNumber: x?.number,
                    payRecReference: x?.payRecReference,
                    date: x?.date,
                    partyRefId: x?.partyLedger[0]?.ref[0]?.id,
                    name: {
                      value: x?.effectiveLedger[0]?.id,
                      label: x?.effectiveLedger[0]?.ledgerName,
                      title: x?.effectiveLedger[0]?.partyOrTax,
                    },
                    isDeleted: false,
                    amount: Math.abs(x?.effectiveLedger[0]?.amount),
                    isReconciled: x.isReconciled,
                    bankImportEntryRef: x.bankImportEntryRef,
                  };
                });

            setEditInvBankDetails(bankDtsGet ?? []);

            const receivedAmount = draftId
              ? res.result?.instantPayLedgersDetails?.reduce(
                  (acc: number, curr: any) => {
                    return (acc += Utils.getNumber(Math.abs(curr?.amount)));
                  },
                  0
                )
              : res.result?.isCashVoucher && !res.result?.payRecVouchers
              ? res.result?.partyLedger?.reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(Math.abs(curr?.amount)));
                }, 0)
              : res.result?.payRecVouchers?.reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(
                    Math.abs(curr?.effectiveLedger[0]?.amount)
                  ));
                }, 0);

            console.log("receivedAmount ", receivedAmount);

            setBankAccountAmt(receivedAmount ?? 0);

            setUpdateTimeData({
              receipt: bankDtsGet?.length > 0,
              cashDiscount:
                res.result?.amountSummary?.cashDiscount?.discountAmount > 0,
              isGSTVoucher: res.result?.isGSTVoucher,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffApplicable ||
                res.result?.amountSummary?.roundOff?.roundOffAmount !== 0,
              showRCM: res.result?.nature === Voucher_Nature.RCM ? true : false,
            });

            const despatchDetail = {
              ...res.result?.despatchDetail,
              delNoteDate: dayjs(
                dayjs(res.result?.despatchDetail?.delNoteDate).format(
                  "DD/MM/YYYY"
                ),
                "DD/MM/YYYY"
              ),
            };

            setInvoiceDespatchDetails(despatchDetail);

            form.setFieldsValue({
              ...res.result,
              billingAddress: {
                ...res.result?.billingAddress,
                type: {
                  value: res.result?.billingAddress?.addressName,
                  lable: res.result?.billingAddress?.addressName,
                  title: res.result?.billingAddress?.type,
                },
              },
              shippingAddress: {
                ...res.result?.shippingAddress,
                type: {
                  value: res.result?.shippingAddress?.addressName,
                  lable: res.result?.shippingAddress?.addressName,
                  title: res.result?.shippingAddress?.type,
                },
              },
              tdsDetail: {
                value: res.result?.tdsDetail?.id,
                label: res.result?.tdsDetail?.name,
                title: res.result?.tdsDetail?.rate,
              },
              tcsDetail: {
                value: res.result?.tcsDetail?.id,
                label: res.result?.tcsDetail?.name,
                title: res.result?.tcsDetail?.rate,
              },
              freightType: res.result?.freightType
                ? res.result?.freightType
                : null,
              roundOff:
                res.result?.amountSummary?.roundOff?.roundOffAmount ?? 0,
              roundoffCheckbox:
                res.result?.amountSummary?.roundOff?.roundOffApplicable,
              cashDiscount:
                res.result?.amountSummary?.cashDiscount?.discountRate > 0
                  ? res.result?.amountSummary?.cashDiscount?.discountRate
                  : Number(
                      res.result?.amountSummary?.cashDiscount?.discountAmount ??
                        0
                    ),
              cashDiscountDrop:
                Number(res.result?.amountSummary?.cashDiscount?.discountRate) >
                0
                  ? DiscountType.PercentageDiscount
                  : DiscountType.RupeeDiscount,
              bankDts:
                bankDtsGet?.length > 0
                  ? bankDtsGet?.length < 2
                    ? [...bankDtsGet, { amount: 0.0 }]
                    : [...bankDtsGet]
                  : [{ amount: 0.0 }],
              showFreightInsLedgers: freightInsLedgers?.length > 0,
              purchaseOrderRef: {
                value: res.result?.purchaseOrderRef?.id,
                label: res.result?.purchaseOrderRef?.name,
              },
              freightInsLedgers: [
                ...freightInsLedgers,
                {
                  id: null,
                  itcEligibilityType:
                    splitPathInVchType === Voucher_Type.Expenses
                      ? ITCEligibility_Type.Available
                      : null,
                  gstAmount: 0,
                  totalAmount: 0,
                  amount: 0,
                },
              ],
              partyLedger: res.result?.isCashVoucher
                ? res.result?.payRecVouchers !== null
                  ? {
                      value: res.result?.partyLedger[0]?.id,
                      label: res.result?.partyLedger[0]?.ledgerName,
                    }
                  : null
                : {
                    value: res.result?.partyLedger[0]?.id,
                    label: res.result?.partyLedger[0]?.ledgerName,
                  },
              number: cloneId
                ? form.getFieldValue("number")
                : res.result?.number,
              receivedAmount: res.result?.amountSummary?.receivedAmount,
              paymentType: res.result?.paymentType === 1 ? true : false,
              // date: dayjs(
              //   dayjs(res.result?.date).format("DD/MM/YYYY"),
              //   "DD/MM/YYYY"
              // ),
              date: dayjs(res.result?.date),
              supplierInvoiceDate:
                res.result?.supplierInvoiceDate &&
                dayjs(res.result?.supplierInvoiceDate),
              dueDate: dayjs(
                dayjs(res.result?.dueDate).format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ),
            });
            setVoucherStatus(res.result?.voucherStatus);
            setDateFiled(dayjs(res.result?.date));
            setEditDate(res.result?.date);
            setEditDueDate(res.result?.dueDate);
            setLoading(false);
          } else setLoading(false);
        } catch (err: any) {
          console.error("error", err);
          openNotification("error", err.message);
          setLoading(false);
        }
      };

      editData(draftId ? draftId : updateId ?? cloneId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateId, cloneId, checkIsPartyApiCall, checkIsBankApiCall]);

  useEffect(() => {
    const FreightAndInsuranceOptions = async () => {
      setOtherExpensiveDropDownLoading(true);
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        splitPathInVchType === Voucher_Type.Expenses
          ? SearchLedgerByGroupsTypes.AllExpenses
          : SearchLedgerByGroupsTypes.IndirectIncomeOnly
      )
        .then((res: any) => {
          if (res) {
            setFreightAndInsuranceOptions(res);
            setOtherExpensiveDropDownLoading(false);
          }
        })
        .catch((ex: any) => {
          console.error("error", ex);
          setOtherExpensiveDropDownLoading(false);
        });
    };
    FreightAndInsuranceOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, splitPathInVchType]);
  // -------- Add Sales Invoice Post API ---------
  const addExpensesIncome = (isSaveAndNew?: boolean) => {
    if (
      Utils.getNumber(footerLedger.ledgerTotalAmount) +
        roundOffAmount -
        Math.round(cashDiscountRs * 100) / 100 >
      0
    ) {
      const iscostCentersValidate = UnallottedAmounts?.find(
        (r) => r?.validate === true
      );
      if (!iscostCentersValidate) {
        try {
          form.validateFields().then(async (val: any) => {
            if (val?.freightInsLedgers[0]?.id) {
              let invoiceValue = Utils.getNumber(
                voucherNature === Voucher_Nature.RCM
                  ? footerLedger.ledgerAmount +
                      totalTcs +
                      roundOffAmount -
                      Math.round(cashDiscountRs * 100) / 100
                  : Utils.getNumber(footerLedger.ledgerTotalAmount) +
                      totalTcs +
                      roundOffAmount -
                      Math.round(cashDiscountRs * 100) / 100
              );
              if (
                // splitPathInVchType === Voucher_Type.Expenses &&
                isCashVoucher &&
                Utils.getNumber(bankAccountAmt) !== invoiceValue
              ) {
                setInsufficientBalanceError(
                  "The total allotted amount is different from voucher total amount, so the transaction cannot be completed."
                );
                // openNotification(
                //   "error",
                //   `Cash ${splitPathInVchType === Voucher_Type.Expenses ? "Expenses" : "Income"
                //   }- Received amount must be equal to the total transaction amount.`
                // );
              } else {
                console.log("val.bankDts", val.bankDts);
                let bankBalanceLargeAmount: any = [];
                if (splitPathInVchType === Voucher_Type.Expenses) {
                  if (val.bankDts?.length > 0) {
                    for (const index in selectedBankBalance) {
                      if (
                        val.bankDts[index]?.amount >
                          selectedBankBalance[index] &&
                        val.bankDts[index]?.name?.title === Party_Tax.BanknCash
                      ) {
                        bankBalanceLargeAmount.push({
                          name: val.bankDts[index]?.name?.label,
                          amount: selectedBankBalance[index],
                        });
                        console.log("index", val.bankDts[index]?.name?.value);
                      }
                    }
                  }
                }

                if (bankBalanceLargeAmount?.length > 0) {
                  const formattedDetails = bankBalanceLargeAmount.map(
                    (obj: any) =>
                      `${
                        obj?.name
                      } -  Bank Amount: ₹ ${Utils.getFormattedNumber(
                        obj?.amount
                      )}`
                  );
                  alert(formattedDetails.join("\n"));
                } else {
                  // console.log("post...........", val.bankDts, bankBalanceLargeAmount);

                  isSaveAndNew
                    ? setSaveNewLoading(true)
                    : setUpdateAndNewButton(true);

                  setSaveAndNew(false);
                  // setUpdateAndNew(false);
                  const freightInsLedgers = val?.freightInsLedgers?.map(
                    (exp: any) => {
                      return {
                        ...exp,
                        id: exp?.id?.value,
                        gstRate: {
                          id: exp?.gstRate?.value,
                          rate: exp?.gstRate?.title,
                          name: exp?.gstRate?.label,
                        },
                        costCentresDetail: exp?.costCentres?.map((cc: any) => {
                          return {
                            id: cc?.costCentreName?.value,
                            value: cc?.amount,
                            qty: 1,
                          };
                        }),
                      };
                    }
                  );

                  console.log("freightInsLedgers", freightInsLedgers);
                  setLoading(true);

                  const partyLedger = val?.partyLedger?.value
                    ? new Array({
                        id: val?.partyLedger?.value,
                        partyOrTax: Party_Tax.party,
                        amount: Utils.getNumber(
                          Utils.getNumber(footerLedger.ledgerTotalAmount) -
                            Math.round(cashDiscountRs * 100) / 100 +
                            roundOffAmount -
                            (voucherNature === Voucher_Nature.RCM
                              ? footerLedger.ledgerGstAmount
                              : 0) -
                            totalTds +
                            totalTcs
                        ),
                        transactionId:
                          transactionId.partyId === ""
                            ? null
                            : transactionId.partyId,
                      })
                    : val.bankDts.map((x: any) => {
                        return {
                          id: x?.name?.value,
                          amount: x?.amount,
                          partyOrTax: x?.name?.title,
                          transactionId:
                            transactionId.partyId === ""
                              ? null
                              : transactionId.partyId,
                        };
                      });

                  const bankDts = val?.partyLedger?.value ? val.bankDts : [];

                  const adjustDateToCurrentTime = (date: any) => {
                    const currentTime = new Date();

                    // Set the time part of the date to match the current time
                    date.setHours(
                      currentTime.getHours(),
                      currentTime.getMinutes(),
                      currentTime.getSeconds(),
                      currentTime.getMilliseconds()
                    );
                    return date;
                  };

                  const despatchDetail = {
                    ...invoiceDespatchDetails,
                    delNoteDate:
                      Utils.isValidDate(invoiceDespatchDetails?.delNoteDate) &&
                      dayjs(invoiceDespatchDetails?.delNoteDate).toISOString(),
                  };

                  let adjustedGivenDate = adjustDateToCurrentTime(
                    new Date(val.date)
                  );
                  let adjustedDueGivenDate = adjustDateToCurrentTime(
                    new Date(val.dueDate)
                  );

                  if (updateId) {
                    adjustedGivenDate = dayjs(val.date).isSame(
                      dayjs(editDate),
                      "day"
                    )
                      ? editDate
                      : adjustedGivenDate;

                    adjustedDueGivenDate = dayjs(val.dueDate).isSame(
                      dayjs(editDueDate),
                      "day"
                    )
                      ? editDueDate
                      : adjustedDueGivenDate;
                  }

                  // console.log("date",adjustedGivenDate, dayjs(adjustedGivenDate).toISOString());

                  // formData.append("file", file);

                  // console.log(
                  //   "val.despatchDetail",
                  //   despatchDetail,
                  //   invoiceDespatchDetails?.delNoteDate
                  // );

                  const tdsRatePredentage =
                    partyPanCard === PanCardType.HUF
                      ? val?.tdsDetail?.title?.rates?.indHUFRate ??
                        val?.tdsDetail?.title
                      : partyPanCard === PanCardType.Other
                      ? val?.tdsDetail?.title?.rates?.otherRate ??
                        val?.tdsDetail?.title
                      : val?.tdsDetail?.title?.rates?.ifPANNotRate ??
                        val?.tdsDetail?.title;

                  const invoice = {
                    ...val,
                    voucherTitle: {
                      id: selectCustomizationTemplete.templateId,
                      name: selectCustomizationTemplete.title,
                    },
                    bankDts: bankDts,
                    isCashVoucher: isCashVoucher,
                    isCustomNumber: settingControl?.manualNumbering,
                    billingAddress: {
                      ...val?.billingAddress,
                      // type: val?.billingAddress?.type?.title,
                      addressName: val?.billingAddress?.type?.value,
                    },
                    shippingAddress: {
                      ...val?.shippingAddress,
                      // type: val?.shippingAddress?.type?.title,
                      addressName: val?.shippingAddress?.type?.value,
                    },
                    // shippingAddress: val?.shippingAddress?.type
                    //   ? val.shippingAddress
                    //   : { address: val?.shippingAddress?.address },
                    tcsApplicable:
                      tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs
                        ? true
                        : false,
                    tcsDetail:
                      tdsOrTcs && totalTcs > 0 && isPartTDSOrTDS.tcs
                        ? {
                            id: val?.tcsDetail?.value,
                            name: val?.tcsDetail?.label,
                            rate: val?.tcsDetail?.title,
                            value: totalTcs,
                          }
                        : null,
                    tdsApplicable:
                      tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds
                        ? true
                        : false,
                    tdsDetail:
                      tdsOrTcs === 0 && totalTds > 0 && isPartTDSOrTDS.tds
                        ? {
                            id: val?.tdsDetail?.value,
                            name: val?.tdsDetail?.label,
                            rate: tdsRatePredentage,
                            value: totalTds,
                            transactionType: tdsPostDetail.transactionType,
                            form: tdsPostDetail.formNo,
                          }
                        : null,
                    nature: voucherNature,
                    // isPurchaseJVVoucher: true,
                    isShippingAddressSame: isSameBillingAddress,
                    isGSTVoucher:
                      currentClient?.gstType === CompanyGSTTypes.Regular ||
                      updateTimeData.isGSTVoucher ||
                      splitPathInVchType !== Voucher_Type.Income,
                    draftId: draftId,
                    bankAmount: bankAccountAmt,
                    instantPayment:
                      // splitPathInVchType === Voucher_Type.SalesVoucher &&
                      isCashVoucher &&
                      !selectedParty &&
                      Utils.getNumber(bankAccountAmt) ===
                        Utils.getNumber(
                          voucherNature === Voucher_Nature.RCM
                            ? footerLedger.ledgerAmount +
                                totalTcs +
                                roundOffAmount -
                                Math.round(cashDiscountRs * 100) / 100
                            : Utils.getNumber(footerLedger.ledgerTotalAmount) +
                                totalTcs +
                                roundOffAmount -
                                Math.round(cashDiscountRs * 100) / 100
                        )
                        ? false
                        : bankAccountAmt > 0
                        ? true
                        : false,
                    purchaseOrderRef: { id: val?.purchaseOrderRef?.value },
                    date: dayjs(adjustedGivenDate).toISOString(),
                    supplierInvoiceDate: dayjs(
                      val?.supplierInvoiceDate
                    ).toISOString(),
                    dueDate: dayjs(adjustedDueGivenDate)?.toISOString(),
                    freightInsLedgers,
                    partyLedger,
                    despatchDetail: despatchDetail,
                    // exportDetail: invoiceExportDetails,

                    isStateSame: isStateSame,
                    billState: currentCustomerState,
                    amountSummary: {
                      tCSRate: val?.tcsDetail?.title,
                      tCSAmt: totalTcs,
                      tDSRate: tdsRatePredentage,
                      tDSAmt: totalTds,
                      totalQty: 0,
                      taxableAmount: 0, // befor gst
                      totalDis: 0,
                      freightAmount: 0,
                      cessAmount: 0,
                      igstAmt: !isStateSame ? footerLedger.ledgerGstAmount : 0,
                      cgstAmt: isStateSame
                        ? footerLedger.ledgerGstAmount / 2
                        : 0,
                      sgstAmt: isStateSame
                        ? footerLedger.ledgerGstAmount / 2
                        : 0,
                      // roundOffAmount: roundOffAmount,
                      roundOff: {
                        roundOffApplicable: val?.roundoffCheckbox,
                        roundOffAmount: roundOffAmount,
                      },
                      cashDiscount: {
                        discountRate:
                          val.cashDiscountDrop ===
                          DiscountType.PercentageDiscount
                            ? val.cashDiscount ?? 0
                            : 0,
                        discountAmount: cashDiscountRs,
                      },
                      totalInvoiceAmount: Utils.getFormattedNumber(
                        Utils.getNumber(footerLedger.ledgerTotalAmount) +
                          roundOffAmount -
                          cashDiscountRs -
                          (voucherNature === Voucher_Nature.RCM
                            ? footerLedger.ledgerGstAmount
                            : 0) +
                          totalTcs
                      ),
                      // -
                      // totalTds,
                      receivedAmount: 0,
                      voucherAmountWithoutTCS:
                        Utils.getNumber(footerLedger.ledgerTotalAmount) -
                        balance,
                    },
                    deleteUploadId: deleteUploadId,
                  };

                  setCurrentInvoiceDetails(invoice);

                  console.log("invoice", invoice);

                  if (cashDiscountRs <= footerLedger.ledgerTotalAmount) {
                    if (
                      Utils.getFormattedNumber(bankAccountAmt) <=
                      invoice.amountSummary?.totalInvoiceAmount
                    ) {
                      if (Utils.getNumber(footerLedger.ledgerTotalAmount) > 0) {
                        // cash voucher model not open
                        if (isCashVoucher) {
                          // Cash Only (Party Not Available) This time not delete payment method
                          if (!invoice?.isCashVoucher || updateInPartyId) {
                            const findDeletePaymentVouchar =
                              editInvBankDetails?.filter(
                                (x: any) =>
                                  !(
                                    invoice?.bankDts?.some(
                                      (y: any) =>
                                        y?.editId === x?.editId && y.amount > 0
                                    ) && x.isDeleted === false
                                  )
                              );

                            if (
                              findDeletePaymentVouchar != null &&
                              findDeletePaymentVouchar?.length > 0
                            ) {
                              setDeletePaymentDetails(findDeletePaymentVouchar);
                            }
                          }

                          try {
                            // setSaveButtonLoading(true);
                            isSaveAndNew
                              ? setSaveNewLoading(true)
                              : setUpdateAndNewButton(true);

                            const postData = {
                              ...invoice,
                              partyLedger:
                                invoice?.isCashVoucher &&
                                invoice?.partyLedger[0]?.partyOrTax !==
                                  Party_Tax.party
                                  ? invoice?.partyLedger
                                  : new Array({
                                      ...invoice?.partyLedger[0],
                                      ref: updateId
                                        ? [
                                            {
                                              id: oldPartyRecepitDetails[0]?.id
                                                ?.value,
                                              name: invoice.number,
                                              refType: RefType.newRef,
                                              value: invoice?.bankAmount,
                                              // date: x?.date,
                                            },
                                          ]
                                        : [
                                            {
                                              id: null,
                                              name: invoice.number,
                                              refType: RefType.newRef,
                                              value: invoice?.bankAmount,
                                            },
                                          ],
                                    }),
                            };

                            // console.log("Post Data", postData);
                            await VoucherServices.postVoucher(
                              currentClient?.id!,
                              splitPathInVchType,
                              postData,
                              updateId
                              // config
                              // location?.state?.copy ? undefined : id
                            )
                              .then((res: any) => {
                                if (res?.status) {
                                  console.log("res....", res);
                                  sessionStorage.removeItem(
                                    `${currentClient?.id} Sales`
                                  );
                                  sessionStorage.removeItem(
                                    "NotificationState"
                                  );

                                  openNotification(
                                    "success",
                                    ` ${
                                      splitPathInVchType ===
                                      Voucher_Type.Expenses
                                        ? "Expenses"
                                        : "Income"
                                    } ${res.result?.name} ${
                                      updateId
                                        ? " updated successfully."
                                        : " added successfully."
                                    }`
                                  );
                                  if (invoice?.bankDts?.length > 0) {
                                    setSaveInvoiceReferences(
                                      res.result?.references[0]
                                    );
                                  } // first credit & user change to cash & not select party & deletePaymentDetails length > 0
                                  else if (
                                    invoice?.bankDts?.length === 0 &&
                                    updateId &&
                                    invoice?.isCashVoucher &&
                                    invoice?.partyLedger[0]?.partyOrTax !==
                                      Party_Tax.party &&
                                    deletePaymentDetails.length > 0
                                  ) {
                                    setTriggerDeletePaymentApi(true);
                                  } else {
                                    onPostSuccess();
                                  }

                                  // setInvoiceTotal(0.0);
                                  // setItemLength(0);
                                } else if (res?.message) {
                                  openNotification("error", res?.message);
                                  setLoading(false);
                                }
                              })
                              .catch((ex) => openNotification("error", ex));

                            // setSaveNewLoading(false);
                            // isSaveAndNew && seInitialRender(!initialRender);
                          } catch (err) {
                            console.error("error", err);
                            openNotification("error", err);
                            setLoading(false);
                          } finally {
                            // setSaveButtonLoading(false);
                            setSaveAndNew(false);
                            setLoading(false);

                            isSaveAndNew
                              ? setSaveNewLoading(false)
                              : setUpdateAndNewButton(false);
                          }
                        } else {
                          setOpenModel({
                            type: "addInvoiceReferenceModel",
                            param: {
                              open: true,
                            },
                          });
                        }
                      } else {
                        openNotification(
                          "error",
                          "Selling price must be greater than 0"
                        );
                        setLoading(false);
                      }
                    } else {
                      openNotification(
                        "error",
                        "Bank amount must be less than Total Invoice amount."
                      );
                      setLoading(false);
                    }
                  } else {
                    openNotification(
                      "error",
                      "Discount must be less than selling price."
                    );
                    setLoading(false);

                    setUpdateAndNewButton(false);
                  }
                }
              }
            } else {
              openNotification(
                "error",
                `Please select at least one ${
                  splitPathInVchType === Voucher_Type.Expenses
                    ? "expense"
                    : "income"
                } ledger.`
              );
              setLoading(false);

              setSaveNewLoading(false);
            }
          });
        } catch (err) {
          setLoading(false);
        } finally {
          setSaveNewLoading(false);
          setUpdateAndNewButton(false);
          setLoading(false);
        }
      } else {
        openNotification(
          "error",
          `Unallotted amount is not equal to total amount`
        );
        setLoading(false);
      }
    } else {
      openNotification(
        "error",
        `${
          splitPathInVchType === Voucher_Type.Expenses ? "Expense " : "Income "
        } amount must be greater than zero`
      );
      setLoading(false);
    }
  };

  // Post(add) payment api
  useEffect(() => {
    const paymentAdd = async () => {
      let index = 0;
      try {
        setLoading(true);
        let postSucessData = {};
        for (const x of currentInvoiceDetails?.bankDts || []) {
          // console.log("date x.............", x, index);
          let selVoucherTemplate =
            companySettings?.setting?.vouchersSettings?.find(
              (vchTemp: vouchersSettings) =>
                vchTemp.settingType ===
                (splitPathInVchType === Voucher_Type.Income
                  ? SettingsSections.Receipt
                  : SettingsSections.Payment)
            );

          const data = {
            voucherTitle: {
              id: selVoucherTemplate?.id,
              name: selVoucherTemplate?.title,
            },
            amountSummary: {
              totalInvoiceAmount: x?.amount,
              roundOff: { roundOffApplicable: false, roundOffAmount: 0 },
            },
            editId: x?.editId,
            instantPayment: true,
            amount: x?.amount,
            payRecReference: x?.payRecReference,
            effectiveLedger: [
              {
                id: x?.name?.value,
                amount: x?.amount,
                partyOrTax: x?.name?.title,
              },
            ],
            isReconciled: x?.editId
              ? x?.isReconciled
              : location.state?.ledgerId && !index
              ? ReconciledFilter.reconciled
              : ReconciledFilter.nonreconciled,
            bankImportEntryRef: x?.editId
              ? x.bankImportEntryRef
              : location.state?.ledgerId && !index
              ? location.state?.bankEntriesId
              : "",
            date: currentInvoiceDetails.date,
            isLocked: false,
            isAudited: false,
            isActive: true,
            partyLedger: [
              {
                id: currentInvoiceDetails?.partyLedger[0]?.id,
                amount: x?.amount,
                partyOrTax: Party_Tax.party,
                value: x?.amount,
                ref: [
                  {
                    refType: RefType.AgnstRef,
                    value: x?.amount,
                    name: saveInvoiceReferences?.name,
                    id: x?.partyRefId,
                    parentRef: saveInvoiceReferences?.id,
                  },
                ],
              },
            ],
          };

          if (data.amount > 0 && data.effectiveLedger[0]?.id) {
            try {
              const res = await VoucherServices.postVoucher(
                currentClient?.id!,
                splitPathInVchType === Voucher_Type.Income
                  ? Voucher_Type.Receipt
                  : Voucher_Type.Payment,
                data,
                // props.
                data?.editId
              );
              if (res.result) {
                if (index === 0) {
                  postSucessData = {
                    id: res.result?.id,
                    name: res.result?.name,
                    voucherType: res.result?.voucherType,
                  };
                  // setAfterSaveData({
                  //   id: res.result?.id,
                  //   name: res.result?.name,
                  //   voucherType: res.result?.voucherType,
                  // });
                }
                openNotification(
                  "success",
                  `Payment ${res.result?.name} ${
                    data?.editId
                      ? "updated successfully."
                      : "added successfully."
                  }`
                );
              } else if (res.message) {
                openNotification("error", res.message);
                setLoading(false);
              }
              index++;
            } catch (ex: any) {
              openNotification("error", ex.message);
              console.log("Error for ID:", x?.id, ex);
              setLoading(false);
            }
          }
        }
        if (deletePaymentDetails?.length > 0) {
          setIsDeletePaymentApi(true);
        } else {
          onPostSuccess(postSucessData);
        }
      } catch (ex) {
        ex && openNotification("error", ex);
        console.log("Error for ID:", ex);
        setLoading(false);
      } finally {
        // setSaveButtonLoading(false);
        isSaveAndNew ? setSaveNewLoading(false) : setUpdateAndNewButton(false);
        setLoading(false);
      }
    };

    if (
      saveInvoiceReferences?.id &&
      currentInvoiceDetails?.bankDts[0]?.name?.value
    ) {
      // setSaveButtonLoading(true);
      isSaveAndNew ? setSaveNewLoading(true) : setUpdateAndNewButton(true);
      paymentAdd();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveInvoiceReferences, currentInvoiceDetails]);

  // delete payment api
  useEffect(() => {
    // console.log("deleteCreditNote.id", deletePaymentIn?.id);
    const deletePaymentVoucher = async () => {
      try {
        // setSaveButtonLoading(true);
        isSaveAndNew ? setSaveNewLoading(true) : setUpdateAndNewButton(true);
        for (const x of deletePaymentDetails) {
          if (x?.editId) {
            await VoucherServices.deleteVoucher(currentClient?.id!, x?.editId)
              .then((res) => {
                if (res?.result) {
                  openNotification(
                    "success",
                    `Voucher ${x?.paymentNumber} deleted successfully.`
                  );
                }
              })
              .catch((err) => {
                openNotification("error", err.message);
              });
          }
        }
        onPostSuccess();
      } catch (err: any) {
        console.error("error", err);
      } finally {
        // setSaveButtonLoading(false);
        isSaveAndNew ? setSaveNewLoading(false) : setUpdateAndNewButton(false);
      }
    };

    if (isDeletePaymentApi || triggerDeletePaymentApi) {
      deletePaymentVoucher();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeletePaymentApi, triggerDeletePaymentApi]);

  const onPostSuccess = (afterSave?: any) => {
    // import transaction save voucher
    if (location.state?.ledgerId) {
      navigate(
        `/billing/clients/${currentClient?.id}/banking/bankTransactionsDetails/${location.state?.bankEntriesId}`,
        {
          state: {
            ledgerId: location.state?.ledgerId,
            bankImportIndex: location.state?.bankImportIndex,
            voucherRef: [afterSave],
          },
        }
      );
    }
    // Save & New - Update & New
    else if (isSaveAndNew) {
      form.resetFields();
      setFooterLedger({
        ledgerAmount: 0,
        ledgerGstAmount: 0,
        ledgerTotalAmount: 0,
      });
      setBankAccountAmt(0);
      form.setFieldValue("dueDate", dayjs(dateFiled).add(dueOnSetting, "d"));
      setRefreshNumber(!refreshNumber);
      setItemLength(0);
    } else {
      navigate(-1);
    }
  };

  // Post Draft
  const saveDrift = async () => {
    try {
      const val = form.getFieldsValue();
      console.log("post Deaft Date: " + val);

      const freightInsLedgers = val?.freightInsLedgers?.map((exp: any) => {
        return {
          ...exp,
          id: exp?.id?.value,
          gstRate: exp?.gstRate?.value && {
            id: exp?.gstRate?.value,
            rate: exp?.gstRate?.title,
            name: exp?.gstRate?.label,
          },
          costCentresDetail: exp?.costCentres?.map((cc: any) => {
            return {
              id: cc?.costCentreName?.value,
              value: cc?.amount,
              qty: 1,
            };
          }),
        };
      });

      const partyLedger = new Array({
        id: val?.partyLedger?.value,
        PartyOrTax: Party_Tax.party,
        amount: Utils.getNumber(
          Utils.getNumber(footerLedger.ledgerTotalAmount) -
            Math.round(cashDiscountRs * 100) / 100 +
            roundOffAmount
        ),
        transactionId:
          transactionId.partyId === "" ? null : transactionId.partyId,
      });

      const instantPayLedgersDetails = val?.bankDts?.map((itm: any) => {
        return {
          ledgerId: itm.name?.value,
          ledgerName: itm.name?.label,
          payRecReference: itm?.payRecReference,
          amount: itm?.amount,
        };
      });

      const adjustDateToCurrentTime = (date: any) => {
        const currentTime = new Date();
        // Set the time part of the date to match the current time
        date.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds(),
          currentTime.getMilliseconds()
        );

        return date;
      };

      let adjustedGivenDate = adjustDateToCurrentTime(new Date(val.date));
      let adjustedDueGivenDate = adjustDateToCurrentTime(new Date(val.dueDate));

      if (updateId) {
        adjustedGivenDate = dayjs(val.date).isSame(dayjs(editDate), "day")
          ? editDate
          : adjustedGivenDate;

        adjustedDueGivenDate = dayjs(val.dueDate).isSame(
          dayjs(editDueDate),
          "day"
        )
          ? editDueDate
          : adjustedDueGivenDate;
      }

      // console.log("date",adjustedGivenDate, dayjs(adjustedGivenDate).toISOString());

      const draftData = {
        ...val,
        voucherTitle: {
          id: selectCustomizationTemplete.templateId,
          name: selectCustomizationTemplete.title,
        },
        tcsApplicable: tdsOrTcs === 1 ? true : false,
        billingAddress: {
          ...val?.billingAddress,
          type: val?.billingAddress?.title,
          addressName: val?.billingAddress?.value,
        },
        shippingAddress: {
          ...val?.shippingAddress,
          type: val?.shippingAddress?.title,
          addressName: val?.shippingAddress?.value,
        },
        // shippingAddress: val?.shippingAddress?.type
        //   ? val.shippingAddress
        //   : { address: val?.shippingAddress?.address },
        tcsDetail: tdsOrTcs
          ? {
              id: val?.tcsDetail?.value,
              name: val?.tcsDetail?.label,
              rate: val?.tcsDetail?.title,
              value: totalTcs,
            }
          : null,
        tdsApplicable: tdsOrTcs ? false : true,
        tdsDetail: tdsOrTcs
          ? null
          : {
              id: val?.tdsDetail?.value,
              name: val?.tdsDetail?.label,
              rate: val?.tdsDetail?.title,
              value: totalTds,
              transactionType: tdsPostDetail.transactionType,
              form: tdsPostDetail.formNo,
            },
        isPurchaseJVVoucher: true,
        nature: voucherNature,
        isShippingAddressSame: isSameBillingAddress,
        isGSTVoucher:
          currentClient?.gstType === CompanyGSTTypes.Regular ||
          updateTimeData.isGSTVoucher ||
          splitPathInVchType !== Voucher_Type.Income,

        instantPayLedgersDetails: instantPayLedgersDetails,
        bankAmount: bankAccountAmt,
        instantPayment: bankAccountAmt > 0 ? true : false,
        purchaseOrderRef: { id: val?.purchaseOrderRef?.value },
        date: dayjs(adjustedGivenDate).toISOString(),
        dueDate: dayjs(adjustedDueGivenDate).toISOString(),
        freightInsLedgers,
        partyLedger,
        despatchDetail: invoiceDespatchDetails,
        // exportDetail: invoiceExportDetails,

        isStateSame: isStateSame,
        billState: currentCustomerState,
        amountSummary: {
          tCSRate: val?.tcsDetail?.title,
          tCSAmt: totalTcs,
          tDSRate: val?.tdsDetail?.title,
          tDSAmt: totalTds,
          totalQty: 0,
          // taxableAmount: Utils.getFormattedNumber(
          //   Utils.getNumber(footerTotal?.taxableAmount) - footerTotal?.discount
          // ), // befor gst
          taxableAmount: 0,
          totalDis: 0,
          freightAmount: 0,
          cessAmount: 0,
          igstAmt: !isStateSame ? footerLedger.ledgerGstAmount : 0,
          cgstAmt: isStateSame ? footerLedger.ledgerGstAmount / 2 : 0,
          sgstAmt: isStateSame ? footerLedger.ledgerGstAmount / 2 : 0,
          // roundOffAmount: roundOffAmount,
          roundOff: {
            roundOffApplicable: val?.roundoffCheckbox,
            roundOffAmount: roundOffAmount,
          },
          cashDiscount: {
            discountRate:
              val.cashDiscountDrop === DiscountType.PercentageDiscount
                ? val.cashDiscount ?? 0
                : 0,
            discountAmount: cashDiscountRs,
          },
          totalInvoiceAmount:
            Utils.getNumber(footerLedger.ledgerTotalAmount) +
            roundOffAmount -
            cashDiscountRs +
            totalTcs -
            totalTds,
          receivedAmount: 0,
          voucherAmountWithoutTCS:
            Utils.getNumber(footerLedger.ledgerTotalAmount) - balance,
        },
      };

      const saveDraftData = await DraftService.postVoucherDraft(
        currentClient?.id!,
        splitPathInVchType === Voucher_Type.Expenses
          ? Voucher_Type.Expenses
          : Voucher_Type.PurchaseVoucher,
        draftData,
        draftId
      );

      if (saveDraftData.result) {
        openNotification(
          "success",
          `Draft ${draftId ? "updated successfully." : "added successfully."}`
        );
      } else if (saveDraftData.message) {
        openNotification("error", saveDraftData?.message);
      }
    } catch (ex: any) {
      openNotification("error", ex);
    }

    // .then((res) => {
    //   if (res) {
    //   }
    // });
  };

  EntryLevelKeys({
    save: () => addExpensesIncome(),
    cancel: () => navigate(-1),
    saveAndNew: () => addExpensesIncome(),
  });
  // ----- Serch customer Api -----
  useEffect(() => {
    const customer = async () => {
      setPartyDropDownLoading(true);

      setLoading(true);
      inputRef.current?.focus();
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.PartiesOnly
      )
        .then((res: any) => {
          if (res) {
            // debugger;
            // form.setFieldValue("date", dayjs());
            // form.setFieldValue("dueDate", dayjs().add(7, "d"));

            // form.setFieldValue(
            //   "dueDate",
            //   dayjs().add(
            //     companySettings?.setting?.dueOn?.duration
            //       ? companySettings?.setting?.dueOn?.duration
            //       : 0,
            //     companySettings?.setting?.dueOn?.durationUnit === TimeUnits.Day
            //       ? "d"
            //       : companySettings?.setting?.dueOn?.durationUnit ===
            //         TimeUnits.Week
            //       ? "w"
            //       : companySettings?.setting?.dueOn?.durationUnit ===
            //         TimeUnits.Month
            //       ? "month"
            //       : "y"
            //   )
            // );
            setOnlyEditTimeCustomerOptions(true);
            setCustomerOptions(res);
            setPartyDropDownLoading(false);
            SetCheckIsPartyApiCall(true);
            // console.log(customerOptions, "getledger");
            // if (!updateId) {
            // }
          }
          setLoading(false);
        })
        .catch((ex: any) => {
          console.error("error", ex);
          setLoading(false);
          setPartyDropDownLoading(false);
        });
    };
    customer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // ----- Set customer to party Balance  ------
  React.useEffect(() => {
    if (partyId) {
      PartyService.getPartytDetailsById(currentClient?.id!, partyId!)
        .then((result: any) => {
          if (result) {
            console.log("Result", result);
            form.setFieldsValue({
              phoneNo: result?.defaultContact?.phone,
              billingAddress: result?.bAddress,
              shippingAddress: result?.sAddress,
              supplyState: result?.state !== 0 ? result?.state : undefined,
              receivedAmount: result.amountSummary?.receivedAmount,
              partyLedger: {
                value: result?.id,
                label: result?.bName,
              },
              narration: result?.narration,
            });
            setEditParty({ id: result?.id });
            setSelectedParty(result?.id);
            // setCurrentCustomerState(result?.state);
          }
        })
        .catch((err) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyId]);
  console.log("term", termNCondData);

  // console.log("newItemData", itemsOption);

  //------- Set partner Data After Adding ledger ------
  useEffect(() => {
    if (addLedgerResponse?.id) {
      console.log("addLedgerResponse", addLedgerResponse);
      let newSupplierData = Utils.getNewlyAddedLedgerData(addLedgerResponse);
      if (apiCallField === "New Supplier") {
        if (addLedgerResponse.isEdited)
          setCustomerOptions((pre) =>
            updateListWithNewValue(pre, newSupplierData, false)
          );
        else {
          setCustomerOptions((pre: ILedgerSearchByGroupNameResponse[]) => {
            const newData = [...pre, addLedgerResponse];
            return newData;
          });
        }
      } else if (apiCallField === "New Ledger") {
        setFreightAndInsuranceOptions(
          (pre: ILedgerSearchByGroupNameResponse[]) => {
            const newData = [...pre, newSupplierData];
            return newData;
          }
        );
      } else if (apiCallField === "Add Bank") {
        setBankAccountList((pre: ILedgerSearchByGroupNameResponse[]) => {
          const newData = [...pre, newSupplierData];
          return newData;
        });
        setSelectedBankLedger((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[newBankAccountAddedIndex!] =
            addLedgerResponse?.id;
          return updatedSelectedOptions;
        });

        setSelectedBankPartyOrTax((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[newBankAccountAddedIndex!] =
            addLedgerResponse?.partyOrTax!;
          return updatedSelectedOptions;
        });
        setSelectedBankBalance((x: any) => {
          const updatedSelectedOptions = [...x];
          updatedSelectedOptions[newBankAccountAddedIndex!] = 0.0;
          return updatedSelectedOptions;
        });
      }
    }
  }, [addLedgerResponse]);
  useEffect(() => {
    if (addLedgerResponse) {
      const exists = customerOptions.some(
        (option) => option.id === addLedgerResponse.id
      );
      if (exists) {
        form.setFieldValue("partyLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
        });
        let isEdited = addLedgerResponse.isEdited ? false : true;
        CustomerSelect(addLedgerResponse?.id, false, isEdited);
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerOptions]);

  //------- Set other expense Data After Adding ledger ------
  useEffect(() => {
    try {
      if (addLedgerResponse) {
        const exists = freightAndInsuranceOptions.some(
          (option: any) => option.id === addLedgerResponse.id
        );
        if (exists) {
          let freightInsLedgers = [
            ...(form.getFieldValue("freightInsLedgers") || []),
          ];
          console.log("freightInsLedgers", freightInsLedgers);
          if (newLedgerAddedIndex === freightInsLedgers.length - 1) {
            freightInsLedgers.pop();
            freightInsLedgers.push({
              id: {
                label: addLedgerResponse?.ledgerName,
                value: addLedgerResponse.id,
                key: addLedgerResponse.id,
              },
            });

            freightInsLedgers.push({
              // gstRate: 0,
              gstAmount: 0,
              totalAmount: 0,
              id: {
                label: "",
                value: "",
                key: "",
              },
            });
          } else {
            freightInsLedgers[newLedgerAddedIndex] = {
              id: {
                label: addLedgerResponse?.ledgerName,
                value: addLedgerResponse.id,
                key: addLedgerResponse.id,
              },
            };
          }
          form.setFieldValue("freightInsLedgers", freightInsLedgers);
          freightInsLedgersSelect(addLedgerResponse.id, newLedgerAddedIndex);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freightAndInsuranceOptions]);
  //--------------   set Newly Added Bank Details in form -----------------------
  useEffect(() => {
    if (addLedgerResponse?.id) {
      let exist = bankAccountList.some((e) => e.id === addLedgerResponse?.id);
      let preData = [...form.getFieldValue("bankDts")];
      if (exist) {
        if (newBankAccountAddedIndex === 0) {
          preData[0] = {
            name: {
              key: addLedgerResponse?.id,
              value: addLedgerResponse?.id,
              label: addLedgerResponse?.ledgerName,
              title: "",
            },
            payRecReference: "",
            amount: 0.0,
          };
          let BankDetails = form.getFieldValue(["bankDts", 0, "name"]);
          !BankDetails &&
            preData.push({
              name: {
                key: "",
                value: "",
                label: "",
                title: "",
              },
              pyaRecReference: "",
              amount: 0.0,
            });
        } else {
          preData[1] = {
            name: {
              key: addLedgerResponse?.id,
              value: addLedgerResponse?.id,
              label: addLedgerResponse?.ledgerName,
              title: "",
            },
            payRecReference: "",
            amount: 0.0,
          };
        }
        form.setFieldValue("bankDts", preData);
      }
      setAddLedgerResponse(null);
    }
  }, [bankAccountList]);
  //----- Bank (ledger) Account Get Api -----
  useEffect(() => {
    // if (settingControl?.showReceipt || editInvBankDetails?.length > 0) {
    setbankAccountDropDownLoading(true);
    const bankLedger = async () => {
      await LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.BankAndCash
      )
        .then((res: any) => {
          if (res) {
            // console.log("data..1111.", res);
            setBankAccountList(res);
            setbankAccountDropDownLoading(false);
            SetCheckIsBankApiCall(true);
          }
        })
        .catch((ex: any) => {
          // setBankLoading(false);
          setBankAccountList([]);
          setbankAccountDropDownLoading(false);
        });
    };
    bankLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }
  }, [currentClient]);

  // const handelTwoDigitAfterDecimal = (e: any) => {
  //   if (!/\d|\./.test(e.key)) e.preventDefault();
  //   if (e.key === "." && e.target.value && e.target.value.includes("."))
  //     e.preventDefault();
  // };

  React.useEffect(() => {
    // update invoice time Customer address set
    if ((updateId || cloneId) && selectedParty && onlyEditTimeCustomerOptions) {
      setOnlyEditTimeCustomerOptions(false);
      CustomerSelect(selectedParty, onlyEditTimeCustomerOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerOptions, selectedParty]);

  // Customer select
  const CustomerSelect: any = async (
    value: string,
    onlyFirstEdit: boolean = false,
    newData: boolean = false
  ) => {
    purchaseOrderRef && form.setFieldValue("purchaseOrderRef", "");
    console.log("customerAddress CustomerSelect", value, onlyFirstEdit);
    if (value) {
      let findCutomerDetails = customerOptions.find(
        (Ledgerlist: any) => Ledgerlist?.id === value
      );

      if (!onlyFirstEdit) {
        if (findCutomerDetails?.payTerms?.creditPeriod > 0) {
          form.setFieldValue(
            "dueDate",
            dayjs(dateFiled).add(
              findCutomerDetails?.payTerms?.creditPeriod,
              "d"
            )
          );
          setDueOnParty(findCutomerDetails?.payTerms?.creditPeriod);
        } else {
          form.setFieldValue(
            "dueDate",
            dayjs(dateFiled).add(dueOnSetting, "d")
          );
          setDueOnParty(0);
        }
        if (splitPathInVchType === Voucher_Type.Expenses) {
          // TypeOfAddress.RegisteredAddress,
          if (findCutomerDetails?.addresses) {
            customerAddSelect(
              findCutomerDetails?.addresses[0]?.addressName,
              findCutomerDetails?.addresses[0]?.type,
              AddressEnum.BillingAddress,
              findCutomerDetails?.addresses
            );
          } else {
            form.setFieldValue(["billingAddress", "address"], "");
            form.setFieldValue(["billingAddress", "type"], {});
          }

          // setCustomerAddress(findCutomerDetails?.addresses);
        } else {
          setPurchasePartyState(findCutomerDetails?.state);
          form.setFieldValue(
            "supplyState",
            findCutomerDetails?.state !== 0
              ? findCutomerDetails?.state
              : undefined
          );
          form.validateFields(["supplyState"]);
        }
      }
      // if (splitPathInVchType === Voucher_Type.Expenses) {
      setEditParty({ id: value });
      setSelectedParty(value);

      //TODO : Check its working
      // setCustomerAddress(findCutomerDetails?.addresses);
      // }
      if (splitPathInVchType === Voucher_Type.Income) {
        setCustomerAddress(findCutomerDetails?.addresses);
      }
      if (!newData) {
        // get party ref (payment invoice no.)
        await VoucherServices.getReferencesByParty(
          currentClient?.id!,
          value,
          splitPathInVchType === Voucher_Type.Expenses
            ? Voucher_Type.Expenses
            : Voucher_Type.PurchaseVoucher
        )
          .then((res: any) => {
            console.log(res);
            if (res) {
              // console.log("res............", res);
              setNewPartyRecepitDetails(
                res?.result?.map((x: any, index: number) => {
                  return {
                    key: index,
                    // date: dayjs(x?.date),
                    id: x?.id,
                    refNo: x?.refNo,
                    dueAmount: x?.dueAmount,
                  };
                })
              );
            }
          })
          .catch((ex: any) => {
            console.log(ex.message);
          });
      }
    }
  };

  // onChange in address type
  const customerAddSelect: any = (
    typeOfAddressName: string,
    typeOfAddress: TypeOfAddress,
    addressEnum: AddressEnum,
    addressTotal: any[]
  ) => {
    if (typeOfAddressName) {
      let findAddress: any;
      if (addressTotal?.length > 0) {
        findAddress = addressTotal?.find(
          (type: any) => type?.addressName === typeOfAddressName
        );
      } else if (customerAddress?.length > 0) {
        findAddress = customerAddress?.find(
          (type: any) => type?.addressName === typeOfAddressName
        );
      }
      // console.log("Hello findAddress", findAddress);

      if (findAddress?.address) {
        // console.log("findAddress.....", findAddress?.address);
        // const objectofaddress1: any[] = [];
        let objectofaddress1: string = "";
        Object.keys(findAddress?.address).forEach((key: any) => {
          // console.log("key...........", key);
          switch (key) {
            case "building":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "street":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "building")
                objectofaddress1 += "\n";
              break;
            case "landmark":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "city":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "landmark")
                objectofaddress1 += "\n";
              break;
            case "district":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
              break;
            case "pincode":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", " + "\n";
              else if (findAddress?.address[key] === "district")
                objectofaddress1 += "\n";
              break;
            case "state":
              objectofaddress1 +=
                getIndianStates(findAddress?.address[key]) + ", ";
              // console.log(
              //   "state",
              //   findAddress?.address[key],
              //   currentClient?.state!
              // );

              if (splitPathInVchType === Voucher_Type.Expenses) {
                if (findAddress?.address[key]) {
                  setCurrentCustomerState(findAddress?.address[key]);
                } else {
                  setCurrentCustomerState(currentClient?.state!);
                }
              } else {
                setPurchasePartyState(findAddress?.address[key]);
                if (
                  addressEnum === AddressEnum.BillingAddress &&
                  splitPathInVchType === Voucher_Type.Income
                ) {
                  form.setFieldValue(
                    "supplyState",
                    findAddress?.address[key] !== 0
                      ? findAddress?.address[key]
                      : undefined
                  );
                  form.validateFields(["supplyState"]);
                }
              }
              // previous code
              // if (findAddress?.address[key]) {
              //   setPurchasePartyState(findAddress?.address[key]);
              //   if (
              //     addressEnum === AddressEnum.BillingAddress &&
              //     splitPathInVchType === Voucher_Type.Expenses
              //   ) {
              //     form.setFieldValue(
              //       "supplyState",
              //       findAddress?.address[key] !== 0
              //         ? findAddress?.address[key]
              //         : undefined
              //     );
              //     form.validateFields(["supplyState"]);
              //   }
              // } else {
              //   setPurchasePartyState(currentClient?.state!);
              // }
              break;
            case "country":
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key];
              break;
            default:
              if (findAddress?.address[key])
                objectofaddress1 += findAddress?.address[key] + ", ";
          }
        });
        if (addressEnum === AddressEnum.BillingAddress) {
          form.setFieldValue(["billingAddress", "address"], objectofaddress1);
          form.setFieldValue(["billingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
          if (objectofaddress1) {
            form.validateFields([["billingAddress", "address"]]);
          }
          if (isSameBillingAddress) {
            form.setFieldValue(
              ["shippingAddress", "address"],
              objectofaddress1
            );
            form.setFieldValue(["shippingAddress", "type"], {
              value: typeOfAddressName,
              label: typeOfAddressName,
              title: typeOfAddress,
            });
          }
        } else {
          form.setFieldValue(["shippingAddress", "address"], objectofaddress1);
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
      } else {
        if (addressEnum === AddressEnum.BillingAddress) {
          form.setFieldValue(["billingAddress", "address"], "");
          form.setFieldValue(["billingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
          if (isSameBillingAddress) {
            form.setFieldValue(["shippingAddress", "address"], "");
            form.setFieldValue(["shippingAddress", "type"], {
              value: typeOfAddressName,
              label: typeOfAddressName,
              title: typeOfAddress,
            });
          }
        } else {
          form.setFieldValue(["shippingAddress", "address"], "");
          form.setFieldValue(["shippingAddress", "type"], {
            value: typeOfAddressName,
            label: typeOfAddressName,
            title: typeOfAddress,
          });
        }
        // if (splitPathInVchType === Voucher_Type.PurchaseVoucher) {
        //   setCurrentCustomerState(-1);
        // }
      }
    } else {
      form.setFieldValue(["billingAddress", "address"], "");
      form.setFieldValue(["billingAddress", "type"], {});
    }
  };

  const handleAllTheTotalValues = (
    isTcsTds?: number,
    panType?: PanCardType
  ) => {
    // cash discount
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");

    const totalSumIncludedGst = footerLedger.ledgerTotalAmount;
    const totalSumExcludedGst = footerLedger.ledgerAmount;
    // ----- Calculate item's total amount with discount -----
    // const AmountAfterDisc = ItemList.reduce((acc: number, curr: any) => {
    //   return (acc += amountWithoutTax(curr));
    // }, 0);

    let cashDiscountAmount: number = 0.0;
    // console.log("discount", totalSum, discount, discountType, typeof discount);
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        // debugger;
        // if (tdsOrTcs === 0 && form.getFieldValue("tdsDetail")?.title) {
        //   cashDiscountAmount = percentCal(
        //     totalSumExcludedGst + totTcs - totTds,
        //     discount
        //   );
        // } else {
        cashDiscountAmount = percentCal(totalSumIncludedGst, discount);
        // }
        setCashDiscountRs(cashDiscountAmount);
      } else {
        cashDiscountAmount = discount;
        setCashDiscountRs(cashDiscountAmount);
      }
    } else {
      setCashDiscountRs(0.0);
    }

    let totTcs = 0;
    let totTds = 0;
    if (isTcsTds ?? tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(
        totalSumIncludedGst - cashDiscountAmount,
        tcsRate?.title
      );
      setTotalTcs(totTcs);
      setTotalTds(0);
      setTcsTdsPercentage(tcsRate?.title);
    } else {
      //----- Calculate TDS amount -----
      const tdsRate = form.getFieldValue("tdsDetail");
      const type = panType ?? partyPanCard;

      const tdsPredentage =
        type === PanCardType.HUF
          ? tdsRate?.title?.rates?.indHUFRate ?? tdsRate?.title
          : type === PanCardType.Other
          ? tdsRate?.title?.rates?.otherRate ?? tdsRate?.title
          : tdsRate?.title?.rates?.ifPANNotRate ?? tdsRate?.title;

      setTcsTdsPercentage(tdsPredentage);
      // totTds = percentCal(
      //   totalSumExcludedGst - cashDiscountAmount,
      //   tdsPredentage
      // );

      // console.log("Tds Rate", tdsPredentage, totTds);
      // setTotalTds(totTds);
      setTotalTcs(0);
    }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM
        ? footerLedger.ledgerAmount - cashDiscountAmount + totTcs - totTds
        : footerLedger.ledgerTotalAmount - cashDiscountAmount + totTcs - totTds;

    const roundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", roundOffAmount);
    setRoundoffAmount(roundOffAmount);
  };

  // Freight And InsLedger total in fotter
  const handleFreightAndInsLedgerTotal = () => {
    const LedgerAllList = form.getFieldValue(["freightInsLedgers"]);

    //----- Total Row Calculations---------
    const AmountLedger = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.amount));
    }, 0);

    const Total = LedgerAllList.reduce(
      (
        acc: {
          amount: number;
          gstAmount: number;
          totalAmount: number;
        },
        curr: any
      ) => {
        acc.amount += Utils.getNumber(curr?.amount);
        acc.gstAmount += Utils.getNumber(curr?.gstAmount);
        acc.totalAmount += Utils.getNumber(curr?.totalAmount);
        return acc;
      },
      {
        amount: 0,
        gstAmount: 0,
        totalAmount: 0,
      }
    );
    // console.log("totalvalueoftheledger", Total);

    setFooterLedger({
      ledgerAmount: Total.amount,
      ledgerGstAmount: Total.gstAmount,
      ledgerTotalAmount: Total.totalAmount,
    });

    // ----- Calculate items total unit Price -----
    const TotalLedgerAmount = LedgerAllList.reduce((acc: number, curr: any) => {
      return (acc += amountInNumber(curr, "totalAmount"));
    }, 0);
    setLedgerAmount(TotalLedgerAmount);

    // cash discount
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");

    const totalSum = Total.totalAmount;
    let cashDiscountAmount: number = 0.0;
    // console.log("discount", totalSum, discount, discountType, typeof discount);
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        cashDiscountAmount = percentCal(totalSum, discount);
        setCashDiscountRs(cashDiscountAmount);
      } else {
        cashDiscountAmount = discount;
        setCashDiscountRs(cashDiscountAmount);
      }
    } else {
      setCashDiscountRs(0.0);
    }

    let totTcs = 0;
    let totTds = 0;
    if (tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSum, tcsRate?.title);
      console.log("Tcs Rate", tcsRate, totTcs);

      setTotalTcs(totTcs);
    } else {
      //----- Calculate TDS amount -----
      // const tdsRate = form.getFieldValue("tdsDetail");
      // totTds = percentCal(totalSum, tdsRate?.title);
      // console.log("Tds Rate", tdsRate, totTds);
      // setTotalTds(totTds);
    }

    // roundOff
    const totalAmount =
      voucherNature === Voucher_Nature.RCM
        ? Total.ledgerAmount - cashDiscountAmount + totTcs - totTds
        : Total.totalAmount - cashDiscountAmount + totTcs - totTds;

    // -
    // (voucherNature === Voucher_Nature.RCM
    //   ? footerTotal.gst + Total.gstAmount
    //   : 0);

    const roundOffAmount = handleRoundoff(
      totalAmount,
      form.getFieldValue("roundoffCheckbox"),
      settingControl.roundOffType
    );

    form.setFieldValue("roundOff", roundOffAmount);
    setRoundoffAmount(roundOffAmount);
  };

  // on chnage in Freight And InsLedger unit price & gst
  const handleLedgerNetAmount = (index: number) => {
    const Ledgerlist = form.getFieldValue(["freightInsLedgers"]);
    const currentLedgerIndexData = Ledgerlist[index];
    // console.log(
    //   "currentLedgerIndexData",
    //   currentLedgerIndexData
    // currentLedgerIndexData,
    // Utils.getFormattedNumber(gstamount(currentLedgerIndexData)),
    // ledgertotalamout(currentLedgerIndexData)
    // );
    if (currentLedgerIndexData) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentLedgerIndexData,
        gstAmount: Utils.getNumber(gstamount(currentLedgerIndexData)),
        // totalAmount: Utils.getNumber(currentLedgerIndexData?.amount),
        totalAmount: Utils.getNumber(ledgertotalamout(currentLedgerIndexData)),
      });
      handleFreightAndInsLedgerTotal();
    }
  };

  const onLedgerTotalAmountChange = async (index: number) => {
    const LedgerList = form.getFieldValue(["freightInsLedgers"]);
    const currentIndexData = LedgerList[index];
    // console.log("currentIndexData", currentIndexData.totalAmount);

    //Calculate the denominator for various calculations
    const denominators = gstrate(currentIndexData);
    // console.log("denominators", denominators);

    const ledgernetAmount =
      (Utils.getNumber(currentIndexData.totalAmount) / (100 + denominators)) *
      100;
    // console.log("gstAmount", ledgernetAmount);

    const gstAmount =
      Utils.getNumber(currentIndexData.totalAmount) - ledgernetAmount;
    // console.log("ledgernetAmount...", gstAmount);

    if (ledgernetAmount > 0) {
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: Utils.getNumber(ledgernetAmount),
        gstAmount: Utils.getNumber(gstAmount),
        // totalAmount: Utils.getFormattedNumber(
        //   ledgertotalamout(currentIndexData)
        // ),
      });
    } else {
      // ledgernetAmount is zero or negative, set all fields to 0
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentIndexData,
        amount: Utils.getNumber(ledgernetAmount),
        gstAmount: Utils.getNumber(gstAmount),
      });
    }
    handleFreightAndInsLedgerTotal();
  };

  // Include Other Expenses (Indirect Income expenses) select
  const freightInsLedgersSelect: any = async (value: any, index: number) => {
    // console.log("value11.............", value, index);

    const currentSelectLedger = freightAndInsuranceOptions.find(
      (x: any) => x.id === value
    );

    if (currentSelectLedger) {
      const currentData = form.getFieldValue(["freightInsLedgers", index]);

      console.log("currentSelectLedger.............", currentData);
      form.setFieldValue(["freightInsLedgers", index], {
        ...currentData,
        id: {
          value: currentSelectLedger?.id,
          label: currentSelectLedger.ledgerName,
        },
        itcEligibilityType:
          splitPathInVchType === Voucher_Type.Expenses
            ? currentData?.itcEligibilityType
            : null,
        amount: currentData?.amount,
        gstRate: (currentClient?.gstType === CompanyGSTTypes.Regular ||
          updateTimeData.isGSTVoucher ||
          splitPathInVchType !== Voucher_Type.Income) &&
          currentSelectLedger?.gstRate?.name && {
            value: currentSelectLedger?.gstRate?.id,
            label: currentSelectLedger?.gstRate?.name,
            title: currentSelectLedger?.gstRate?.rate,
          },
        gstAmount: Utils.getNumber(gstamount(currentData)),
        totalAmount: Utils.getNumber(ledgertotalamout(currentData)),
      });
    }
    setLedgerLength(index + 1);
    handleFreightAndInsLedgerTotal();
    setSelectedOtherExpenses((prevState) => {
      const updatedSelectedOptions = [...prevState];
      updatedSelectedOptions[index] = value;
      return updatedSelectedOptions;
    });

    const shoudValidate = currentSelectLedger?.costCentres?.length! < 1;
    setUnallottedAmounts((prev: any) => {
      const newAmounts = [...prev];
      newAmounts[index] = {
        ...newAmounts[index],
        validate: shoudValidate,
      };
      return newAmounts;
    });

    // console.log("currentSelectLedger", currentSelectLedger);
  };

  const hangleCashDisCount = () => {
    const discount = form.getFieldValue("cashDiscount");
    const discountType = form.getFieldValue("cashDiscountDrop");
    const totalSum =
      voucherNature === Voucher_Nature.RCM
        ? footerLedger.ledgerAmount
        : footerLedger.ledgerTotalAmount;
    // console.log("discount", totalSum, discount, discountType, typeof discount);

    let totalSumIncludedGstLessCashDiscount = footerLedger.ledgerTotalAmount;

    let totalSumExcludedGstLessCashDiscount = footerLedger.ledgerAmount;

    let roundOffAmount = 0;
    if (discount > 0) {
      if (discountType === DiscountType.PercentageDiscount) {
        const percentDis = percentCal(totalSum, discount);
        setCashDiscountRs(percentDis);

        totalSumIncludedGstLessCashDiscount =
          totalSumIncludedGstLessCashDiscount - percentDis;
        totalSumExcludedGstLessCashDiscount =
          totalSumExcludedGstLessCashDiscount - percentDis;

        roundOffAmount = handleRoundoff(
          totalSum - percentDis,
          form.getFieldValue("roundoffCheckbox"),
          settingControl.roundOffType
        );

        form.setFieldValue("roundOff", roundOffAmount);
        setRoundoffAmount(roundOffAmount);
        // console.log("")
        // console.log("footerTotal.taxableAmount", percentCal(totalSum, discount));
      } else {
        setCashDiscountRs(discount);
        roundOffAmount = handleRoundoff(
          totalSum - discount,
          form.getFieldValue("roundoffCheckbox"),
          settingControl.roundOffType
        );

        form.setFieldValue("roundOff", roundOffAmount);
        setRoundoffAmount(roundOffAmount);

        totalSumIncludedGstLessCashDiscount =
          totalSumIncludedGstLessCashDiscount - discount;
        totalSumExcludedGstLessCashDiscount =
          totalSumExcludedGstLessCashDiscount - discount;
        // console.log("RupeeDiscount", totalSum - discount);
      }
    } else {
      setCashDiscountRs(0.0);

      roundOffAmount = handleRoundoff(
        totalSum,
        form.getFieldValue("roundoffCheckbox"),
        settingControl.roundOffType
      );

      form.setFieldValue("roundOff", roundOffAmount);
      setRoundoffAmount(roundOffAmount);
    }

    let totTcs = 0;
    let totTds = 0;
    if (tdsOrTcs) {
      //----- Calculate TCS amount -----
      const tcsRate = form.getFieldValue("tcsDetail");

      totTcs = percentCal(totalSumIncludedGstLessCashDiscount, tcsRate?.title);
      console.log("Tcs Rate", tcsRate, tcsRate);

      setTotalTcs(totTcs);
      setTotalTds(0);
      setTcsTdsPercentage(tcsRate?.title);
    } else {
      //----- Calculate TDS amount -----
      const tdsRate = form.getFieldValue("tdsDetail");
      console.log("Tcs Rate", tdsRate);

      const type = partyPanCard;

      const tdsPredentage =
        type === PanCardType.HUF
          ? tdsRate.title?.rates?.indHUFRate ?? tdsRate?.title
          : type === PanCardType.Other
          ? tdsRate.title?.rates?.otherRate ?? tdsRate?.title
          : tdsRate.title?.rates?.ifPANNotRate ?? tdsRate?.title;

      setTcsTdsPercentage(tdsPredentage);
      // totTds = percentCal(totalSumExcludedGstLessCashDiscount, tdsPredentage);

      // console.log("Tds Rate", tdsPredentage, totTds);
      // setTotalTds(totTds);
      setTotalTcs(0);
    }
  };

  console.log("ItemId", itemsOption);

  // --------- Get TDS Option List API ---------
  React.useEffect(() => {
    const getTDSList = async (
      start: number,
      length: number,
      search?: string,
      status: LedgerStatus = LedgerStatus.active
    ) => {
      await TdsTcsServices.getTDSList(
        currentClient?.id!,
        start,
        length,
        search,
        status
      )
        .then((res: any) => {
          if (res.length > 0) {
            setTdsList(res);
          } else if (res.length === 0) {
            setTdsList([]);
          }
          // if (!updateId) {
          setLoading(false);
          // }
        })
        .catch((ex: any) => {
          console.error(ex.message);
          // if (!updateId) {
          setLoading(false);
          // }
          setTdsList([]);
        });
    };

    getTDSList(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPathInVchType, tdsListTrigger]);

  // --------- Get TCS TableData API ---------
  React.useEffect(() => {
    const getList = async (
      start: number,
      length: number,
      search?: string,
      status: LedgerStatus = LedgerStatus.active
    ) => {
      await TdsTcsServices.getTCSList(
        currentClient?.id!,
        start,
        length,
        search,
        status
      )
        .then((res: any) => {
          if (res.length > 0) {
            setTcsList(res);
          } else if (res.length === 0) {
            setTcsList([]);
          }
          // if (!updateId) {
          setLoading(false);
          // }
        })
        .catch((ex: any) => {
          console.error(ex.message);
          // if (!updateId) {
          setLoading(false);
          // }
          setTcsList([]);
        });
    };
    getList(0, 0);
  }, [tcsListTrigger]);

  useEffect(() => {
    if (dueDateTrigger) {
      form.setFieldValue(
        "dueDate",
        dayjs(
          form
            .getFieldValue("date")
            .add(presetsDueDate.label, presetsDueDate.value)
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dueDateTrigger]);

  console.log("loading", loading);

  const permissionLedgerAdd =
    splitPathInVchType === Voucher_Type.Income
      ? findUserOnlyOnePremission(
          "Master.Ledger.Income.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Expenses.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionPartyAdd =
    splitPathInVchType === Voucher_Type.Income
      ? findUserOnlyOnePremission(
          "Master.Ledger.Customer.Add",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Suppliers.Add",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionPartyEdit =
    splitPathInVchType === Voucher_Type.Income
      ? findUserOnlyOnePremission(
          "Master.Ledger.Customer.Edit",
          clientSpecificRole(),
          currentClient?.id
        )
      : findUserOnlyOnePremission(
          "Master.Ledger.Suppliers.Edit",
          clientSpecificRole(),
          currentClient?.id
        );

  const permissionCashAdd = findUserOnlyOnePremission(
    "Master.Ledger.Cash.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionBankAdd = findUserOnlyOnePremission(
    "Master.Ledger.Bank.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const calculateUnallotted = (ledgerIndex: any) => {
    const ledgers = form.getFieldValue("freightInsLedgers") || [];
    const currentLedger = ledgers[ledgerIndex] || {};
    const grossAmount = currentLedger?.totalAmount || 0;
    const costCenters = currentLedger?.costCentres || [];
    const totalAllotted = costCenters?.reduce(
      (sum: any, cc: any) => sum + (cc?.amount || 0),
      0
    );
    const Unallotted = grossAmount - totalAllotted;
    const shoudValidate =
      totalAllotted === 0 &&
      costCenters?.length > 1 &&
      grossAmount != 0 &&
      Unallotted != 0
        ? true
        : Unallotted !== 0 && costCenters?.length > 1
        ? true
        : false;
    setUnallottedAmounts((prev: any) => {
      const newAmounts = [...prev];
      newAmounts[ledgerIndex] = {
        unallottedAmount: Unallotted,
        validate: shoudValidate,
      };
      return newAmounts;
    });
  };

  const handleCostCenterSelect = (ledgerIndex: number, ccIndex: number) => {
    const ledgers = form.getFieldValue("freightInsLedgers") || [];
    const currentLedger = ledgers[ledgerIndex] || {};
    const grossAmount = currentLedger?.totalAmount || 0;
    const costCenters = currentLedger?.costCentres || [];
    const allottedToOthers = costCenters?.reduce(
      (sum: any, cc: any, index: number) => {
        if (index !== ccIndex && cc?.amount) {
          return sum + cc?.amount;
        }
        return sum;
      },
      0
    );

    const remainingAmount = grossAmount - allottedToOthers;
    if (remainingAmount > 0) {
      form.setFieldValue(
        ["freightInsLedgers", ledgerIndex, "costCentres", ccIndex, "amount"],
        remainingAmount
      );
      calculateUnallotted(ledgerIndex);
    }
  };

  console.log("costCenters after edit data:", selectedCostCentres);

  return (
    <>
      <Spin
        spinning={
          loading
          // ||
          // (updateId || cloneId || draftId
          //   ? customerOptions?.length === 0
          //   : false) ||
          // (settingControl?.showReceipt || editInvBankDetails?.length > 0
          //   ? bankAccountList?.length === 0
          //   : false)
        }
        indicator={<LoadingOutlined />}
        style={{ marginTop: "50px" }}
      >
        <Layout>
          <Header
            style={{
              background: "#fff",
              top: 0,
              width: "100%",
              margin: "0px -14px",
              zIndex: 999,
              height: "45px",
              lineHeight: "45px",
              padding: "0px 24px",
            }}
          >
            <Row justify="space-between">
              <Col>
                <Row gutter={10}>
                  <Col className="fs-20 fw-200" style={{ marginRight: "25px" }}>
                    <span style={{ color: themeData.themeData?.themeColor }}>
                      {settingControl?.title}{" "}
                    </span>

                    <Dropdown
                      //overlay={itemsabc}
                      menu={{
                        items: ExpenseIncomeDropdownItems(),
                        selectable: true,
                        defaultSelectedKeys: [
                          location?.pathname?.split("/")[5] === "addExpenses" ||
                          location?.pathname?.split("/")[5] === "editExpenses"
                            ? "0"
                            : "1",
                        ],
                      }}
                      trigger={["click"]}
                      autoFocus={true}
                    >
                      <Typography.Link>
                        <Space>
                          <DownOutlined
                          // style={{
                          //   fontSize: "12px",
                          //   color: "black",
                          //   padding: "0px 0px 10px 10px",
                          // }}
                          />
                        </Space>
                      </Typography.Link>
                    </Dropdown>
                  </Col>
                  <Col>
                    <Radio.Group buttonStyle="solid" value={isCashVoucher}>
                      <Radio.Button
                        value={false}
                        onChange={(e) => {
                          setIsCashVoucher(e?.target?.value);
                          // if (!settingControl?.showReceipt) {
                          //   form.setFieldValue("bankDts", [{}]);
                          //   setBankAccountAmt(0);
                          // }
                          if (
                            (updateId || cloneId || draftId) &&
                            editInvBankDetails?.length < 0
                          ) {
                            form.setFieldValue("bankDts", [{}]);
                            setBankAccountAmt(0);
                          } else if (
                            !(updateId || cloneId || draftId) &&
                            !settingControl?.showReceipt
                          ) {
                            form.setFieldValue("bankDts", [{}]);
                            setBankAccountAmt(0);
                          }
                          setInsufficientBalanceError("");
                        }}
                      >
                        Credit
                      </Radio.Button>
                      <Radio.Button
                        value={true}
                        onChange={(e) => {
                          setIsCashVoucher(e?.target?.value);
                        }}
                      >
                        Cash
                      </Radio.Button>
                    </Radio.Group>
                  </Col>
                </Row>
              </Col>

              <Col>
                <Space>
                  {/* {splitPathInVchType === Voucher_Type.PurchaseVoucher && ( */}
                  <>
                    <Select
                      // disabled={isLocked}
                      style={{ width: "180px", marginRight: "6px" }}
                      options={findVoucharCustomizationTemplete(
                        splitPathInVchType === Voucher_Type.Expenses
                          ? SettingsSections.Expenses
                          : SettingsSections.Income,
                        companySettings?.setting?.vouchersSettings
                      )}
                      value={selectCustomizationTemplete?.templateId.toString()}
                      onChange={(e: string) => {
                        let selVoucherTemplate =
                          companySettings?.setting?.vouchersSettings?.find(
                            (vchTemp: vouchersSettings) =>
                              vchTemp.id === Utils.getNumber(e)
                          );
                        setSelectCustomizationTemplete({
                          title:
                            selVoucherTemplate?.settings?.expenseSettings
                              ?.titleToBePrint,
                          templateId: selVoucherTemplate?.id!,
                        });
                        // setDefaultEffectedAccount(Utils.getNumber(e));
                      }}
                    />

                    <Select
                      style={{ width: "150px", marginRight: "10px" }}
                      options={
                        settingControl.showRCM || updateTimeData.showRCM
                          ? [
                              ...expensesIncomeNatureOptions,
                              addVoucherExpensesIncomeptions,
                            ]
                          : expensesIncomeNatureOptions
                      }
                      defaultValue={Voucher_Nature.Regular}
                      value={voucherNature}
                      onChange={(e: Voucher_Nature) => {
                        // console.log(e);
                        setVoucherNature(e);
                        const roundOffAmount = handleRoundoff(
                          e === Voucher_Nature.RCM
                            ? footerLedger.ledgerAmount -
                                Math.round(cashDiscountRs * 100) / 100
                            : footerLedger.ledgerTotalAmount -
                                Math.round(cashDiscountRs * 100) / 100,
                          form.getFieldValue("roundoffCheckbox"),
                          settingControl.roundOffType
                        );

                        form.setFieldValue("roundOff", roundOffAmount);
                        setRoundoffAmount(roundOffAmount);
                      }}
                    />
                  </>
                  {/* )} */}
                </Space>
              </Col>
            </Row>
          </Header>
          <Content>
            <div
              style={{
                maxHeight: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                padding: "10px",
              }}
            >
              <div>
                {/* bankAccountList?.length === 0 || */}

                <>
                  <Form
                    labelAlign="left"
                    labelCol={{ lg: 8, xs: 24, sm: 7 }}
                    wrapperCol={{ lg: 15, xs: 24, sm: 16 }}
                    requiredMark={true}
                    form={form}
                    autoComplete="off"
                    name="salesInvoice"
                    // requiredMark={false}
                    initialValues={{
                      supplyState: currentClient?.state!,
                      roundoffCheckbox: settingControl.autoRoundOff,
                      // tcsDetail: 0,
                      // tdsDetail: 0,
                      // isPurchaseJVVoucher: false,

                      cashDiscountDrop: DiscountType.PercentageDiscount,
                      freightInsLedgers: [
                        {
                          itcEligibilityType:
                            splitPathInVchType === Voucher_Type.Expenses
                              ? ITCEligibility_Type.Available
                              : null,
                          gstAmount: 0,
                          totalAmount: 0,
                          // amount: 0,
                        },
                      ],
                      bankDts: [{}],
                    }}
                  >
                    <Row justify={"space-between"} style={{ width: "101.3%" }}>
                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item
                          name="partyLedger"
                          label={
                            <>
                              <span>
                                {splitPathInVchType === Voucher_Type.Expenses
                                  ? "Supplier"
                                  : "Customer"}
                              </span>
                              <span
                                style={{
                                  paddingLeft: "14px",
                                  paddingTop: "4px",
                                }}
                              >
                                {selectedParty && permissionPartyEdit && (
                                  <Col className="fw-500">
                                    <div
                                      style={{
                                        textAlign: "end",
                                        paddingRight: "17px",
                                      }}
                                    >
                                      <Tooltip title="View Party">
                                        <EyeOutlined
                                          onClick={() => {
                                            setEditParty({
                                              id: selectedParty,
                                            });
                                            setOpenModel({
                                              type: "addLedger",
                                              param: {
                                                open: true,
                                                ledgerByGroupsType:
                                                  SearchLedgerByGroupsTypes.PartiesOnly,
                                                showName: "Party",
                                              },
                                            });
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </Col>
                                )}
                              </span>
                            </>
                          }
                          // className="m-0 selectPlaceholder selectedItem errormsg"

                          rules={[
                            {
                              required: !isCashVoucher,
                              message: "Select a customer",
                            },
                          ]}
                          style={
                            {
                              // paddingBottom:
                              //   selectedParty ||
                              //     updateId ||
                              //     cloneId ||
                              //     draftId ||
                              //     salesOrderId ||
                              //     quotationId ||
                              //     purchaseOrderId
                              //     ? undefined
                              //     : "54px",
                              // marginBottom: "5px",
                              // marginTop: selectedParty ? "0px" : "20px"
                            }
                          }
                          className="mb-3"
                        >
                          <Select
                            ref={inputRef}
                            loading={partyDropDownLoading}
                            showSearch
                            allowClear
                            labelInValue
                            optionFilterProp="children"
                            placeholder="Party's name"
                            style={{ width: "100%" }}
                            // filterOption={false}
                            // className="selectedItem"

                            // loading
                            autoFocus={true}
                            // onSearch={(value: string) =>
                            //   setSearchCustomer({ search: value, length: 15 })
                            // }
                            filterOption={(input, option) =>
                              (option?.label?.toString() ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            // onClick={() =>
                            //   setSearchCustomer({ ...searchCustomer, search: "" })
                            // }
                            onChange={(e: any) => {
                              if (!e?.cancelable) {
                                setSelectedParty("");
                                // setPurchaseOrderRef(null);
                              }
                              const party = customerOptions.find(
                                (x: any) => x.id === e?.value
                              );
                              let PanType: PanCardType;
                              if (party?.pan) {
                                if (
                                  party?.pan?.split("")[3]?.toUpperCase() ===
                                    "H" ||
                                  party?.pan?.split("")[3]?.toUpperCase() ===
                                    "P"
                                ) {
                                  PanType = PanCardType.HUF;
                                } else {
                                  PanType = PanCardType.Other;
                                }
                              } else {
                                PanType = PanCardType.notAvailable;
                              }
                              setPartyPanCard(PanType);

                              if (form.getFieldValue("tdsDetail")?.value) {
                                handleAllTheTotalValues(tdsOrTcs, PanType);
                              }

                              form.setFieldValue(
                                ["shippingAddress", "address"],
                                ""
                              );
                              form.setFieldValue(
                                ["shippingAddress", "type"],
                                ""
                              );
                              setIsPartTDSOrTDS({
                                tds: party?.deductTDSinSameVoucher,
                                tcs: party?.ledgerTCSApplicability,
                              });
                              // Party Wise Tcs & Tds condition

                              if (
                                splitPathInVchType === Voucher_Type.Expenses
                              ) {
                                if (
                                  party?.ledgerTCSApplicability &&
                                  settingControl?.showTcsTds
                                ) {
                                  setTotalTcs(totalTcs);
                                  setTcsTdsPercentage(tcsTdsPercentage);

                                  form.setFieldValue(
                                    "tcsDetail",
                                    form.getFieldValue("tcsDetail")
                                  );
                                  handleAllTheTotalValues();
                                } else {
                                  setTotalTcs(0);
                                  // form.setFieldValue("tcsDetail", {});
                                  // setTcsTdsPercentage(0);
                                }
                              } else {
                                if (
                                  party?.deductTDSinSameVoucher &&
                                  settingControl?.showTcsTds
                                ) {
                                  // setTotalTds(totalTds);
                                  setTcsTdsPercentage(tcsTdsPercentage);
                                  // setTdsPostDetail({
                                  //   formNo: tdsSelect.form,
                                  //   transactionType: tdsSelect.transactionType,
                                  // });
                                  form.setFieldValue(
                                    "tdsDetail",
                                    form.getFieldValue("tdsDetail")
                                  );
                                  handleAllTheTotalValues();
                                } else {
                                  setTotalTds(0);
                                  // form.setFieldValue("tdsDetail", {});
                                  // setTcsTdsPercentage(0);
                                }
                              }
                              CustomerSelect(e?.value);
                              // }
                            }}
                            options={customerOptions?.map((value: any) => ({
                              title: "",
                              value: value?.id,
                              label: value?.ledgerName.concat(
                                value?.aliasName
                                  ? `${" (" + value?.aliasName + ")"}`
                                  : ""
                              ),
                            }))}
                            dropdownRender={(customerOptions) => (
                              <>
                                {customerOptions}
                                {permissionPartyAdd && (
                                  <>
                                    {" "}
                                    <Divider style={{ margin: "5px 0px" }} />
                                    <Button
                                      style={{ width: "100%" }}
                                      icon={<PlusOutlined />}
                                      type="link"
                                      onClick={() => {
                                        setEditParty({ id: "" });
                                        setOpenModel({
                                          type: "addLedger",
                                          param: {
                                            open: true,
                                            defaultGroup:
                                              splitPathInVchType ===
                                              Voucher_Type.Expenses
                                                ? {
                                                    id: "6603afe599242bad67d446d3",
                                                    ledgerName:
                                                      "Trade Payables - Sundry Creditors",
                                                    parent:
                                                      "65af9df71a48db26effbb5a3",
                                                  }
                                                : {
                                                    id: "6603afaa99242bad67d446cd",
                                                    ledgerName:
                                                      "Trade Receivables - Sundry Debtors",
                                                    parent:
                                                      "65af9ce61a48db26effbb598",
                                                  },
                                            ledgerByGroupsType:
                                              splitPathInVchType ===
                                              Voucher_Type.Expenses
                                                ? SearchLedgerByGroupsTypes.CreditorsOnly
                                                : SearchLedgerByGroupsTypes.DebtorsOnly,
                                            showName:
                                              splitPathInVchType ===
                                              Voucher_Type.Expenses
                                                ? "Supplier"
                                                : "Customer",
                                          },
                                        });
                                        setApiCallField("New Supplier");
                                      }}
                                    >
                                      {splitPathInVchType ===
                                      Voucher_Type.Expenses
                                        ? "Supplier"
                                        : "Customer"}
                                    </Button>
                                  </>
                                )}
                              </>
                            )}
                          />
                        </Form.Item>
                        {/* <Col xxl={10} xl={10} lg={10} sm={24} >
                       
                      </Col> */}

                        {/* <Col xxl={10} xl={10} lg={10} sm={24}>
                       
                      </Col> */}
                      </Col>
                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item
                          name="number"
                          label={
                            <>
                              <span className=" fw-500">
                                {splitPathInVchType === Voucher_Type.Expenses
                                  ? "Exp No. "
                                  : "Income No. "}
                              </span>
                              {!settingControl?.manualNumbering && (
                                <span
                                  style={{
                                    paddingLeft: "12px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {" "}
                                  <ReloadOutlined
                                    onClick={() =>
                                      setRefreshNumber(!refreshNumber)
                                    }
                                    style={{ fontSize: "12px" }}
                                    // className="textEnd"
                                  />
                                </span>
                              )}
                            </>
                          }
                          style={{ marginBottom: "4px", width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please enter invoice No.",
                            },
                          ]}
                        >
                          {voucherNumberLoader ? (
                            <Skeleton.Input
                              active={true}
                              size="default"
                              block={false}
                              className="responsive-skeleton-input"
                              style={{ width: "100%" }}
                            />
                          ) : (
                            <Input
                              disabled={!settingControl?.manualNumbering}
                              placeholder="Enter voucher No."
                              style={{
                                width: "100%",
                                backgroundColor: settingControl?.manualNumbering
                                  ? ""
                                  : `${themeData.themeData?.themeColor}40`,
                              }}
                            />
                          )}
                        </Form.Item>
                        {/* {selectedParty && ( */}

                        <Form.Item
                          name="supplyState"
                          style={{ marginBottom: "2px" }}
                          label={
                            <>
                              <span className="fw-500">
                                {splitPathInVchType === Voucher_Type.Expenses
                                  ? "Origin of Supply"
                                  : "Place of Supply"}
                              </span>
                            </>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Place is required",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            allowClear={false}
                            placeholder="Select State"
                            placement="bottomLeft"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onSelect={(val) => {
                              console.log("val", val);
                              setPurchasePartyState(val);
                              // isStateSame = val === currentCustomerState;
                            }}
                            options={Object?.entries(stateOptions)?.map(
                              ([key, x]: any) => ({
                                title: "",
                                value: x?.id,
                                label: x?.name,
                              })
                            )}
                          />
                        </Form.Item>
                        {splitPathInVchType === Voucher_Type.Expenses && (
                          <>
                            <Form.Item
                              label="Invoice Ref. No."
                              name="supplierInvoiceRef"
                              className="mb-3"
                            >
                              <Input />
                            </Form.Item>
                            <Form.Item
                              name="supplierInvoiceDate"
                              label="Invoice Ref. Date"
                              className="mb-3"
                            >
                              <DatePicker
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                allowClear={true}
                                disabledDate={(current: any) =>
                                  current <
                                    dayjs(currentClient?.financialYearBegin) ||
                                  current >=
                                    dayjs(
                                      currentClient?.financialYearBegin
                                    ).add(2, "year")
                                }
                              />
                            </Form.Item>
                          </>
                        )}

                        {/* )} */}
                      </Col>
                      <Col xxl={8} xl={8} lg={12} sm={24}>
                        <Form.Item
                          name="date"
                          style={{ marginBottom: "4px" }}
                          label="Date"
                        >
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            allowClear={false}
                            disabledDate={(current: any) =>
                              current <
                                dayjs(currentClient?.financialYearBegin) ||
                              current >=
                                dayjs(currentClient?.financialYearBegin).add(
                                  2,
                                  "year"
                                )
                            }
                            onChange={(val) => {
                              if (dueOnParty) {
                                form.setFieldValue(
                                  "dueDate",
                                  dayjs(val).add(dueOnParty, "d")
                                );
                              } else {
                                form.setFieldValue(
                                  "dueDate",
                                  dayjs(val).add(dueOnSetting, "d")
                                );
                              }
                              setDateFiled(dayjs(val).toISOString());
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          name="dueDate"
                          className="m-0"
                          label="Due Date"
                        >
                          <DatePicker
                            disabledDate={(current) =>
                              current <
                              form.getFieldValue("date")?.startOf("day")
                            }
                            allowClear={false}
                            format="DD/MM/YYYY"
                            style={{ width: "100%" }}
                            open={isOpenDueDate}
                            onOpenChange={(x) => setIsDueDate(x)}
                            // presets={
                            //   windowWidth > 550
                            //     ?
                            //   [
                            //     {
                            //       label: "Tomorrow",
                            //       value: dayjs().add(1, "d"),
                            //     },
                            //     {
                            //       label: "After 7 days",
                            //       value: dayjs().add(7, "d"),
                            //     },
                            //     {
                            //       label: "After 15 days",
                            //       value: dayjs().add(15, "d"),
                            //     },
                            //     {
                            //       label: "After 30 days",
                            //       value: dayjs().add(30, "d"),
                            //     },
                            //     {
                            //       label: "After 45 days",
                            //       value: dayjs().add(45, "d"),
                            //     },
                            //     {
                            //       label: "After 60 days",
                            //       value: dayjs().add(60, "d"),
                            //     },
                            //     {
                            //       label: "After 90 days",
                            //       value: dayjs().add(90, "d"),
                            //     },
                            //     {
                            //       label: "After 180 days",
                            //       value: dayjs().add(180, "d"),
                            //     },
                            //     {
                            //       label: "Due on Receipt",
                            //       value: dayjs(),
                            //     },
                            //   ]
                            //   : []
                            // }
                            renderExtraFooter={() => (
                              <Space
                                style={{
                                  display: "flex",

                                  justifyContent: "space-around",
                                }}
                              >
                                <InputNumber
                                  placeholder="After"
                                  style={{ width: "60px" }}
                                  controls={false}
                                  onChange={(e) =>
                                    setPresetsDueDate({
                                      ...presetsDueDate,
                                      label: e,
                                    })
                                  }
                                  onClick={() =>
                                    inputRef.current && inputRef.current.focus()
                                  }
                                  ref={inputRef}
                                />

                                <Select
                                  allowClear
                                  onBlur={(e) => {
                                    e.relatedTarget === null
                                      ? setIsDueDate(false)
                                      : setIsDueDate(true);
                                  }}
                                  style={{ width: "100px" }}
                                  // onMouseDown={(e) => e.stopPropagation()}
                                  onChange={(e: any) => {
                                    setPresetsDueDate({
                                      ...presetsDueDate,
                                      value: e,
                                    });
                                  }}
                                  options={[
                                    { value: "d", label: "Days", title: "" },
                                    { value: "w", label: "Weeks", title: "" },
                                    {
                                      value: "month",
                                      label: "Months",
                                      title: "",
                                    },
                                    {
                                      value: "year",
                                      label: "Years",
                                      title: "",
                                    },
                                  ]}
                                />

                                <Tooltip title="Save" placement="bottom">
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      setDueDateTrigger((x) => x + 1);
                                      setIsDueDate(false);
                                    }}
                                    icon={<SaveOutlined />}
                                  />
                                </Tooltip>
                                <Tooltip title="Cancel" placement="right">
                                  <Button
                                    onClick={() => {
                                      setIsDueDate(false);

                                      // form.setFieldValue(
                                      //   "dueDate",
                                      //   dayjs().add(0, "d")
                                      // );
                                    }}
                                    icon={<CloseOutlined />}
                                  />
                                </Tooltip>
                              </Space>
                            )}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* Item Table */}

                    <div
                      style={{
                        width: "100%",
                        overflowY: "auto",
                        marginTop: "0px",
                      }}
                    >
                      <table
                        className="AddPageTabelDesign"
                        style={{
                          width: "100%",
                          tableLayout: "auto",
                        }}
                      >
                        <thead>
                          <tr>
                            <th rowSpan={2} style={{ width: "5%" }}>
                              S.No.
                            </th>
                            <th
                              rowSpan={2}
                              style={{
                                // width: "40%",
                                borderLeft: "1px solid rgb(240, 245, 255)",
                              }}
                            >
                              {splitPathInVchType === Voucher_Type.Expenses
                                ? "Expenses"
                                : "Income"}
                            </th>
                            <th rowSpan={2} style={{ width: "10%" }}>
                              Price
                            </th>
                            {(splitPathInVchType !== Voucher_Type.Income ||
                              currentClient?.gstType ===
                                CompanyGSTTypes.Regular ||
                              updateTimeData.isGSTVoucher) && (
                              <th
                                colSpan={
                                  splitPathInVchType === Voucher_Type.Expenses
                                    ? 3
                                    : 2
                                }
                                style={{ width: "25%" }}
                              >
                                GST
                              </th>
                            )}
                            <th
                              colSpan={2}
                              rowSpan={2}
                              style={{
                                width: "15%",
                                // display: "flex",
                                // justifyContent: "space-between",
                              }}
                            >
                              Gross Amount
                            </th>
                          </tr>
                          {(currentClient?.gstType ===
                            CompanyGSTTypes.Regular ||
                            updateTimeData.isGSTVoucher ||
                            splitPathInVchType !== Voucher_Type.Income) && (
                            <tr>
                              <th style={{ width: "10%" }}>Rate</th>
                              {splitPathInVchType === Voucher_Type.Expenses && (
                                <th style={{ width: "12%" }}>
                                  ITC Availability
                                </th>
                              )}
                              <th style={{ width: "10%" }}>Amount</th>
                            </tr>
                          )}
                        </thead>

                        <tbody>
                          {/* Show Include Other Expenses */}
                          {/* Expenses */}
                          <>
                            <Form.List name="freightInsLedgers">
                              {(fields, { add, remove, move }) => {
                                return (
                                  <>
                                    {ledgerconfirmation && (
                                      <ConfirmationModal
                                        open={ledgerconfirmation}
                                        text={
                                          "Do you really want to delete this item"
                                        }
                                        onNo={() =>
                                          setLedgerConfirmation(false)
                                        }
                                        onYes={() => {
                                          setLedgerConfirmation(false);
                                          setLedgerLength(fields.length - 2);
                                          setSelectedOtherExpenses((prev) => {
                                            const newDisabledInputs = [...prev];
                                            newDisabledInputs.splice(
                                              deleteLedgerList,
                                              1
                                            );
                                            return newDisabledInputs;
                                          });
                                          setUnallottedAmounts((prev: any) => {
                                            const newAmounts = [...prev];
                                            newAmounts?.splice(
                                              deleteLedgerList,
                                              1
                                            );
                                            return newAmounts;
                                          });
                                          setSelectedCostCentres(
                                            (prev: any[]) => {
                                              const prevCostCenters = [...prev];
                                              prevCostCenters.splice(
                                                deleteLedgerList,
                                                1
                                              );
                                              return prevCostCenters;
                                            }
                                          );
                                          console.log("lengt", fields.length);
                                          remove(deleteLedgerList);
                                          handleLedgerNetAmount(0);
                                        }}
                                      />
                                    )}
                                    {/* <tbody> */}
                                    {fields?.map(
                                      ({ key, name, ...restField }, index) => {
                                        return (
                                          <>
                                            <tr key={key}>
                                              <td
                                                style={{
                                                  verticalAlign: "top",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {index + 1}.
                                              </td>
                                              {/* Expenses */}
                                              <td>
                                                <Form.Item
                                                  name={[name, "id"]}
                                                  className="m-0"
                                                  {...restField}
                                                  wrapperCol={{
                                                    span: 24,
                                                  }}
                                                >
                                                  <Select
                                                    labelInValue
                                                    bordered={false}
                                                    loading={
                                                      otherExpensiveDropDownLoading
                                                    }
                                                    variant="filled"
                                                    className="variantFilledSelect"
                                                    // style={{ width: "338px" }}
                                                    placeholder={
                                                      splitPathInVchType ===
                                                      Voucher_Type.Expenses
                                                        ? "Search for other expenses"
                                                        : "Search for other incomes"
                                                    }
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(
                                                      input,
                                                      option
                                                    ) =>
                                                      (
                                                        option?.label?.toString() ??
                                                        ""
                                                      )
                                                        .toLowerCase()
                                                        .includes(
                                                          input.toLowerCase()
                                                        )
                                                    }
                                                    onChange={(e: any) => {
                                                      if (
                                                        fields.length ===
                                                        index + 1
                                                      )
                                                        add({
                                                          itcEligibilityType:
                                                            splitPathInVchType ===
                                                            Voucher_Type.Expenses
                                                              ? ITCEligibility_Type.Available
                                                              : null,
                                                        });
                                                      freightInsLedgersSelect(
                                                        e.value,
                                                        index
                                                      );

                                                      const hasPeviousValue =
                                                        form.getFieldValue([
                                                          "freightInsLedgers",
                                                          index,
                                                        ]);

                                                      if (
                                                        hasPeviousValue
                                                          ?.costCentres
                                                          ?.length > 1
                                                      ) {
                                                        form.setFieldValue(
                                                          [
                                                            "freightInsLedgers",
                                                            index,
                                                            "costCentres",
                                                          ],
                                                          [{}]
                                                        );
                                                        setSelectedCostCentres(
                                                          (prev) => {
                                                            const newArr = [
                                                              ...prev,
                                                            ];
                                                            newArr.splice(
                                                              index,
                                                              1,
                                                              []
                                                            );
                                                            return newArr;
                                                          }
                                                        );
                                                      } else {
                                                        setSelectedCostCentres(
                                                          (prevDataArray) => {
                                                            const newArray = [
                                                              ...prevDataArray,
                                                            ];
                                                            if (
                                                              index < 0 ||
                                                              index >=
                                                                newArray?.length
                                                            ) {
                                                              newArray.push([]);
                                                            } else {
                                                              newArray.splice(
                                                                index,
                                                                1,
                                                                []
                                                              );
                                                            }
                                                            return newArray;
                                                          }
                                                        );
                                                      }
                                                    }}
                                                    options={freightAndInsuranceOptions
                                                      ?.filter(
                                                        (option: any) =>
                                                          !selectedOtherExpenses.includes(
                                                            option.id
                                                          )
                                                      )
                                                      ?.map((value: any) => ({
                                                        title: "",
                                                        value: value?.id,
                                                        label:
                                                          value?.ledgerName.concat(
                                                            value?.aliasName
                                                              ? `${
                                                                  " (" +
                                                                  value?.aliasName +
                                                                  ")"
                                                                }`
                                                              : ""
                                                          ),
                                                      }))}
                                                    style={{
                                                      width: "100%",
                                                      minWidth: "100%",
                                                      maxWidth: "240px",
                                                      backgroundColor:
                                                        "#FFFFFF",
                                                    }}
                                                    dropdownRender={(
                                                      customerOptions
                                                    ) => (
                                                      <>
                                                        {customerOptions}
                                                        {permissionLedgerAdd && (
                                                          <>
                                                            <Divider
                                                              style={{
                                                                margin:
                                                                  "5px 0px",
                                                              }}
                                                            />
                                                            <Button
                                                              style={{
                                                                width: "100%",
                                                              }}
                                                              icon={
                                                                <PlusOutlined />
                                                              }
                                                              type="link"
                                                              onClick={() => {
                                                                setOpenModel({
                                                                  type: "addLedger",
                                                                  param: {
                                                                    open: true,
                                                                    ledgerByGroupsType:
                                                                      splitPathInVchType ===
                                                                      Voucher_Type.Expenses
                                                                        ? SearchLedgerByGroupsTypes.AllExpenses
                                                                        : SearchLedgerByGroupsTypes.IndirectIncomeOnly,
                                                                    showName:
                                                                      splitPathInVchType ===
                                                                      Voucher_Type.Expenses
                                                                        ? "Expense"
                                                                        : "Income",
                                                                  },
                                                                });
                                                                setEditParty({
                                                                  id: "",
                                                                });
                                                                setApiCallField(
                                                                  "New Ledger"
                                                                );
                                                                setNewLedgerAddedIndex(
                                                                  index
                                                                );
                                                              }}
                                                            >
                                                              New Ledger
                                                            </Button>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  />
                                                </Form.Item>
                                              </td>
                                              {/* Price */}
                                              <td>
                                                <Form.Item
                                                  name={[name, "amount"]}
                                                  className="m-0"
                                                  {...restField}
                                                  wrapperCol={{
                                                    span: 24,
                                                  }}
                                                  initialValue={0.0}
                                                >
                                                  <InputNumber
                                                    variant="filled"
                                                    bordered={false}
                                                    disabled={
                                                      fields.length ===
                                                      index + 1
                                                    }
                                                    placeholder="Amount"
                                                    min={0}
                                                    step={0.01}
                                                    precision={2}
                                                    onFocus={(e) => {
                                                      handleInputFocus(e, form);
                                                      var getData =
                                                        form.getFieldValue([
                                                          "freightInsLedgers",
                                                          index,
                                                          "costCentres",
                                                        ]);
                                                      setShowPriceHistory(
                                                        (prev: any) => {
                                                          let newValues = [
                                                            ...prev,
                                                          ];
                                                          newValues[index] =
                                                            true;
                                                          return newValues;
                                                        }
                                                      );
                                                      handlePriceHistoryData(
                                                        getData?.id?.value
                                                      );
                                                    }}
                                                    onBlur={(e) => {
                                                      setShowPriceHistory(
                                                        (prev: any) => {
                                                          let newValues = [
                                                            ...prev,
                                                          ];
                                                          newValues[index] =
                                                            false;
                                                          return newValues;
                                                        }
                                                      );
                                                      setShowPriceHistoryData(
                                                        null
                                                      );
                                                    }}
                                                    onKeyPress={
                                                      handleDecimalValues
                                                    }
                                                    style={{
                                                      width: "100%",
                                                      // width: "125px",
                                                      // marginLeft: "10px",
                                                      backgroundColor:
                                                        fields.length ===
                                                        index + 1
                                                          ? `${themeData.themeData?.themeColor}40`
                                                          : "#FFFFFF",
                                                    }}
                                                    controls={false}
                                                    className="inputNumberTextEnd"
                                                    onChange={() => {
                                                      handleLedgerNetAmount(
                                                        index
                                                      );
                                                      calculateUnallotted(
                                                        index
                                                      );
                                                    }}
                                                  />
                                                </Form.Item>
                                                {showPriceHistory[index] &&
                                                  settingControl?.showPriceHistory &&
                                                  splitPathInVchType ===
                                                    Voucher_Type.Expenses && (
                                                    <ShowPriceHistoryDataView
                                                      data={
                                                        showPriceHistoryData ??
                                                        []
                                                      }
                                                      themeColor={`${themeData.themeData?.themeColor}40`}
                                                      loading={
                                                        showPriceHistoryLoading
                                                      }
                                                    ></ShowPriceHistoryDataView>
                                                  )}
                                              </td>
                                              {/* GST */}
                                              {(currentClient?.gstType ===
                                                CompanyGSTTypes.Regular ||
                                                updateTimeData.isGSTVoucher ||
                                                splitPathInVchType !==
                                                  Voucher_Type.Income) && (
                                                <>
                                                  <td>
                                                    <Form.Item
                                                      name={[name, "gstRate"]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: 25,
                                                      }}
                                                    >
                                                      <Select
                                                        // style={
                                                        //   {
                                                        //     // backgroundColor: "#FFFFFF",
                                                        //   }
                                                        // }
                                                        allowClear
                                                        placement="bottomRight"
                                                        labelInValue
                                                        bordered={false}
                                                        disabled={
                                                          fields.length ===
                                                          index + 1
                                                        }
                                                        style={{
                                                          minWidth: "100%",
                                                          maxWidth: "110px",
                                                        }}
                                                        variant="filled"
                                                        // style={{
                                                        //   width: "100%",
                                                        //   backgroundColor:
                                                        //     fields.length ===
                                                        //     index + 1
                                                        //       ? "#f0f8ff"
                                                        //       : "#FFFFFF",
                                                        // }}
                                                        placeholder={
                                                          "Select GST %"
                                                        }
                                                        popupMatchSelectWidth={
                                                          false
                                                        }
                                                        filterOption={(
                                                          input,
                                                          option
                                                        ) =>
                                                          (
                                                            option?.label?.toString() ??
                                                            ""
                                                          )
                                                            .toLowerCase()
                                                            .includes(
                                                              input.toLowerCase()
                                                            )
                                                        }
                                                        onChange={() => {
                                                          handleLedgerNetAmount(
                                                            index
                                                          );
                                                          calculateUnallotted(
                                                            index
                                                          );
                                                        }}
                                                        options={gstOption?.map(
                                                          (gst: any) => ({
                                                            value: gst?.id,
                                                            title: gst?.rate,
                                                            label: gst?.name,
                                                          })
                                                        )}
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  {splitPathInVchType ===
                                                    Voucher_Type.Expenses && (
                                                    <>
                                                      {" "}
                                                      <td>
                                                        <Form.Item
                                                          name={[
                                                            name,
                                                            "itcEligibilityType",
                                                          ]}
                                                          className="m-0"
                                                          {...restField}
                                                          wrapperCol={{
                                                            xl: 25,
                                                          }}
                                                        >
                                                          <Select
                                                            bordered={false}
                                                            variant="filled"
                                                            placeholder="Please select"
                                                            popupMatchSelectWidth={
                                                              false
                                                            }
                                                            disabled={
                                                              fields.length ===
                                                              index + 1
                                                            }
                                                            style={{
                                                              minWidth: "100%",
                                                              maxWidth: "110px",
                                                              // backgroundColor:
                                                              //   "#FFFFFF",
                                                            }}
                                                            placement="bottomRight"
                                                            options={
                                                              ITCEligibilityTypeOptions
                                                            }
                                                          />
                                                        </Form.Item>
                                                      </td>
                                                    </>
                                                  )}

                                                  <td>
                                                    <Form.Item
                                                      className="m-0 inputNumberTextEnd"
                                                      name={[name, "gstAmount"]}
                                                      {...restField}
                                                      initialValue={0.0}
                                                      wrapperCol={{
                                                        span: 24,
                                                      }}
                                                    >
                                                      <InputNumber
                                                        bordered={false}
                                                        variant="filled"
                                                        controls={false}
                                                        disabled={true}
                                                        formatter={(
                                                          value: any
                                                        ) =>
                                                          value
                                                            ? Utils.getFormattedNumber(
                                                                value
                                                              )
                                                            : "0.00"
                                                        }
                                                        // disabled={
                                                        //   fields.length ===
                                                        //   index + 1
                                                        // }
                                                        step={0.01}
                                                        className="inputNumberTextEnd"
                                                        style={{
                                                          width: "100%",
                                                          // minWidth: "100%",
                                                          // maxWidth: "240px",
                                                          backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                        }}
                                                        onChange={() => {
                                                          handleLedgerNetAmount(
                                                            index
                                                          );
                                                          calculateUnallotted(
                                                            index
                                                          );
                                                        }}
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                </>
                                              )}
                                              <td>
                                                {/* <div
                                            style={{
                                              display: "flex",
                                              alignItems: "baseline",
                                            }}
                                          > */}
                                                {/* <div> */}

                                                {/* Gross Amount */}
                                                <Form.Item
                                                  name={[name, "totalAmount"]}
                                                  className="m-0 inputNumberTextEnd"
                                                  {...restField}
                                                  initialValue={0.0}
                                                  wrapperCol={{
                                                    span: 25,
                                                  }}
                                                >
                                                  <InputNumber
                                                    // disabled
                                                    bordered={false}
                                                    disabled={
                                                      fields.length ===
                                                      index + 1
                                                    }
                                                    variant="filled"
                                                    style={{
                                                      width: "100%",
                                                      backgroundColor:
                                                        fields.length ===
                                                        index + 1
                                                          ? `${themeData.themeData?.themeColor}40`
                                                          : "#FFFFFF",
                                                    }}
                                                    className="inputNumberTextEnd"
                                                    controls={false}
                                                    step={0.01}
                                                    precision={2}
                                                    onChange={(value) => {
                                                      onLedgerTotalAmountChange(
                                                        index
                                                      );
                                                      calculateUnallotted(
                                                        index
                                                      );
                                                    }}
                                                    onKeyPress={
                                                      handleDecimalValues
                                                    }
                                                    onFocus={(e) => {
                                                      handleInputFocus(e, form);
                                                    }}
                                                  />
                                                </Form.Item>
                                              </td>

                                              {/* delete ITems */}
                                              <td>
                                                {fields.length !==
                                                  index + 1 && (
                                                  <img
                                                    className="cursor mx-1"
                                                    onClick={() => {
                                                      setDeleteLedgerList(name);
                                                      setLedgerConfirmation(
                                                        true
                                                      );
                                                    }}
                                                    src={deleteImg}
                                                    alt="Delete"
                                                  />
                                                )}
                                              </td>

                                              {/* </div> */}
                                              {/* <td style={{ width: "24px" }}></td> */}
                                            </tr>

                                            {/* Nest Form.List */}
                                            {/* costCenters List */}
                                            {selectedOtherExpenses?.length !=
                                              0 &&
                                              freightAndInsuranceOptions?.find(
                                                (e: any) =>
                                                  e?.id ===
                                                  selectedOtherExpenses[index]
                                              )?.costCentres?.length !== 0 &&
                                              fields?.length != index + 1 && (
                                                <tr>
                                                  <td></td>
                                                  <td
                                                    style={{
                                                      width: "608px",
                                                    }}
                                                  >
                                                    <table
                                                      style={{
                                                        width: "100%",
                                                      }}
                                                    >
                                                      <tbody>
                                                        <Form.Item
                                                          className="m-0"
                                                          name="costCentres"
                                                        >
                                                          <Form.List
                                                            name={[
                                                              name,
                                                              "costCentres",
                                                            ]}
                                                            initialValue={[{}]}
                                                          >
                                                            {(
                                                              subFields,
                                                              { add, remove }
                                                            ) => {
                                                              return (
                                                                <div
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    flexDirection:
                                                                      "column",
                                                                    width:
                                                                      "608px",
                                                                  }}
                                                                >
                                                                  {subFields.map(
                                                                    (
                                                                      subField,
                                                                      index2
                                                                    ) => {
                                                                      return (
                                                                        <>
                                                                          <tr
                                                                            key={
                                                                              index2
                                                                            }
                                                                            style={{
                                                                              minWidth:
                                                                                "100%",
                                                                            }}
                                                                          >
                                                                            <td
                                                                              style={{
                                                                                width:
                                                                                  "65%",
                                                                              }}
                                                                            >
                                                                              <Form.Item
                                                                                className="m-0"
                                                                                name={[
                                                                                  subField.name,
                                                                                  "costCentreName",
                                                                                ]}
                                                                              >
                                                                                <Select
                                                                                  bordered={
                                                                                    false
                                                                                  }
                                                                                  style={{
                                                                                    backgroundColor:
                                                                                      "#FFFFFF",
                                                                                    width:
                                                                                      "100%",
                                                                                  }}
                                                                                  labelInValue
                                                                                  showSearch
                                                                                  optionFilterProp="children"
                                                                                  placeholder="Select Cost Centre"
                                                                                  filterOption={(
                                                                                    input,
                                                                                    option
                                                                                  ) =>
                                                                                    (
                                                                                      option?.label?.toString() ??
                                                                                      ""
                                                                                    )
                                                                                      .toLowerCase()
                                                                                      .includes(
                                                                                        input.toLowerCase()
                                                                                      )
                                                                                  }
                                                                                  onChange={(
                                                                                    e
                                                                                  ) => {
                                                                                    if (
                                                                                      subFields.length ===
                                                                                      index2 +
                                                                                        1
                                                                                    )
                                                                                      add();
                                                                                    handleCostCenterSelect(
                                                                                      index,
                                                                                      index2
                                                                                    );
                                                                                    setSelectedCostCentres(
                                                                                      (
                                                                                        prevState: any[]
                                                                                      ) => {
                                                                                        const updatedSelectedOptions: any[] =
                                                                                          [
                                                                                            ...prevState,
                                                                                          ];
                                                                                        updatedSelectedOptions[
                                                                                          index
                                                                                        ] =
                                                                                          [
                                                                                            ...(prevState[
                                                                                              index
                                                                                            ] ||
                                                                                              []),
                                                                                          ];
                                                                                        updatedSelectedOptions[
                                                                                          index
                                                                                        ][
                                                                                          index2
                                                                                        ] =
                                                                                          e?.value;
                                                                                        return updatedSelectedOptions;
                                                                                      }
                                                                                    );
                                                                                  }}
                                                                                  options={freightAndInsuranceOptions
                                                                                    ?.find(
                                                                                      (
                                                                                        e: ILedgerSearchByGroupNameResponse
                                                                                      ) =>
                                                                                        e?.id ===
                                                                                        selectedOtherExpenses[
                                                                                          index
                                                                                        ]
                                                                                    )
                                                                                    ?.costCentres?.filter(
                                                                                      (
                                                                                        r: ICostCentre
                                                                                      ) =>
                                                                                        !selectedCostCentres[
                                                                                          index
                                                                                        ]?.includes(
                                                                                          r.id
                                                                                        )
                                                                                    )
                                                                                    ?.map(
                                                                                      (
                                                                                        val: ICostCentre
                                                                                      ) => ({
                                                                                        value:
                                                                                          val?.id,
                                                                                        label:
                                                                                          val?.costCentreName,
                                                                                        title:
                                                                                          "",
                                                                                      })
                                                                                    )}
                                                                                  dropdownRender={(
                                                                                    customerOptions
                                                                                  ) => (
                                                                                    <>
                                                                                      {
                                                                                        customerOptions
                                                                                      }
                                                                                      <>
                                                                                        <Divider
                                                                                          style={{
                                                                                            margin:
                                                                                              "5px 0px",
                                                                                          }}
                                                                                        />
                                                                                        <Button
                                                                                          style={{
                                                                                            width:
                                                                                              "100%",
                                                                                          }}
                                                                                          onClick={() => {
                                                                                            setOpenCostCentreModel(
                                                                                              {
                                                                                                open: true,
                                                                                                id: "",
                                                                                              }
                                                                                            );
                                                                                            setCostCentreAddedDetails(
                                                                                              {
                                                                                                expenseId:
                                                                                                  selectedOtherExpenses[
                                                                                                    index
                                                                                                  ],
                                                                                                expenseParentIndex:
                                                                                                  index,
                                                                                                costCentreAddedIndex:
                                                                                                  index2,
                                                                                              }
                                                                                            );
                                                                                          }}
                                                                                          icon={
                                                                                            <PlusOutlined />
                                                                                          }
                                                                                          type="link"
                                                                                        >
                                                                                          New
                                                                                          Cost
                                                                                          Centre
                                                                                        </Button>
                                                                                      </>
                                                                                    </>
                                                                                  )}
                                                                                />
                                                                              </Form.Item>
                                                                            </td>
                                                                            <td
                                                                              style={{
                                                                                width:
                                                                                  "25%",
                                                                              }}
                                                                            >
                                                                              <Form.Item
                                                                                className="m-0"
                                                                                name={[
                                                                                  subField.name,
                                                                                  "amount",
                                                                                ]}
                                                                                initialValue={
                                                                                  0.0
                                                                                }
                                                                              >
                                                                                <InputNumber
                                                                                  disabled={
                                                                                    subFields.length ==
                                                                                    index2 +
                                                                                      1
                                                                                  }
                                                                                  bordered={
                                                                                    false
                                                                                  }
                                                                                  min={
                                                                                    0
                                                                                  }
                                                                                  step={
                                                                                    0.01
                                                                                  }
                                                                                  precision={
                                                                                    2
                                                                                  }
                                                                                  controls={
                                                                                    false
                                                                                  }
                                                                                  style={{
                                                                                    width:
                                                                                      "100%",
                                                                                    backgroundColor:
                                                                                      subFields.length ==
                                                                                      index2 +
                                                                                        1
                                                                                        ? `${themeData.themeData?.themeColor}40`
                                                                                        : "white",
                                                                                  }}
                                                                                  placeholder="Amount"
                                                                                  onChange={(
                                                                                    e
                                                                                  ) => {
                                                                                    calculateUnallotted(
                                                                                      index
                                                                                    );
                                                                                  }}
                                                                                  onKeyPress={
                                                                                    handleDecimalValues
                                                                                  }
                                                                                  onFocus={(
                                                                                    e
                                                                                  ) => {
                                                                                    handleInputFocus(
                                                                                      e,
                                                                                      form
                                                                                    );
                                                                                  }}
                                                                                />
                                                                              </Form.Item>
                                                                            </td>
                                                                            <td
                                                                              style={{
                                                                                width:
                                                                                  "5%",
                                                                                padding:
                                                                                  "0px 10px",
                                                                              }}
                                                                            >
                                                                              {subFields.length !==
                                                                              index2 +
                                                                                1 ? (
                                                                                <CloseOutlined
                                                                                  style={{
                                                                                    color:
                                                                                      "red",
                                                                                  }}
                                                                                  onClick={() => {
                                                                                    setSelectedCostCentres(
                                                                                      (
                                                                                        prev: any[]
                                                                                      ) => {
                                                                                        const allPrevCostCenters =
                                                                                          [
                                                                                            ...prev,
                                                                                          ];
                                                                                        allPrevCostCenters[
                                                                                          index
                                                                                        ]?.splice(
                                                                                          index2,
                                                                                          1
                                                                                        );
                                                                                        return allPrevCostCenters;
                                                                                      }
                                                                                    );

                                                                                    if (
                                                                                      subFields.length !==
                                                                                      1
                                                                                    ) {
                                                                                      remove(
                                                                                        subField.name
                                                                                      );
                                                                                      calculateUnallotted(
                                                                                        index
                                                                                      );
                                                                                    }
                                                                                  }}
                                                                                />
                                                                              ) : (
                                                                                <div
                                                                                  style={{
                                                                                    padding: 7,
                                                                                  }}
                                                                                ></div>
                                                                              )}
                                                                            </td>
                                                                          </tr>
                                                                        </>
                                                                      );
                                                                    }
                                                                  )}
                                                                </div>
                                                              );
                                                            }}
                                                          </Form.List>
                                                        </Form.Item>
                                                      </tbody>
                                                    </table>

                                                    {UnallottedAmounts[index]
                                                      ?.unallottedAmount !=
                                                      null &&
                                                      form.getFieldValue([
                                                        "freightInsLedgers",
                                                        index,
                                                        "costCentres",
                                                      ])?.length > 1 && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            flexDirection:
                                                              "row",
                                                            padding: "0px 7px",
                                                            color:
                                                              UnallottedAmounts[
                                                                index
                                                              ]
                                                                ?.unallottedAmount ==
                                                              0
                                                                ? "green"
                                                                : " #ED2939",

                                                            fontSize: "14px",
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              float: "right",
                                                              justifyContent:
                                                                "end",
                                                              width: "69%",
                                                            }}
                                                          >
                                                            <span>
                                                              {UnallottedAmounts[
                                                                index
                                                              ]
                                                                ?.unallottedAmount <
                                                              0
                                                                ? "Allotted amount cannot be greater than the gross amount: "
                                                                : "Unallotted amount: "}
                                                            </span>
                                                          </div>
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "start",
                                                              width: "28%",
                                                              marginLeft: "5px",
                                                            }}
                                                          >
                                                            <span>
                                                              {Utils.getFormattedNumber(
                                                                UnallottedAmounts[
                                                                  index
                                                                ]
                                                                  ?.unallottedAmount
                                                              )}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      )}
                                                  </td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                </tr>
                                              )}
                                          </>
                                        );
                                      }
                                    )}
                                  </>
                                );
                              }}
                            </Form.List>

                            <tr>
                              <td
                                colSpan={2}
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "end",
                                }}
                              >
                                Sub Total
                              </td>

                              {/* {selectedInput.includes("unit") && <td></td>} */}
                              <td
                                className="textEnd pe-14"
                                style={{ fontWeight: "bold" }}
                              >
                                {" "}
                                {Utils.getFormattedNumber(
                                  footerLedger.ledgerAmount
                                )}
                              </td>

                              {splitPathInVchType === Voucher_Type.Expenses ? (
                                <>
                                  <td></td>
                                  <td></td>
                                </>
                              ) : (
                                <>
                                  <td></td>
                                </>
                              )}
                              {splitPathInVchType !== Voucher_Type.Income ||
                              currentClient?.gstType ===
                                CompanyGSTTypes.Regular ||
                              updateTimeData.isGSTVoucher ? (
                                <>
                                  <td
                                    className="textEnd pe-14"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {" "}
                                    {Utils.getFormattedNumber(
                                      footerLedger.ledgerGstAmount
                                    )}
                                  </td>
                                  <td
                                    className="textEnd pe-14"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {" "}
                                    {Utils.getFormattedNumber(
                                      footerLedger.ledgerTotalAmount
                                    )}
                                  </td>
                                  <td></td>
                                </>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>

                    {(footerLedger.ledgerAmount > 0 ||
                      updateId ||
                      cloneId ||
                      draftId) && (
                      <Row gutter={20}>
                        {/*----- Bank Account Details ----- */}

                        {(isCashVoucher ||
                          settingControl?.showReceipt ||
                          editInvBankDetails?.length > 0) && (
                          <Col
                            xl={10}
                            lg={16}
                            md={24}
                            xs={24}
                            className="pt-10"
                          >
                            <div
                              style={{
                                overflowY: "scroll",
                                maxHeight: "200px",
                              }}
                            >
                              <table className="AddPageTabelDesign">
                                <Form.List name="bankDts">
                                  {(fields, { add, remove }) => {
                                    return (
                                      <>
                                        {bankConfirmation && (
                                          <ConfirmationModal
                                            open={true}
                                            text="Do you really want to delete this Row ?"
                                            onNo={() =>
                                              setBankConfirmation(false)
                                            }
                                            onYes={() => {
                                              remove(deleteBankAccountRow);
                                              setBankAccountAmt(
                                                form
                                                  .getFieldValue("bankDts")
                                                  .reduce(
                                                    (acc: number, x: any) =>
                                                      acc + x?.amount,
                                                    0
                                                  )
                                              );
                                              setBankConfirmation(false);
                                            }}
                                          />
                                        )}
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                textAlign: "start",
                                                paddingLeft: "8px",
                                                width: "33%",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Select Account
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "start",
                                                paddingLeft: "8px",
                                                width: "20%",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Balance
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "start",
                                                paddingLeft: "8px",
                                                width: "20%",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Reference
                                            </th>
                                            <th
                                              style={{
                                                textAlign: "end",
                                                paddingRight: "8px",
                                                width: "20%",
                                                fontWeight: "500",
                                              }}
                                            >
                                              Amount
                                            </th>

                                            <th style={{ width: "7%" }}>
                                              {/* <Form.Item className="m-0">
                                                <PlusOutlined
                                                  onClick={() => add()}
                                                />
                                              </Form.Item> */}
                                            </th>
                                          </tr>
                                        </thead>
                                        {/*  Bank Table - Select Account  */}
                                        <tbody>
                                          <tr>
                                            <td>
                                              <Input
                                                disabled
                                                placeholder="Unallotted amount"
                                                bordered={false}
                                                // variant="filled"
                                                style={{
                                                  backgroundColor: "#F0F8FF",
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <Input
                                                disabled
                                                bordered={false}
                                                // variant="filled"
                                                // style={{
                                                //   backgroundColor: "#FFFFFF",
                                                // }}
                                              />
                                            </td>
                                            <td>
                                              <Input
                                                disabled
                                                bordered={false}
                                                // variant="filled"
                                                style={
                                                  {
                                                    // backgroundColor: "#FFFFFF",
                                                  }
                                                }
                                              />
                                            </td>
                                            <td>
                                              <Input
                                                bordered={false}
                                                // variant="filled"
                                                style={{
                                                  textAlign: "end",
                                                  width: "100%",
                                                  backgroundColor: "#F0F8FF",
                                                  // backgroundColor: "#FFFFFFF",
                                                }}
                                                min={0}
                                                disabled
                                                value={
                                                  voucherNature ===
                                                  Voucher_Nature.RCM
                                                    ? Utils.getFormattedNumber(
                                                        footerLedger.ledgerAmount +
                                                          roundOffAmount -
                                                          Math.round(
                                                            cashDiscountRs * 100
                                                          ) /
                                                            100 -
                                                          bankAccountAmt -
                                                          totalTcs -
                                                          totalTds
                                                      )
                                                    : Utils.getFormattedNumber(
                                                        Utils.getNumber(
                                                          footerLedger.ledgerTotalAmount
                                                        ) +
                                                          roundOffAmount -
                                                          Math.round(
                                                            cashDiscountRs * 100
                                                          ) /
                                                            100 -
                                                          bankAccountAmt +
                                                          totalTcs -
                                                          totalTds
                                                        // -
                                                        // (voucherNature ===
                                                        // Voucher_Nature.RCM
                                                        //   ? footerTotal.gst +
                                                        //     footerLedger.ledgerGstAmount
                                                        //   : 10)
                                                      )
                                                }
                                              />
                                            </td>
                                            <td></td>
                                          </tr>
                                          {fields?.map(
                                            (
                                              { key, name, ...restField },
                                              index
                                            ) => {
                                              return (
                                                <tr key={key}>
                                                  {/* Select Account */}
                                                  <td>
                                                    <Form.Item
                                                      name={[name, "name"]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: 24,
                                                      }}
                                                    >
                                                      <Select
                                                        bordered={false}
                                                        loading={
                                                          bankAccountDropDownLoading
                                                        }
                                                        variant="filled"
                                                        className="variantFilledSelect"
                                                        disabled={
                                                          location.state
                                                            ?.ledgerId &&
                                                          index === 0
                                                            ? true
                                                            : false
                                                        }
                                                        labelInValue
                                                        showSearch
                                                        filterOption={(
                                                          input,
                                                          option
                                                        ) =>
                                                          (
                                                            option?.label?.toString() ??
                                                            ""
                                                          )
                                                            .toLowerCase()
                                                            .includes(
                                                              input.toLowerCase()
                                                            )
                                                        }
                                                        placeholder="Search for bank"
                                                        optionFilterProp="children"
                                                        popupMatchSelectWidth={
                                                          false
                                                        }
                                                        style={{
                                                          width: "100%",
                                                          minWidth: "100%",
                                                          maxWidth: "140px",
                                                          backgroundColor:
                                                            "#FFFFFF",
                                                        }}
                                                        options={bankAccountList
                                                          ?.filter(
                                                            (
                                                              option: ILedgerSearchByGroupNameResponse
                                                            ) =>
                                                              !selectedBankLedger.includes(
                                                                option.id
                                                              )
                                                          )
                                                          ?.map(
                                                            (
                                                              value: ILedgerSearchByGroupNameResponse,
                                                              index: number
                                                            ) => ({
                                                              key: index,
                                                              value: value?.id,
                                                              label:
                                                                value?.ledgerName.concat(
                                                                  value?.aliasName
                                                                    ? `${
                                                                        " (" +
                                                                        value?.aliasName +
                                                                        ")"
                                                                      }`
                                                                    : ""
                                                                ),
                                                              title:
                                                                value?.partyOrTax?.toString(),
                                                            })
                                                          )}
                                                        onChange={(e: any) => {
                                                          if (
                                                            fields.length ===
                                                              index + 1 &&
                                                            fields.length < 2
                                                          )
                                                            add();

                                                          let findBalance =
                                                            bankAccountList?.find(
                                                              (x: any) =>
                                                                x.id === e.value
                                                            );
                                                          // console.log(
                                                          //   "Data",
                                                          //   // findBalance,
                                                          //   findBalance?.balance
                                                          // );

                                                          if (updateId) {
                                                            const editBankAccountFind =
                                                              editInvBankDetails.find(
                                                                (x) =>
                                                                  x.name
                                                                    ?.value ===
                                                                  e.value
                                                              );
                                                            console.log(
                                                              "editBankAccountFind",
                                                              editBankAccountFind,
                                                              editBankAccountFind?.amount ??
                                                                0,
                                                              typeof editBankAccountFind?.amount
                                                            );

                                                            if (
                                                              editBankAccountFind
                                                            ) {
                                                              // form.setFieldValue(["freightInsLedgers", index], {/
                                                              form.setFieldValue(
                                                                [
                                                                  "bankDts",
                                                                  index,
                                                                ],
                                                                {
                                                                  ...editBankAccountFind,
                                                                  name: {
                                                                    label:
                                                                      editBankAccountFind
                                                                        .name
                                                                        ?.label,
                                                                    value:
                                                                      editBankAccountFind
                                                                        .name
                                                                        .value,
                                                                    title:
                                                                      editBankAccountFind
                                                                        .name
                                                                        ?.title,
                                                                  },
                                                                }
                                                              );

                                                              setBankAccountAmt(
                                                                bankAccountAmt +
                                                                  editBankAccountFind?.amount
                                                              );
                                                            }
                                                            setSelectedBankBalance(
                                                              (x: any) => {
                                                                const updatedSelectedOptions =
                                                                  [...x];
                                                                updatedSelectedOptions[
                                                                  index
                                                                ] =
                                                                  (findBalance?.balance ??
                                                                    0) +
                                                                  (editBankAccountFind?.amount ??
                                                                    0);
                                                                return updatedSelectedOptions;
                                                              }
                                                            );
                                                          } else {
                                                            setSelectedBankBalance(
                                                              (x: any) => {
                                                                const updatedSelectedOptions =
                                                                  [...x];
                                                                updatedSelectedOptions[
                                                                  index
                                                                ] =
                                                                  findBalance?.balance;
                                                                return updatedSelectedOptions;
                                                              }
                                                            );
                                                          }

                                                          setSelectedBankLedger(
                                                            (prevState) => {
                                                              const updatedSelectedOptions =
                                                                [...prevState];
                                                              updatedSelectedOptions[
                                                                index
                                                              ] = e.value;
                                                              return updatedSelectedOptions;
                                                            }
                                                          );

                                                          setSelectedBankPartyOrTax(
                                                            (prevState) => {
                                                              const updatedSelectedOptions =
                                                                [...prevState];
                                                              updatedSelectedOptions[
                                                                index
                                                              ] = e.title;
                                                              return updatedSelectedOptions;
                                                            }
                                                          );
                                                        }}
                                                        dropdownRender={(
                                                          bankAccountList
                                                        ) => (
                                                          <>
                                                            {bankAccountList}
                                                            {(permissionCashAdd ||
                                                              permissionBankAdd) && (
                                                              <>
                                                                <Divider
                                                                  style={{
                                                                    margin:
                                                                      "5px 0px",
                                                                  }}
                                                                />
                                                                <Button
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                  }}
                                                                  icon={
                                                                    <PlusOutlined />
                                                                  }
                                                                  type="link"
                                                                  onClick={() => {
                                                                    setApiCallField(
                                                                      "Add Bank"
                                                                    );
                                                                    setNewBankAccountAddedIndex(
                                                                      index
                                                                    );
                                                                    setOpenModel(
                                                                      {
                                                                        type: "addBankAccount",
                                                                        param: {
                                                                          open: true,
                                                                          defaultGroup:
                                                                            {
                                                                              id: "6603af4b99242bad67d446c5",
                                                                              ledgerName:
                                                                                "Bank Account",
                                                                              parent:
                                                                                "65af9ce61a48db26effbb598",
                                                                            },
                                                                        },
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  New Bank
                                                                </Button>
                                                              </>
                                                            )}
                                                          </>
                                                        )}
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  {/* Balance */}
                                                  <td>
                                                    <Form.Item
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: 25,
                                                      }}
                                                    >
                                                      <InputNumber
                                                        bordered={false}
                                                        // variant="filled"
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                        }}
                                                        disabled
                                                        value={
                                                          selectedBankBalance[
                                                            index
                                                          ]
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  {/* Reference */}
                                                  <td>
                                                    <Form.Item
                                                      name={[
                                                        name,
                                                        "payRecReference",
                                                      ]}
                                                      className="m-0"
                                                      {...restField}
                                                      wrapperCol={{
                                                        span: 24,
                                                      }}
                                                    >
                                                      <Input
                                                        bordered={false}
                                                        variant="filled"
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                        disabled={
                                                          (location.state
                                                            ?.ledgerId &&
                                                            index === 0) ||
                                                          !selectedBankLedger[
                                                            index
                                                          ]
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </td>

                                                  {/* Amount */}
                                                  <td>
                                                    <Form.Item
                                                      name={[name, "amount"]}
                                                      className="m-0"
                                                      {...restField}
                                                      initialValue={0.0}
                                                      wrapperCol={{
                                                        span: 24,
                                                      }}
                                                    >
                                                      <InputNumber
                                                        bordered={false}
                                                        variant="filled"
                                                        step={0.01}
                                                        min={0}
                                                        precision={2}
                                                        disabled={
                                                          (location.state
                                                            ?.ledgerId &&
                                                            index === 0) ||
                                                          !selectedBankLedger[
                                                            index
                                                          ]
                                                        }
                                                        onFocus={(e) => {
                                                          handleInputFocus(
                                                            e,
                                                            form
                                                          );
                                                        }}
                                                        onKeyPress={
                                                          handleDecimalValues
                                                        }
                                                        onBlur={(x) => {
                                                          if (
                                                            splitPathInVchType ===
                                                              Voucher_Type.Expenses &&
                                                            selectedBankPartyOrTax[
                                                              index
                                                            ] ===
                                                              Party_Tax.BanknCash
                                                          ) {
                                                            if (
                                                              Utils.getNumber(
                                                                x.target.value
                                                              ) >
                                                              selectedBankBalance[
                                                                index
                                                              ]
                                                            ) {
                                                              form.setFieldValue(
                                                                [
                                                                  "bankDts",
                                                                  index,
                                                                  "amount",
                                                                ],
                                                                selectedBankBalance[
                                                                  index
                                                                ]
                                                              );
                                                              setBankAccountAmt(
                                                                form
                                                                  .getFieldValue(
                                                                    "bankDts"
                                                                  )
                                                                  .reduce(
                                                                    (
                                                                      acc: number,
                                                                      x: any
                                                                    ) =>
                                                                      acc +
                                                                      x?.amount,
                                                                    0
                                                                  )
                                                              );
                                                            } else {
                                                              setBankAccountAmt(
                                                                form
                                                                  .getFieldValue(
                                                                    "bankDts"
                                                                  )
                                                                  .reduce(
                                                                    (
                                                                      acc: number,
                                                                      x: any
                                                                    ) =>
                                                                      acc +
                                                                      x?.amount,
                                                                    0
                                                                  )
                                                              );
                                                            }
                                                          }

                                                          if (
                                                            Utils.getNumber(
                                                              voucherNature ===
                                                                Voucher_Nature.RCM
                                                                ? footerLedger.ledgerAmount +
                                                                    totalTcs +
                                                                    roundOffAmount -
                                                                    Math.round(
                                                                      cashDiscountRs *
                                                                        100
                                                                    ) /
                                                                      100
                                                                : Utils.getNumber(
                                                                    footerLedger.ledgerTotalAmount
                                                                  ) +
                                                                    totalTcs +
                                                                    roundOffAmount -
                                                                    Math.round(
                                                                      cashDiscountRs *
                                                                        100
                                                                    ) /
                                                                      100
                                                            ) -
                                                              form
                                                                .getFieldValue(
                                                                  "bankDts"
                                                                )
                                                                .reduce(
                                                                  (
                                                                    acc: number,
                                                                    x: any
                                                                  ) =>
                                                                    acc +
                                                                    x?.amount,
                                                                  0
                                                                ) <
                                                            0
                                                          ) {
                                                            form.setFieldValue(
                                                              [
                                                                "bankDts",
                                                                index,
                                                                "amount",
                                                              ],
                                                              0.0
                                                            );
                                                            setBankAccountAmt(
                                                              form
                                                                .getFieldValue(
                                                                  "bankDts"
                                                                )
                                                                .reduce(
                                                                  (
                                                                    acc: number,
                                                                    x: any
                                                                  ) =>
                                                                    acc +
                                                                    x?.amount,
                                                                  0
                                                                )
                                                            );
                                                          } else
                                                            setBankAccountAmt(
                                                              form
                                                                .getFieldValue(
                                                                  "bankDts"
                                                                )
                                                                .reduce(
                                                                  (
                                                                    acc: number,
                                                                    x: any
                                                                  ) =>
                                                                    acc +
                                                                    x?.amount,
                                                                  0
                                                                )
                                                            );

                                                          if (
                                                            Utils.getNumber(
                                                              x.target.value
                                                            ) >
                                                            selectedBankBalance[
                                                              index
                                                            ]
                                                          ) {
                                                            if (
                                                              Utils.getNumber(
                                                                footerLedger.ledgerTotalAmount
                                                              ) -
                                                                form
                                                                  .getFieldValue(
                                                                    "bankDts"
                                                                  )
                                                                  .reduce(
                                                                    (
                                                                      acc: number,
                                                                      x: any
                                                                    ) =>
                                                                      acc +
                                                                      x?.amount,
                                                                    0
                                                                  ) <
                                                              0
                                                            ) {
                                                              setInsufficientBalanceError(
                                                                "Allotted amount is exceeding the voucher total amount."
                                                              );
                                                            } else if (
                                                              selectedBankPartyOrTax[
                                                                index
                                                              ] ===
                                                              Party_Tax.BanknCash
                                                            ) {
                                                              setInsufficientBalanceError(
                                                                splitPathInVchType ===
                                                                  Voucher_Type.Expenses
                                                                  ? "Due to insufficient balance, the transaction cannot be completed."
                                                                  : ""
                                                              );
                                                            }
                                                          } else {
                                                            setInsufficientBalanceError(
                                                              ""
                                                            );
                                                          }
                                                        }}
                                                        className="inputNumberTextEnd"
                                                        controls={false}
                                                        style={{
                                                          width: "100%",
                                                          backgroundColor:
                                                            (location.state
                                                              ?.ledgerId &&
                                                              index === 0) ||
                                                            !selectedBankLedger[
                                                              index
                                                            ]
                                                              ? // fields.length ===
                                                                //   index + 1
                                                                `${themeData.themeData?.themeColor}40`
                                                              : "#ffffff",
                                                        }}
                                                      />
                                                    </Form.Item>
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {selectedBankLedger[
                                                      index
                                                    ] && (
                                                      <img
                                                        className="cursor mx-1"
                                                        onClick={() => {
                                                          const currentAmount =
                                                            form.getFieldValue([
                                                              "bankDts",
                                                              index,
                                                              "amount",
                                                            ]);
                                                          if (
                                                            location.state
                                                              ?.ledgerId &&
                                                            index !== 0
                                                          ) {
                                                            remove(name);
                                                          } else if (
                                                            !location.state
                                                              ?.ledgerId
                                                          ) {
                                                            if (
                                                              fields.length > 1
                                                            ) {
                                                              remove(name);
                                                              if (
                                                                fields.length <
                                                                3
                                                              ) {
                                                                add({});
                                                              }
                                                            } else
                                                              form.setFieldValue(
                                                                [
                                                                  "bankDts",
                                                                  index,
                                                                ],
                                                                { amount: 0 }
                                                              );
                                                          }

                                                          setSelectedBankLedger(
                                                            (prev) => {
                                                              const newDisabledInputs =
                                                                [...prev];
                                                              newDisabledInputs.splice(
                                                                name,
                                                                1
                                                              );
                                                              return newDisabledInputs;
                                                            }
                                                          );

                                                          setSelectedBankPartyOrTax(
                                                            (prev) => {
                                                              const newDisabledInputs =
                                                                [...prev];
                                                              newDisabledInputs.splice(
                                                                name,
                                                                1
                                                              );
                                                              return newDisabledInputs;
                                                            }
                                                          );

                                                          setSelectedBankBalance(
                                                            (x: any) => {
                                                              const allBankAmount =
                                                                [...x];
                                                              allBankAmount.splice(
                                                                name,
                                                                1
                                                              );
                                                              return allBankAmount;
                                                            }
                                                          );

                                                          setBankAccountAmt(
                                                            (prevAmt) =>
                                                              prevAmt -
                                                              currentAmount
                                                          );
                                                          // setDeleteBankAccountRow(name);
                                                          // setBankConfirmation(true);
                                                        }}
                                                        src={deleteImg}
                                                        alt="Delete"
                                                      />
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </>
                                    );
                                  }}
                                </Form.List>
                              </table>
                            </div>
                            <div>
                              <span style={{ color: "red" }}>
                                {insufficientBalanceError}
                              </span>
                            </div>
                            {/* //commented for temporary basis  */}

                            <div>
                              <Form.Item
                                name="attachments"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => {
                                  return e.fileList;
                                }}
                                // className="m-0"
                                style={{ paddingTop: "10px", margin: "0px" }}
                              >
                                <Upload
                                  multiple
                                  maxCount={2}
                                  accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                                  beforeUpload={(file) => {
                                    // const attachments =
                                    //   form.getFieldValue("attachments");
                                    // console.log("preview", attachments);
                                    // const maxCount = 5;
                                    if (file.size > 5242880) {
                                      openNotification(
                                        "error",
                                        `"${file?.name}" size must be smaller than 5MB.`
                                      );
                                      return Upload.LIST_IGNORE;
                                    } else return false;
                                  }}
                                  onRemove={(e: any) => {
                                    if (updateId && e?.id) {
                                      setDeleteUploadId([
                                        ...deleteUploadId,
                                        e?.id,
                                      ]);
                                    }
                                  }}
                                  onPreview={(e: any) => {
                                    console.log("preview", e);
                                    if (updateId && e?.path) {
                                      setPreviewImage({
                                        isBaseConvert: false,
                                        path: e,
                                      });
                                    } else if (
                                      e.type?.split("/")[0] === "image"
                                    ) {
                                      setPreviewImage({
                                        isBaseConvert: true,
                                        path: e,
                                      });
                                    }
                                  }}
                                >
                                  <Button
                                    icon={<UploadOutlined />}
                                    style={{ backgroundColor: "ButtonFace" }}
                                    disabled={
                                      form.getFieldValue("attachments")
                                        ?.length > 5
                                        ? true
                                        : false
                                    }
                                  >
                                    Upload
                                  </Button>
                                </Upload>
                              </Form.Item>
                            </div>
                          </Col>
                        )}

                        <Col
                          style={{ marginTop: "9px" }}
                          xl={6}
                          lg={8}
                          md={24}
                          xs={24}
                          className="pt-10"
                        >
                          <Form.Item
                            name="narration"
                            className="m-0"
                            wrapperCol={{ span: 24 }}
                          >
                            <TextArea
                              placeholder="Write narration"
                              autoSize={{ minRows: 2, maxRows: 4 }}
                            />
                          </Form.Item>

                          {updateId
                            ? !isCashVoucher &&
                              !settingControl?.showReceipt &&
                              editInvBankDetails?.length < 0
                            : !isCashVoucher &&
                              (!settingControl?.showReceipt ||
                                editInvBankDetails?.length < 0) && (
                                <>
                                  {/* //commented for temporary basis  */}

                                  <Form.Item
                                    name="attachments"
                                    valuePropName="fileList"
                                    getValueFromEvent={(e) => {
                                      return e.fileList;
                                    }}
                                    // className="m-0"
                                    style={{
                                      paddingTop: "10px",
                                      margin: "0px",
                                    }}
                                  >
                                    <Upload
                                      multiple
                                      // accept={".png, .jpg, .jpeg, .pdf"}
                                      // accept={".png, .jpg, .jpeg"}
                                      beforeUpload={() => {
                                        return false;
                                      }}
                                      onRemove={(e: any) => {
                                        if (updateId && e?.id) {
                                          setDeleteUploadId([
                                            ...deleteUploadId,
                                            e?.id,
                                          ]);
                                        }
                                      }}
                                      onPreview={(e: any) => {
                                        console.log("preview", e);
                                        if (updateId && e?.path) {
                                          setPreviewImage({
                                            isBaseConvert: false,
                                            path: e,
                                          });
                                        } else if (
                                          e.type?.split("/")[0] === "image"
                                        ) {
                                          setPreviewImage({
                                            isBaseConvert: true,
                                            path: e,
                                          });
                                        }
                                      }}
                                    >
                                      <Button
                                        icon={<UploadOutlined />}
                                        style={{
                                          backgroundColor: "ButtonFace",
                                        }}
                                      >
                                        Upload
                                      </Button>
                                    </Upload>
                                  </Form.Item>
                                </>
                              )}
                        </Col>

                        {updateId ? (
                          editInvBankDetails?.length < 0 && !isCashVoucher ? (
                            <Col xl={10} xs={0}></Col>
                          ) : editInvBankDetails?.length < 0 &&
                            !settingControl?.showReceipt &&
                            !isCashVoucher ? (
                            <Col xl={10} xs={0}></Col>
                          ) : editInvBankDetails?.length === 0 &&
                            !settingControl?.showReceipt &&
                            !isCashVoucher ? (
                            <Col xl={10} xs={0}></Col>
                          ) : (
                            <></>
                          )
                        ) : (
                          !isCashVoucher &&
                          !settingControl?.showReceipt && (
                            <Col xl={10} xs={0}></Col>
                          )
                        )}

                        <Col
                          xl={8}
                          lg={
                            isCashVoucher ||
                            settingControl?.showReceipt ||
                            editInvBankDetails?.length > 0
                              ? 24
                              : 16
                          }
                          md={24}
                          xs={24}
                          // style={{ paddingRight: 30 }}
                          className="pt-10"
                        >
                          {/* <Col lg={17} md={24}>
                    <div style={{ overflowY: "auto" }}></div>
                  </Col> */}

                          <Row gutter={[0, 8]} style={{ marginTop: "5px" }}>
                            <>
                              <Col lg={9} span={9}>
                                <span>Total</span>
                              </Col>
                              <Col lg={15} span={15} className="textEnd">
                                <span>
                                  ₹{" "}
                                  {Utils.getFormattedNumber(
                                    footerLedger.ledgerAmount
                                  )}
                                </span>
                              </Col>
                            </>

                            {(splitPathInVchType === Voucher_Type.Expenses ||
                              currentClient?.gstType ===
                                CompanyGSTTypes.Regular ||
                              updateTimeData.isGSTVoucher) && (
                              <>
                                {isStateSame ? (
                                  <>
                                    <Col lg={9} span={9}>
                                      <span>CGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          footerLedger.ledgerGstAmount / 2
                                        )}
                                      </span>
                                    </Col>
                                    <Col lg={9} span={9}>
                                      <span>SGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          footerLedger.ledgerGstAmount / 2
                                        )}
                                      </span>
                                    </Col>
                                  </>
                                ) : currentCustomerState ? (
                                  <>
                                    <Col lg={9} span={9}>
                                      <span>IGST</span>
                                    </Col>
                                    <Col lg={15} span={15} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {Utils.getFormattedNumber(
                                          footerLedger.ledgerGstAmount
                                        )}
                                      </span>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {(isStateSame || currentCustomerState) &&
                                  voucherNature === Voucher_Nature.RCM && (
                                    <>
                                      <Col lg={12} span={11}>
                                        <span>Tax Under Reverse Charge</span>
                                      </Col>
                                      <Col
                                        lg={12}
                                        span={13}
                                        className="textEnd"
                                      >
                                        <span>
                                          ₹{" "}
                                          {Utils.getFormattedNumber(
                                            footerLedger.ledgerGstAmount
                                          )}
                                        </span>
                                      </Col>
                                    </>
                                  )}
                              </>
                            )}
                            <Divider
                              className="grayBg"
                              style={{ margin: "0px" }}
                            />
                            <>
                              {/* <Divider className="my-0 grayBg" /> */}
                              <Col lg={9} span={9}>
                                <span>Gross Total</span>
                              </Col>
                              <Col lg={15} span={15} className="textEnd">
                                <span>
                                  ₹{" "}
                                  {Utils.getFormattedNumber(
                                    footerLedger.ledgerAmount +
                                      footerLedger.ledgerGstAmount
                                  )}
                                </span>
                              </Col>
                            </>
                            {(settingControl.discountPolicy ===
                              Discount_Policy.OnlyCashDiscount ||
                              settingControl.discountPolicy ===
                                Discount_Policy.TradenCashDiscount) && (
                              <>
                                <Col lg={6} span={6}>
                                  <span>Cash Discount</span>
                                </Col>

                                <Col lg={4} span={4}>
                                  <Form.Item
                                    // style={{flex:'end'}}
                                    name="cashDiscountDrop"
                                    className="inputBoxMb"
                                    wrapperCol={{ span: 20 }}
                                  >
                                    <Select
                                      size="small"
                                      options={[
                                        {
                                          value:
                                            DiscountType.PercentageDiscount,
                                          label: "%",
                                          title: "",
                                        },
                                        {
                                          value: DiscountType.RupeeDiscount,
                                          label: "₹",
                                          title: "",
                                        },
                                      ]}
                                      onChange={() => hangleCashDisCount()}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col lg={7} span={7}>
                                  <Form.Item
                                    className="discountInput inputBoxMb textEnd"
                                    name="cashDiscount"
                                  >
                                    <InputNumber
                                      step={0.01}
                                      controls={false}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      placeholder="0.0"
                                      min={0.0}
                                      max={
                                        form.getFieldValue(
                                          "cashDiscountDrop"
                                        ) === DiscountType.PercentageDiscount
                                          ? 100
                                          : Utils.getNumber(
                                              footerLedger.ledgerTotalAmount
                                            )
                                      }
                                      precision={2}
                                      onFocus={(e) => {
                                        handleInputFocus(e, form);
                                      }}
                                      onKeyPress={handleDecimalValues}
                                      style={{
                                        width: "100%",
                                        // borderBottom: "1px solid black"
                                        // margin: "0px 30px 0px 10px",
                                      }}
                                      onChange={() => hangleCashDisCount()}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col lg={7} span={7} className="textEnd">
                                  <span>
                                    - ₹{" "}
                                    {Utils.getFormattedNumber(cashDiscountRs)}
                                  </span>
                                </Col>

                                {cashDiscountRs > 0 && (
                                  <>
                                    <Divider
                                      className="grayBg"
                                      style={{ margin: "0px" }}
                                    />
                                    <Col lg={6} span={6}>
                                      <span>Sub Total</span>
                                    </Col>

                                    <Col lg={18} span={18} className="textEnd">
                                      <span>
                                        ₹{" "}
                                        {voucherNature === Voucher_Nature.RCM
                                          ? Utils.getFormattedNumber(
                                              footerLedger.ledgerAmount -
                                                cashDiscountRs
                                            )
                                          : Utils.getFormattedNumber(
                                              footerLedger.ledgerTotalAmount -
                                                cashDiscountRs
                                            )}
                                      </span>
                                    </Col>
                                  </>
                                )}
                              </>
                            )}
                            {/* Update Time Party TCS & TDS Check & Amount, Add time normal condition check  */}
                            {/*                      
                            {/* splitPathInVchType === Voucher_Type.Expenses ?
                    isPartTDSOrTDS.tcs && settingControl.showTcsTds :
                    isPartTDSOrTDS.tds && settingControl.showTcsTds */}

                            {(isPartTDSOrTDS.tds || isPartTDSOrTDS.tcs) && (
                              <>
                                <Col lg={17} span={15}>
                                  <Row>
                                    <Col lg={12} span={12}>
                                      <Radio.Group
                                        // disabled
                                        onChange={(e) => {
                                          setTotalTcs(0);
                                          setTotalTds(0);
                                          form.setFieldValue("tcsDetail", null);
                                          form.setFieldValue("tdsDetail", null);
                                          setTdsOrTcs(e.target.value);
                                          handleAllTheTotalValues(
                                            e.target.value
                                          );
                                        }}
                                        value={tdsOrTcs}
                                      >
                                        {(isPartTDSOrTDS.tds ||
                                          totalTds > 0) && (
                                          <Radio value={0}>TDS</Radio>
                                        )}

                                        {(isPartTDSOrTDS.tcs ||
                                          totalTcs > 0) && (
                                          <Radio value={1}>TCS</Radio>
                                        )}
                                      </Radio.Group>
                                    </Col>
                                    <Col lg={12} span={12}>
                                      {tdsOrTcs === 1 ? (
                                        <Row gutter={5}>
                                          <Col lg={18} span={18}>
                                            <Form.Item
                                              name="tcsDetail"
                                              className="m-0"
                                              wrapperCol={{
                                                span: 24,
                                              }}
                                            >
                                              <Select
                                                labelInValue
                                                placement="bottomRight"
                                                popupMatchSelectWidth={false}
                                                placeholder="Select TCS"
                                                // disabled
                                                allowClear
                                                size="small"
                                                onChange={(e) => {
                                                  if (e) {
                                                    const tcsSelect =
                                                      tcsList?.find(
                                                        (x) =>
                                                          x?.id === e?.value
                                                      );
                                                    // console.log("any", tcsSelect);
                                                    form.setFieldValue(
                                                      "tcsDetail",
                                                      {
                                                        value: e?.value,
                                                        label:
                                                          tcsSelect?.section,
                                                        title: tcsSelect?.rate,
                                                      }
                                                    );
                                                  } else {
                                                    form.setFieldValue(
                                                      "tcsDetail",
                                                      null
                                                    );
                                                  }
                                                  handleAllTheTotalValues();
                                                }}
                                                options={tcsList?.map(
                                                  (value: any) => ({
                                                    value: value?.id,
                                                    label: (
                                                      <div>
                                                        <Col>
                                                          <p
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color: "dimgray",
                                                            }}
                                                          >
                                                            {value?.section}
                                                          </p>
                                                        </Col>

                                                        <div>
                                                          <span>
                                                            {
                                                              value?.natureOfCollection
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ),
                                                    title: value?.rate,
                                                  })
                                                )}
                                                filterOption={(input, option) =>
                                                  (
                                                    option?.label?.toString() ??
                                                    ""
                                                  )
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    )
                                                }
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col
                                            lg={4}
                                            span={4}
                                            style={{ paddingTop: "2.5px" }}
                                          >
                                            {tcsTdsPercentage}%
                                          </Col>
                                        </Row>
                                      ) : tdsOrTcs === 0 ? (
                                        <Row gutter={5}>
                                          <Col lg={18} span={18}>
                                            <Form.Item
                                              name="tdsDetail"
                                              className="m-0"
                                              wrapperCol={{
                                                span: 24,
                                              }}
                                            >
                                              <Select
                                                labelInValue
                                                optionFilterProp="children"
                                                // disabled
                                                placement="bottomRight"
                                                popupMatchSelectWidth={false}
                                                placeholder="Select TDS"
                                                size="small"
                                                allowClear
                                                onChange={(e) => {
                                                  if (e) {
                                                    const tdsSelect =
                                                      tdsList.find(
                                                        (x) =>
                                                          x?.id === e?.value
                                                      );
                                                    // console.log("any", tdsSelect, e);
                                                    form.setFieldValue(
                                                      "tdsDetail",
                                                      {
                                                        value: e?.value,
                                                        label:
                                                          tdsSelect?.section,
                                                        title:
                                                          tdsSelect?.rateDetail,
                                                      }
                                                    );
                                                    setTdsPostDetail({
                                                      id: e?.value,
                                                      formNo: tdsSelect?.form,
                                                      transactionType:
                                                        tdsSelect?.transactionType,
                                                    });
                                                    handleAllTheTotalValues();
                                                  } else {
                                                    form.setFieldValue(
                                                      "tdsDetail",
                                                      null
                                                    );
                                                    setTdsPostDetail({
                                                      id: "",
                                                      formNo: "",
                                                      transactionType:
                                                        Transaction_Type.Domestic,
                                                    });
                                                    setTotalTds(0);
                                                  }
                                                }}
                                                options={tdsList?.map(
                                                  (value: any) => ({
                                                    value: value?.id,
                                                    label: (
                                                      <div>
                                                        <Col>
                                                          <p
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color: "dimgray",
                                                            }}
                                                          >
                                                            {value?.section}
                                                          </p>
                                                        </Col>

                                                        <div>
                                                          <span>
                                                            {
                                                              value?.natureOfPayment
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    ),
                                                    title:
                                                      value?.TransactionType ===
                                                      Transaction_Type.Domestic
                                                        ? value?.domesticSegment
                                                        : value?.internationalSegment,
                                                  })
                                                )}
                                                filterOption={(input, option) =>
                                                  (
                                                    option?.label?.toString() ??
                                                    ""
                                                  )
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    )
                                                }
                                                // dropdownRender={(menu) => (
                                                //   <>
                                                //     <div>
                                                //       {menu}
                                                //       <Divider
                                                //         style={{
                                                //           margin: "5px 0px",
                                                //         }}
                                                //       />
                                                //       <Button
                                                //         style={{
                                                //           width: "100%",
                                                //         }}
                                                //         icon={
                                                //           <PlusOutlined />
                                                //         }
                                                //         type="link"
                                                //         onClick={() => {
                                                //           setEditParty({
                                                //             id: "",
                                                //           });
                                                //           setOpenModel({
                                                //             type: "addTdsRate",
                                                //             param: {
                                                //               open: true,
                                                //             },
                                                //           });
                                                //         }}
                                                //       >
                                                //         Rate
                                                //       </Button>
                                                //     </div>
                                                //   </>
                                                // )}
                                              />
                                            </Form.Item>
                                          </Col>
                                          <Col
                                            lg={4}
                                            span={4}
                                            style={{ paddingTop: "2.5px" }}
                                          >
                                            {tcsTdsPercentage}%
                                          </Col>
                                        </Row>
                                      ) : (
                                        <></>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>

                                {tdsOrTcs === 1 ? (
                                  <Col lg={7} span={9} className="textEnd">
                                    <span>
                                      ₹ {Utils.getFormattedNumber(totalTcs)}
                                    </span>
                                  </Col>
                                ) : tdsOrTcs === 0 ? (
                                  <Col lg={7} span={9} className="textEnd">
                                    {/* <span>
                                      ₹ {Utils.getFormattedNumber(totalTds)}
                                    </span> */}

                                    <InputNumber
                                      disabled={
                                        tdsPostDetail?.id ? false : true
                                      }
                                      step={0.01}
                                      precision={2}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      type="number"
                                      controls={false}
                                      placeholder="0.0"
                                      value={totalTds}
                                      // onFocus={(e) => {
                                      //   handleInputFocus(e, form);
                                      // }}
                                      min={0}
                                      style={{
                                        width: "100%",
                                      }}
                                      onChange={(e: number | null) => {
                                        if (e || e === 0) {
                                          setTotalTds(e);
                                          // const roundOffAmount = handleRoundoff(
                                          //   totalPaymentIn +
                                          //     (splitPathInVchType ===
                                          //     Voucher_Type.Receipt
                                          //       ? e
                                          //       : -e),
                                          //   form.getFieldValue(
                                          //     "roundoffCheckbox"
                                          //   ),
                                          //   settingControl.roundOffType
                                          // );

                                          // form.setFieldValue(
                                          //   "roundOff",
                                          //   roundOffAmount
                                          // );
                                          // setRoundoffAmount(roundOffAmount);
                                        }
                                      }}
                                      // onKeyPress={handleDecimalValues}
                                    />
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                            {(settingControl.autoRoundOff ||
                              updateTimeData.roundOff) && (
                              <>
                                <Col
                                  lg={5}
                                  span={5}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <p>Round off</p>
                                </Col>

                                <Col lg={4} span={4}>
                                  <Form.Item
                                    valuePropName="checked"
                                    name="roundoffCheckbox"
                                    className="inputBoxMb"
                                  >
                                    <Checkbox
                                      onChange={() => {
                                        const roundOffAmount = handleRoundoff(
                                          voucherNature === Voucher_Nature.RCM
                                            ? footerLedger.ledgerAmount -
                                                Math.round(
                                                  cashDiscountRs * 100
                                                ) /
                                                  100
                                            : footerLedger.ledgerTotalAmount -
                                                Math.round(
                                                  cashDiscountRs * 100
                                                ) /
                                                  100,
                                          form.getFieldValue(
                                            "roundoffCheckbox"
                                          ),
                                          settingControl.roundOffType
                                        );

                                        form.setFieldValue(
                                          "roundOff",
                                          roundOffAmount
                                        );
                                        setRoundoffAmount(roundOffAmount);
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col
                                  lg={15}
                                  span={15}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Form.Item
                                    className="discountInput inputBoxMb textEnd"
                                    name="roundOff"
                                    wrapperCol={{ span: "25" }}
                                  >
                                    <InputNumber
                                      step={0.01}
                                      className="inputNumberTextEnd"
                                      size="small"
                                      controls={false}
                                      placeholder="0.0"
                                      precision={2}
                                      style={{
                                        width: "100%",
                                      }}
                                      min={
                                        voucherNature === Voucher_Nature.RCM
                                          ? -(
                                              footerLedger.ledgerAmount -
                                              Math.round(cashDiscountRs * 100) /
                                                100
                                            )
                                          : -(
                                              footerLedger.ledgerTotalAmount -
                                              Math.round(cashDiscountRs * 100) /
                                                100
                                            )
                                      }
                                      max={
                                        voucherNature === Voucher_Nature.RCM
                                          ? footerLedger.ledgerAmount -
                                            Math.round(cashDiscountRs * 100) /
                                              100
                                          : footerLedger.ledgerTotalAmount -
                                            Math.round(cashDiscountRs * 100) /
                                              100
                                      }
                                      onFocus={(e) => {
                                        handleInputFocus(e, form);
                                      }}
                                      onKeyPress={handleDecimalValues}
                                      onChange={(e: any) => {
                                        setRoundoffAmount(e);
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                            {(totalTcs > 0 || totalTds > 0) && (
                              <>
                                <Col lg={6} span={6}>
                                  <span>Sub Total</span>
                                </Col>

                                <Col lg={18} span={18} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {voucherNature === Voucher_Nature.RCM
                                      ? Utils.getFormattedNumber(
                                          footerLedger.ledgerAmount -
                                            cashDiscountRs -
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount
                                        )
                                      : Utils.getFormattedNumber(
                                          footerLedger.ledgerTotalAmount -
                                            cashDiscountRs +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount
                                        )}
                                  </span>
                                  {/* {Utils.getFormattedNumber(cashDiscount)} */}
                                </Col>
                              </>
                            )}
                            {bankAccountAmt > 0 && (
                              <>
                                <Divider
                                  className="grayBg"
                                  style={{ margin: "0px" }}
                                />
                                <Col lg={11} span={11}>
                                  <span>
                                    {splitPathInVchType ===
                                    Voucher_Type.Expenses
                                      ? "Received"
                                      : "Paid"}
                                  </span>
                                </Col>
                                <Col lg={13} span={13} className="textEnd">
                                  <span>
                                    ₹ {Utils.getFormattedNumber(bankAccountAmt)}
                                  </span>
                                  {/* <Form.Item className="m-0" name="receivedAmount1">
                             <InputNumber
                             disabled
                             style={{ width: "100%" }}
                             size="small"
                             controls={false}
                             className="inputNumberTextEnd "
                             // onChange={(e) => onAmountReceived()}
                             /> 
                          </Form.Item> */}
                                </Col>

                                <Col lg={9} span={9}>
                                  <span>Balance</span>
                                </Col>
                                <Col lg={15} span={15} className="textEnd">
                                  <span>
                                    ₹{" "}
                                    {voucherNature === Voucher_Nature.RCM
                                      ? Utils.getFormattedNumber(
                                          Utils.getNumber(
                                            footerLedger.ledgerAmount
                                          ) -
                                            cashDiscountRs +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount -
                                            bankAccountAmt
                                        )
                                      : Utils.getFormattedNumber(
                                          Utils.getNumber(
                                            footerLedger.ledgerTotalAmount
                                          ) -
                                            cashDiscountRs +
                                            totalTcs -
                                            totalTds +
                                            roundOffAmount -
                                            bankAccountAmt
                                        )}
                                  </span>
                                </Col>
                                {/* <Divider className="grayBg" style={{ margin: "0px" }} /> */}
                              </>
                            )}
                          </Row>

                          <Divider className="my-5 grayBg" />

                          <Row gutter={[12, 2]}>
                            <Col
                              lg={11}
                              span={11}
                              style={{ fontWeight: 600, fontSize: "16px" }}
                            >
                              <span>
                                {splitPathInVchType === Voucher_Type.Expenses
                                  ? "Total Expenses Value"
                                  : "Total Income Value"}
                              </span>
                            </Col>

                            <Col
                              lg={13}
                              span={13}
                              className="textEnd"
                              style={{ fontWeight: 600, fontSize: "16px" }}
                            >
                              <span>
                                ₹{" "}
                                {Utils.getFormattedNumber(
                                  voucherNature === Voucher_Nature.RCM
                                    ? footerLedger.ledgerAmount +
                                        totalTcs +
                                        roundOffAmount -
                                        Math.round(cashDiscountRs * 100) / 100
                                    : Utils.getNumber(
                                        footerLedger.ledgerTotalAmount
                                      ) +
                                        totalTcs +
                                        roundOffAmount -
                                        Math.round(cashDiscountRs * 100) / 100
                                )}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </>
              </div>
            </div>
          </Content>
          <Footer
            style={{
              bottom: 0,
              position: "fixed",
              width: "100%",
              background: "#fff",
              marginLeft: "-14px",
              zIndex: 999,
            }}
          >
            <Row style={{ padding: "10px" }}>
              <Col lg={16}></Col>
              <Col lg={8}>
                <Row gutter={10}>
                  <Col>
                    <Tooltip
                      title={<p>ALT+C</p>}
                      placement="topLeft"
                      open={showKeys}
                    >
                      <Button
                        onClick={() => {
                          if (
                            Utils.getNumber(footerLedger.ledgerTotalAmount) +
                              roundOffAmount -
                              Math.round(cashDiscountRs * 100) / 100 >
                              0 &&
                            !updateId &&
                            selectedParty
                          ) {
                            saveDrift();
                          }
                          setIsSaveDraft(false);
                          sessionStorage.removeItem(
                            `${currentClient?.id} Sales`
                          );
                          sessionStorage.removeItem("NotificationState");
                          if (location.state?.ledgerId) {
                            navigate(
                              `/accounts/clients/${currentClient?.id}/banking/bankTransactionsDetails/${location.state?.bankEntriesId}`,
                              {
                                state: {
                                  ledgerId: location.state?.ledgerId,
                                  bankImportIndex: null,
                                  voucherRef: null,
                                },
                              }
                            );
                          } else {
                            navigate(-1);
                          }
                        }}
                      >
                        Cancel
                      </Button>
                    </Tooltip>
                  </Col>
                  <Col>
                    {/* <Form.Item> */}
                    <Tooltip
                      title={<p>ALT+S</p>}
                      placement="topLeft"
                      open={showKeys}
                    >
                      <Button
                        type="primary"
                        loading={updateAndNewButton}
                        onClick={() => {
                          addExpensesIncome(false);
                          setIsSaveDraft(false);
                          setIsSaveAndNew(false);
                        }}
                      >
                        {updateId && !updateAndNew ? "Update" : "Save"}
                      </Button>
                    </Tooltip>
                    {/* </Form.Item> */}
                  </Col>
                  <Col>
                    {updateId && !updateAndNew ? (
                      <Button
                        disabled={location.state?.ledgerId}
                        loading={saveNewLoading}
                        onClick={() => {
                          // setIsSaveDraft(false);
                          addExpensesIncome(true);
                          setIsSaveAndNew(true);
                        }}
                        type="primary"
                      >
                        Update & New
                      </Button>
                    ) : (
                      <Button
                        loading={saveNewLoading}
                        onClick={() => {
                          // setIsSaveDraft(false);
                          addExpensesIncome(true);
                          setIsSaveAndNew(true);
                        }}
                        type="primary"
                      >
                        Save & New
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Footer>
        </Layout>
      </Spin>

      {/* -------------ADD Party ----------*/}

      {/* -------------ADD Items ----------*/}
      {openModel.type === "addItem" && (
        <AddItems
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={itemId}
          setTrigger={setloadItemAPI}
          setNewItem={setNewItem}
        />
      )}
      {/* -------------ADD Bank Account ----------*/}
      {openModel.type === "addBankAccount" && (
        <AddBankAccount
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={openModel.param?.id}
          defaultGroup={openModel?.param?.defaultGroup}
          setNewItem={setAddLedgerResponse}
        />
      )}
      {openModel.type === "addInvoiceReferenceModel" && (
        <AddSalesInvBillAndExpensesReferenceModel
          open={true}
          onCancel={() => {
            setOpenModel({ type: "", param: "" });
            setSaveNewLoading(false);
            setUpdateAndNewButton(false);
          }}
          invoiceId={updateAndNew ? undefined : updateId}
          voucherType={splitPathInVchType}
          currentInvoiceDetails={currentInvoiceDetails}
          newPartyRecepitDetails={newPartyRecepitDetails}
          oldPartyRecepitDetails={
            updateInPartyId === selectedParty ? oldPartyRecepitDetails : []
          }
          newSalesInvoice={saveNewLoading}
          setSaveAndNew={() => setSaveAndNew(true)}
          setUpdateAndNew={() => setUpdateAndNew(true)}
          editInvBankDetails={editInvBankDetails}
          settingControl={{
            showReceipt: settingControl.showReceipt,
            voucherTitle: selectCustomizationTemplete?.title,
            templateId: selectCustomizationTemplete?.templateId,
          }}
          voucherStatus={voucherStatus}
          updateInPartyId={updateInPartyId}
        />
      )}
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={editParty?.id}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={setTrigger}
          type={openModel?.param?.ledgerByGroupsType}
          setAddLedgerResponse={setAddLedgerResponse}
          // setRefresh={setRefresh}
          defaultGroup={openModel?.param?.defaultGroup}
          showName={openModel?.param?.showName}
        />
      )}

      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
              // uploadType: "",
            })
          }
          documentDetails={previewImage}
        />
      )}
      {/* --------- Add TCS Model--------- */}
      {openModel.type === "addTcsRate" && (
        <AddTcsTaxRate
          open={true}
          setOpen={() => setOpenModel({ type: "", param: { open: false } })}
          setTrigger={setTcsListTrigger}
          editData={openModel.param}
        />
      )}
      {/* --------- Add TDS Model--------- */}
      {openModel.type === "addTdsRate" && (
        <AddTdsTaxRate
          open={true}
          setOpen={() => setOpenModel({ type: "", param: "" })}
          setTrigger={setTdsListTrigger}
          editData={openModel.param}
        />
      )}
      {openCostCentreModel.open && (
        <AddCostCentreModel
          isModalOpen={openCostCentreModel.open}
          setIsModalOpen={setOpenCostCentreModel}
          expenseId={costCentreAddedDetails.expenseId}
          setPostCostCentreData={setPostCostCentreResponse}
        />
      )}
    </>
  );
};

export default AddExpensesIncome;
const ShowPriceHistoryDataView = ({ data, themeColor, loading }: any) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 999,
        width: "500px",
        marginTop: "5px",
        background: "white",
        padding: "6px",
        border: `solid ${themeColor} 2px`,
      }}
    >
      <Row>
        <Col>
          <h4>Price history:</h4>
        </Col>
      </Row>
      <Skeleton
        loading={loading}
        paragraph={{ rows: 2, width: "100%" }}
        title={false}
      >
        <Row>
          {data.length > 0 ? (
            <Col span={24}>
              <table
                className="ca-viewmodel-table"
                style={{
                  marginTop: "2px",
                }}
              >
                <thead>
                  <th
                    style={{
                      width: "30%",
                      textAlign: "left",
                    }}
                  >
                    Party Name
                  </th>
                  <th
                    style={{
                      width: "20%",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      width: "20%",
                    }}
                  >
                    Voucher No.
                  </th>
                  <th
                    style={{
                      width: "20%",
                      textAlign: "right",
                    }}
                  >
                    Price
                  </th>
                </thead>
                <tbody>
                  {data?.map((row: any) => (
                    <tr
                      style={{
                        verticalAlign: "top",
                      }}
                    >
                      <td
                        style={{
                          textAlign: "left",
                        }}
                      >
                        {row.partyName}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {dayjs(row.voucherDate).format("DD/MM/YYYY")}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {row.voucherNumber}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {Utils.getFormattedNumber(
                          row.expenses[0]?.expensePrice
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          ) : (
            <Col span={24}>
              <p>No price history data</p>
            </Col>
          )}
        </Row>
      </Skeleton>
    </div>
  );
};
